/* eslint-disable */
// @ts-nocheck
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccountUser = User & {
  __typename?: 'AccountUser';
  age?: Maybe<Scalars['Int']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  currentProfile?: Maybe<ProfileUser>;
  display_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hashedUserId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  mail_address?: Maybe<Scalars['String']['output']>;
  profiles?: Maybe<Array<Maybe<ProfileUser>>>;
  receiveAdvertisingMailType?: Maybe<Scalars['Int']['output']>;
  rights_free_flag?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<Scalars['Int']['output']>;
  test_flg?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AddResumeResult = {
  __typename?: 'AddResumeResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Advert = {
  __typename?: 'Advert';
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  targetBlank?: Maybe<Scalars['Boolean']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AdvertisingPreferencesResult = {
  __typename?: 'AdvertisingPreferencesResult';
  request_id?: Maybe<Scalars['String']['output']>;
};

export type Attributes = {
  __typename?: 'Attributes';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Auth = {
  __typename?: 'Auth';
  error?: Maybe<IdcTokenAuthError>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AccountUser>;
};

export type AuthOwnerProfileResponse = {
  __typename?: 'AuthOwnerProfileResponse';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthResult = {
  __typename?: 'AuthResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  bookmark_meta?: Maybe<Meta>;
  bookmark_meta_id?: Maybe<Scalars['Int']['output']>;
  meta_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type Browser = {
  __typename?: 'Browser';
  major?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Campaign = {
  __typename?: 'Campaign';
  description?: Maybe<Scalars['String']['output']>;
  discountApplyCount?: Maybe<Scalars['Int']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validityEndAt?: Maybe<Scalars['String']['output']>;
  validityStartAt?: Maybe<Scalars['String']['output']>;
};

export type CanvasPageMeta = {
  __typename?: 'CanvasPageMeta';
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  robots?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CanvasStructure = {
  __typename?: 'CanvasStructure';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CanvasStructureConnection = {
  __typename?: 'CanvasStructureConnection';
  data?: Maybe<Array<Maybe<CanvasStructure>>>;
  meta?: Maybe<CanvasPageMeta>;
  pageInfo?: Maybe<PageInfo>;
};

export type ChannelByCourseResult = {
  __typename?: 'ChannelByCourseResult';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  data?: Maybe<Array<Maybe<ChannelMeta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ChannelMeta = Meta & {
  __typename?: 'ChannelMeta';
  contractAllowed?: Maybe<Scalars['Boolean']['output']>;
  contractStatus?: Maybe<Scalars['Boolean']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<Scalars['String']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<ChannelMetaHeroImage>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  live_flag?: Maybe<Scalars['Boolean']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  parents?: Maybe<Array<Maybe<Meta>>>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  tabMenu?: Maybe<Array<Maybe<Link>>>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  video_flag?: Maybe<Scalars['Boolean']['output']>;
};

export type ChannelMetaHeroImage = {
  __typename?: 'ChannelMetaHeroImage';
  mb?: Maybe<Scalars['String']['output']>;
  pc?: Maybe<Scalars['String']['output']>;
};

export type ChatGuidelineAgreement = {
  __typename?: 'ChatGuidelineAgreement';
  agreement?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  id?: Maybe<Scalars['String']['output']>;
  isNGMessage?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Sender>;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  config?: Maybe<ChatRoomConfig>;
  customData?: Maybe<ChatRoomCustomData>;
  roomId?: Maybe<Scalars['String']['output']>;
};

export type ChatRoomConfig = {
  __typename?: 'ChatRoomConfig';
  initialMessageLimit?: Maybe<Scalars['Int']['output']>;
  messageLimit?: Maybe<Scalars['Int']['output']>;
  pollingInterval?: Maybe<Scalars['Int']['output']>;
  userLimit?: Maybe<Scalars['Int']['output']>;
};

export type ChatRoomCustomData = {
  __typename?: 'ChatRoomCustomData';
  appMessageLimit?: Maybe<Scalars['Int']['output']>;
  chatEndDateTime?: Maybe<Scalars['String']['output']>;
  liveEndAfter?: Maybe<Scalars['Int']['output']>;
  liveStartBefore?: Maybe<Scalars['Int']['output']>;
  skipMessageThreshold?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ChatRooms = {
  __typename?: 'ChatRooms';
  rooms?: Maybe<Array<Maybe<ChatRoom>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ChatUser = {
  __typename?: 'ChatUser';
  id?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
};

export type Course = {
  __typename?: 'Course';
  active_pricing?: Maybe<CoursePrice>;
  channel?: Maybe<ChannelMeta>;
  contractAllowed?: Maybe<Scalars['Boolean']['output']>;
  defaultPrice?: Maybe<Scalars['Int']['output']>;
  defaultPriceWithoutTax?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_price?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  priceWithoutTax?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  ref_id?: Maybe<Scalars['String']['output']>;
  rightIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  trialCampaignFlag?: Maybe<Scalars['Boolean']['output']>;
  trialDate?: Maybe<Scalars['String']['output']>;
  trialTerm?: Maybe<Scalars['String']['output']>;
  trialTermText?: Maybe<Scalars['String']['output']>;
  trialText?: Maybe<Scalars['String']['output']>;
  trial_date?: Maybe<Scalars['String']['output']>;
  trial_flag?: Maybe<Scalars['Boolean']['output']>;
  trial_term_unit?: Maybe<Scalars['String']['output']>;
  validity_end_at?: Maybe<Scalars['String']['output']>;
  validity_start_at?: Maybe<Scalars['String']['output']>;
  valuePlan?: Maybe<Scalars['Boolean']['output']>;
};

export type CoursePrice = {
  __typename?: 'CoursePrice';
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  validityEndAt?: Maybe<Scalars['String']['output']>;
  validity_end_at?: Maybe<Scalars['String']['output']>;
  validity_start_at?: Maybe<Scalars['String']['output']>;
};

export type DeleteProfileResponse = {
  __typename?: 'DeleteProfileResponse';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteViewingHistoryResult = {
  __typename?: 'DeleteViewingHistoryResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  browser?: Maybe<Browser>;
  deviceType?: Maybe<Scalars['String']['output']>;
  deviceVendor?: Maybe<Scalars['String']['output']>;
  isAndroid?: Maybe<Scalars['Boolean']['output']>;
  isApp?: Maybe<Scalars['Boolean']['output']>;
  isBot?: Maybe<Scalars['Boolean']['output']>;
  isChrome?: Maybe<Scalars['Boolean']['output']>;
  isChromeOS?: Maybe<Scalars['Boolean']['output']>;
  isDesktop?: Maybe<Scalars['Boolean']['output']>;
  isEdge?: Maybe<Scalars['Boolean']['output']>;
  isFirefox?: Maybe<Scalars['Boolean']['output']>;
  isIE?: Maybe<Scalars['Boolean']['output']>;
  isIOS?: Maybe<Scalars['Boolean']['output']>;
  isIPad?: Maybe<Scalars['Boolean']['output']>;
  isIPhone?: Maybe<Scalars['Boolean']['output']>;
  isMac?: Maybe<Scalars['Boolean']['output']>;
  isMobile?: Maybe<Scalars['Boolean']['output']>;
  isSafari?: Maybe<Scalars['Boolean']['output']>;
  isTablet?: Maybe<Scalars['Boolean']['output']>;
  isWindows?: Maybe<Scalars['Boolean']['output']>;
  os?: Maybe<Os>;
  ua?: Maybe<Scalars['String']['output']>;
};

export type EntitledEpisodesResult = {
  __typename?: 'EntitledEpisodesResult';
  data?: Maybe<Array<Maybe<MediaMeta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type EntitledResult = {
  __typename?: 'EntitledResult';
  data?: Maybe<Array<Maybe<Meta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Entitlement = {
  __typename?: 'Entitlement';
  end_at?: Maybe<Scalars['String']['output']>;
  entitled_by?: Maybe<Scalars['String']['output']>;
  exercisable_end_at?: Maybe<Scalars['String']['output']>;
  exercisable_start_at?: Maybe<Scalars['String']['output']>;
  exercise_duration?: Maybe<Scalars['Int']['output']>;
  exercise_duration_unit?: Maybe<Scalars['Int']['output']>;
  exercised_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  right_id?: Maybe<Scalars['Int']['output']>;
  start_at?: Maybe<Scalars['String']['output']>;
  suspend_flag?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type EpisodeMeta = Meta & {
  __typename?: 'EpisodeMeta';
  area_control_flag?: Maybe<Scalars['Boolean']['output']>;
  cast?: Maybe<Scalars['String']['output']>;
  catch_up_flag?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<ChannelMeta>;
  copyright?: Maybe<Scalars['String']['output']>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  encode_end_date?: Maybe<Scalars['String']['output']>;
  encode_start_date?: Maybe<Scalars['String']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  is_live?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  last_viewing_at?: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  num?: Maybe<Scalars['Int']['output']>;
  parents?: Maybe<Array<Maybe<Meta>>>;
  plalaFlag?: Maybe<Scalars['Boolean']['output']>;
  production_country?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  production_year?: Maybe<Scalars['String']['output']>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  recommend?: Maybe<Scalars['Int']['output']>;
  resume_point?: Maybe<Scalars['Int']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  rtsid?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  source_epg_id?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Scalars['String']['output']>;
  start_over_flag?: Maybe<Scalars['Boolean']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  tvShow?: Maybe<TvShowMeta>;
};

export enum EpisodeType {
  Catchup = 'CATCHUP',
  LiveBefore = 'LIVE_BEFORE',
  LiveOnair = 'LIVE_ONAIR',
  Video = 'VIDEO'
}

export type FavoriteMeta = ChannelMeta | EpisodeMeta | LiveMeta | TvShowMeta;

export type FavoriteResult = {
  __typename?: 'FavoriteResult';
  favorites?: Maybe<UserFavorites>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type FavoritesByContentTypeResult = {
  __typename?: 'FavoritesByContentTypeResult';
  data?: Maybe<Array<Maybe<FavoriteMeta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type FormData = {
  __typename?: 'FormData';
  cancel_url?: Maybe<Scalars['String']['output']>;
  cust_code?: Maybe<Scalars['String']['output']>;
  error_url?: Maybe<Scalars['String']['output']>;
  free1?: Maybe<Scalars['String']['output']>;
  free2?: Maybe<Scalars['String']['output']>;
  free3?: Maybe<Scalars['String']['output']>;
  item_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
  limit_second?: Maybe<Scalars['String']['output']>;
  merchant_id?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  pagecon_url?: Maybe<Scalars['String']['output']>;
  pay_method?: Maybe<Scalars['String']['output']>;
  request_date?: Maybe<Scalars['String']['output']>;
  service_id?: Maybe<Scalars['String']['output']>;
  service_type?: Maybe<Scalars['Int']['output']>;
  sps_hashcode?: Maybe<Scalars['String']['output']>;
  success_url?: Maybe<Scalars['String']['output']>;
  terminal_type?: Maybe<Scalars['Int']['output']>;
};

export type FormQuestionAnswer = {
  __typename?: 'FormQuestionAnswer';
  answer_id?: Maybe<Scalars['Int']['output']>;
};

export type FormQuestions = {
  __typename?: 'FormQuestions';
  help_text?: Maybe<Scalars['String']['output']>;
  key_name?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<OptionsValue>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  schema_group_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unique?: Maybe<Scalars['String']['output']>;
};

export type FormQuestionsResponse = {
  __typename?: 'FormQuestionsResponse';
  data?: Maybe<Array<Maybe<FormQuestions>>>;
  question_id?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GenreAttributesResult = {
  __typename?: 'GenreAttributesResult';
  attributes?: Maybe<Array<Maybe<Attributes>>>;
};

export type GenrePaletteEpisodesResult = {
  __typename?: 'GenrePaletteEpisodesResult';
  data?: Maybe<Array<Maybe<MediaMeta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type HowtoPlay = {
  __typename?: 'HowtoPlay';
  courses?: Maybe<Array<Maybe<Course>>>;
  free?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  member_only?: Maybe<Scalars['Boolean']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  rights?: Maybe<Array<Maybe<Right>>>;
};

export type HtmlSnippet = {
  __typename?: 'HtmlSnippet';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  javascript?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type IdcAccessTokenResponse = {
  __typename?: 'IdcAccessTokenResponse';
  access_token?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  error_description?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type IdcTokenAuthError = {
  __typename?: 'IdcTokenAuthError';
  code?: Maybe<Scalars['String']['output']>;
};

export type IdcTokenVerifyInfo = {
  __typename?: 'IdcTokenVerifyInfo';
  access_token?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  elipsis_flg?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type IdcUserInfo = {
  __typename?: 'IdcUserInfo';
  aud?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  namekana?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
};

export type InformarionConnection = {
  __typename?: 'InformarionConnection';
  data?: Maybe<Array<Maybe<Link>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type KeywordMinScore = {
  __typename?: 'KeywordMinScore';
  keyword?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type Link = {
  __typename?: 'Link';
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startAt?: Maybe<Scalars['String']['output']>;
  targetBlank?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['JSONObject']['output']>;
};

export type LiveMeta = Meta & {
  __typename?: 'LiveMeta';
  area_control_flag?: Maybe<Scalars['Boolean']['output']>;
  cast?: Maybe<Scalars['String']['output']>;
  catch_up_flag?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<ChannelMeta>;
  copyright?: Maybe<Scalars['String']['output']>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  encode_end_date?: Maybe<Scalars['String']['output']>;
  encode_start_date?: Maybe<Scalars['String']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  is_live?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  last_viewing_at?: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  num?: Maybe<Scalars['Int']['output']>;
  parents?: Maybe<Array<Maybe<Meta>>>;
  plalaFlag?: Maybe<Scalars['Boolean']['output']>;
  production_country?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  production_year?: Maybe<Scalars['String']['output']>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  recommend?: Maybe<Scalars['Int']['output']>;
  resume_point?: Maybe<Scalars['Int']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  rtsid?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  source_epg_id?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Scalars['String']['output']>;
  start_over_flag?: Maybe<Scalars['Boolean']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  tvShow?: Maybe<TvShowMeta>;
};

export type Login = {
  __typename?: 'Login';
  error?: Maybe<IdcTokenAuthError>;
  token?: Maybe<Scalars['String']['output']>;
};

export type MappingResponce = {
  __typename?: 'MappingResponce';
  error?: Maybe<IdcTokenAuthError>;
  user?: Maybe<AccountUser>;
};

export type MediaMeta = EpisodeMeta | LiveMeta;

export type MediaSource = {
  __typename?: 'MediaSource';
  error?: Maybe<PlaybackError>;
  media?: Maybe<Scalars['JSONObject']['output']>;
};

export type MessageResult = {
  __typename?: 'MessageResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Meta = {
  copyright?: Maybe<Scalars['String']['output']>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parents?: Maybe<Array<Maybe<Meta>>>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type MetaConnection = {
  __typename?: 'MetaConnection';
  data?: Maybe<Array<Maybe<Meta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MetaTags = {
  __typename?: 'MetaTags';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  robots?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFavorite?: Maybe<FavoriteResult>;
  addPaymentInstrumentSendMail?: Maybe<SendMailResult>;
  addProfile?: Maybe<Profile>;
  addResume?: Maybe<AddResumeResult>;
  advertisingPreferences?: Maybe<AdvertisingPreferencesResult>;
  agree?: Maybe<Array<Maybe<TermRevision>>>;
  authProfile?: Maybe<AuthOwnerProfileResponse>;
  clearRecommendArticle?: Maybe<RecommendArticle>;
  createUser?: Maybe<ChatUser>;
  deleteChatMessage?: Maybe<MessageResult>;
  deleteFavorite?: Maybe<FavoriteResult>;
  deleteProfile?: Maybe<DeleteProfileResponse>;
  deleteViewingHistory?: Maybe<DeleteViewingHistoryResult>;
  formQuestionAnswer?: Maybe<FormQuestionAnswer>;
  idcTokenEndPoint?: Maybe<IdcAccessTokenResponse>;
  idcTokenLogin?: Maybe<Auth>;
  idcTokenMapping?: Maybe<MappingResponce>;
  idcTokenSignup?: Maybe<Auth>;
  login?: Maybe<Auth>;
  logout?: Maybe<AuthResult>;
  passcodeReset?: Maybe<PinCodeResult>;
  passwordReset?: Maybe<PinCodeResult>;
  paymentInstrumentsActivate?: Maybe<PaymentInstrumentsActivate>;
  paymentInstrumentsCreateCreditCardRecaptchaV2?: Maybe<PaymentInstrumentsCreateCreditCardRecaptchaV2Result>;
  paymentInstrumentsCreateCreditCardRecaptchaV3?: Maybe<PaymentInstrumentsCreateCreditCardRecaptchaV3Result>;
  paymentInstrumentsCreateOther?: Maybe<PaymentInstrumentsCreateOther>;
  paymentInstrumentsDeactivate?: Maybe<PaymentInstrumentsDeactivate>;
  paymentInstrumentsSetDefault?: Maybe<PaymentInstrumentsSetDefault>;
  pinActivate?: Maybe<PinActivateResult>;
  playbackSessionCheck?: Maybe<PlaybackSessionCheckResult>;
  playbackSessionClose?: Maybe<PlaybackSessionCloseResult>;
  playbackSessionOpen?: Maybe<MediaSource>;
  postChatMessage?: Maybe<ChatMessage>;
  purchaseExecute?: Maybe<ProductOrder>;
  purchaseTest?: Maybe<ProductOrder>;
  refreshToken?: Maybe<AuthResult>;
  reportChatMessage?: Maybe<MessageResult>;
  selectProfile?: Maybe<AccountUser>;
  sendInquiryMail?: Maybe<Result>;
  sendPasswordResetToken?: Maybe<PinCodeResult>;
  sendProfilePinResetToken?: Maybe<PinCodeResult>;
  setChatGuideLineAgreement?: Maybe<ChatGuidelineAgreement>;
  signup?: Maybe<Auth>;
  subscribe?: Maybe<Subscription>;
  subscriptionCancel?: Maybe<SubscriptionCancel>;
  subscriptionChangePayment?: Maybe<SubscriptionChangePaymentResult>;
  update?: Maybe<UserUpdate>;
  updateOwnerProfile?: Maybe<UserUpdate>;
  updatePassword?: Maybe<UserUpdate>;
  updateProfile?: Maybe<Profile>;
  updateRecommendArticle?: Maybe<RecommendArticle>;
  userDelete?: Maybe<UserDeleteResponse>;
  verifyPasswordToken?: Maybe<VerifyResult>;
  verifyPinCode?: Maybe<VerifyResult>;
};


export type MutationAddFavoriteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAddPaymentInstrumentSendMailArgs = {
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddProfileArgs = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddResumeArgs = {
  groupedMetaId?: InputMaybe<Scalars['Int']['input']>;
  metaId?: InputMaybe<Scalars['Int']['input']>;
  psid?: InputMaybe<Scalars['String']['input']>;
  reachToEnd?: InputMaybe<Scalars['Boolean']['input']>;
  resume?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdvertisingPreferencesArgs = {
  receiveAdvertisingMailFlag?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAgreeArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAuthProfileArgs = {
  passcode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateUserArgs = {
  metaId?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteChatMessageArgs = {
  messageId?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteFavoriteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProfileArgs = {
  profileId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteViewingHistoryArgs = {
  metaIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationFormQuestionAnswerArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  values?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIdcTokenEndPointArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIdcTokenLoginArgs = {
  signature: Scalars['String']['input'];
};


export type MutationIdcTokenMappingArgs = {
  signature: Scalars['String']['input'];
};


export type MutationIdcTokenSignupArgs = {
  password: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  terms: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  loginid: Scalars['String']['input'];
  password: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPasscodeResetArgs = {
  passcode: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationPasswordResetArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationPaymentInstrumentsActivateArgs = {
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPaymentInstrumentsCreateCreditCardRecaptchaV2Args = {
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  tds_info_token?: InputMaybe<Scalars['String']['input']>;
  tds_info_token_key?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
  token_key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPaymentInstrumentsCreateCreditCardRecaptchaV3Args = {
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  recaptchaTokenV3?: InputMaybe<Scalars['String']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  tds_info_token?: InputMaybe<Scalars['String']['input']>;
  tds_info_token_key?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
  token_key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPaymentInstrumentsCreateOtherArgs = {
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationPaymentInstrumentsDeactivateArgs = {
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPaymentInstrumentsSetDefaultArgs = {
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPinActivateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPlaybackSessionCheckArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPlaybackSessionCloseArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPlaybackSessionOpenArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPostChatMessageArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPurchaseExecuteArgs = {
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPurchaseTestArgs = {
  mode?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  userVoucherId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReportChatMessageArgs = {
  messageId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectProfileArgs = {
  passcode?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendInquiryMailArgs = {
  body: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
  membersId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pastSpooxId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationSendPasswordResetTokenArgs = {
  mailAddress: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  birthday: Scalars['String']['input'];
  code: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  sex: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  terms: Scalars['String']['input'];
};


export type MutationSubscribeArgs = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  valuePlanTerm?: InputMaybe<Scalars['String']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscriptionCancelArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSubscriptionChangePaymentArgs = {
  paymentInstrumentId: Scalars['Int']['input'];
  subscriptionId: Scalars['Int']['input'];
};


export type MutationUpdateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  mailAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOwnerProfileArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdatePasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProfileArgs = {
  birthday?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRecommendArticleArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type: Scalars['String']['input'];
};


export type MutationVerifyPasswordTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyPinCodeArgs = {
  code: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
};

export type Os = {
  __typename?: 'OS';
  major?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type OptionsValue = {
  __typename?: 'OptionsValue';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  order_id?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  payment_method_id?: Maybe<Scalars['Int']['output']>;
};

export type OrderData = {
  __typename?: 'OrderData';
  created_at?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_type?: Maybe<Scalars['String']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  payment_instrument?: Maybe<PaymentInstrumentType>;
  values?: Maybe<OrderValue>;
};

export type OrderType = {
  __typename?: 'OrderType';
  finished_at?: Maybe<Scalars['String']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  payment_instrument?: Maybe<PaymentInstrumentType>;
};

export type OrdersResult = {
  __typename?: 'OrdersResult';
  data?: Maybe<Array<Maybe<OrderData>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Palette = {
  __typename?: 'Palette';
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id_key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  palette_id: Scalars['ID']['output'];
  schema?: Maybe<Scalars['String']['output']>;
  schema_id?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Scalars['JSONObject']['output']>;
};

export type PaletteObject = {
  __typename?: 'PaletteObject';
  advertising?: Maybe<Advert>;
  id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Meta>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaletteObjectConnection = {
  __typename?: 'PaletteObjectConnection';
  data?: Maybe<Array<Maybe<PaletteObject>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  values?: Maybe<PaymentInstrumentValues>;
};

export type PaymentInstrumentValues = {
  __typename?: 'PaymentInstrumentValues';
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstruments = {
  __typename?: 'PaymentInstruments';
  default_flag?: Maybe<Scalars['Boolean']['output']>;
  payment_instrument_id?: Maybe<Scalars['Int']['output']>;
  payment_method?: Maybe<PaymentMethod>;
  payment_method_id?: Maybe<Scalars['Int']['output']>;
  ref_id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<PurchaseMethodsValues>;
};

export type PaymentInstrumentsActivate = {
  __typename?: 'PaymentInstrumentsActivate';
  error?: Maybe<PaymentInstrumentsActivateError>;
  payment_instrument_id?: Maybe<Scalars['Int']['output']>;
};

export type PaymentInstrumentsActivateError = {
  __typename?: 'PaymentInstrumentsActivateError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentsCreateCreditCardRecaptchaV2Result = {
  __typename?: 'PaymentInstrumentsCreateCreditCardRecaptchaV2Result';
  charset?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  form_data?: Maybe<FormData>;
  http_method?: Maybe<Scalars['String']['output']>;
  recaptchaSuccessV2?: Maybe<Scalars['Boolean']['output']>;
  redirect_link?: Maybe<Scalars['Boolean']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentsCreateCreditCardRecaptchaV3Result = {
  __typename?: 'PaymentInstrumentsCreateCreditCardRecaptchaV3Result';
  charset?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  form_data?: Maybe<FormData>;
  http_method?: Maybe<Scalars['String']['output']>;
  recaptchaSuccessV3?: Maybe<Scalars['Boolean']['output']>;
  redirect_link?: Maybe<Scalars['Boolean']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentsCreateOther = {
  __typename?: 'PaymentInstrumentsCreateOther';
  charset?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  form_data?: Maybe<FormData>;
  http_method?: Maybe<Scalars['String']['output']>;
  redirect_link?: Maybe<Scalars['Boolean']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentsDeactivate = {
  __typename?: 'PaymentInstrumentsDeactivate';
  error?: Maybe<PaymentInstrumentsDeactivateError>;
  payment_instrument_id?: Maybe<Scalars['Int']['output']>;
};

export type PaymentInstrumentsDeactivateError = {
  __typename?: 'PaymentInstrumentsDeactivateError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentsSetDefault = {
  __typename?: 'PaymentInstrumentsSetDefault';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  name?: Maybe<Scalars['String']['output']>;
  payment_method_id?: Maybe<Scalars['Int']['output']>;
  payment_method_type_name?: Maybe<Scalars['String']['output']>;
};

export type PinActivateResult = {
  __typename?: 'PinActivateResult';
  deviceToken?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PinCodeResult = {
  __typename?: 'PinCodeResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Playback = {
  __typename?: 'Playback';
  entitlements?: Maybe<Array<Maybe<Entitlement>>>;
  error?: Maybe<PlaybackError>;
  log_params?: Maybe<Scalars['JSONObject']['output']>;
  media?: Maybe<PlaybackMedia>;
  mediaSource?: Maybe<Scalars['JSONObject']['output']>;
  playback_session_id?: Maybe<Scalars['String']['output']>;
  resumePoint?: Maybe<Scalars['Int']['output']>;
  rule?: Maybe<PlaybackRule>;
};

export type PlaybackError = {
  __typename?: 'PlaybackError';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PlaybackMedia = {
  __typename?: 'PlaybackMedia';
  media_id: Scalars['ID']['output'];
  ovp_id?: Maybe<Scalars['Int']['output']>;
  ovp_video_id?: Maybe<Scalars['String']['output']>;
  thumbnail_tile_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type PlaybackRule = {
  __typename?: 'PlaybackRule';
  enable_airplay_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_background_play_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_catchup_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_cromecst_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_external_monitor_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_mirroring_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_offline_play_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_pause_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_playback_rate_change_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_screen_capture_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_seek_flag?: Maybe<Scalars['Boolean']['output']>;
  enable_start_over_flag?: Maybe<Scalars['Boolean']['output']>;
  maximum_bitrate?: Maybe<Scalars['Int']['output']>;
  minimum_bitrate?: Maybe<Scalars['Int']['output']>;
  playback_rule_id?: Maybe<Scalars['ID']['output']>;
};

export type PlaybackSessionCheckResult = {
  __typename?: 'PlaybackSessionCheckResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type PlaybackSessionCloseResult = {
  __typename?: 'PlaybackSessionCloseResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<MediaMeta>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  priceWithoutTax?: Maybe<Scalars['Int']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
  purchaseAllowed?: Maybe<Scalars['Boolean']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
  right?: Maybe<Right>;
  rightIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sales_end_at?: Maybe<Scalars['String']['output']>;
  sales_start_at?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  voucherCode?: Maybe<VoucherCode>;
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  created_at?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  product_id?: Maybe<Scalars['Int']['output']>;
  product_order_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProductOrders = {
  __typename?: 'ProductOrders';
  created_at?: Maybe<Scalars['String']['output']>;
  entitlements?: Maybe<Array<Maybe<Entitlement>>>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderType>;
  order_id?: Maybe<Scalars['Int']['output']>;
};

export type ProductOrdersResponse = {
  __typename?: 'ProductOrdersResponse';
  data?: Maybe<Array<Maybe<ProductOrders>>>;
};

export type Profile = {
  __typename?: 'Profile';
  profile?: Maybe<ProfileUser>;
};

export type ProfileUser = User & {
  __typename?: 'ProfileUser';
  age?: Maybe<Scalars['Int']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  needPasscode?: Maybe<Scalars['Boolean']['output']>;
  ownerProfile?: Maybe<Scalars['Boolean']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  sex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type PurchaseEstimate = {
  __typename?: 'PurchaseEstimate';
  error?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

export type PurchaseMethodsValues = {
  __typename?: 'PurchaseMethodsValues';
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  advertising?: Maybe<Result>;
  canvas?: Maybe<CanvasStructureConnection>;
  channelDetail?: Maybe<ChannelMeta>;
  channelEpisodeSearch?: Maybe<MetaConnection>;
  channelFeatureEpisodes?: Maybe<MetaConnection>;
  channelLinearEpisodes?: Maybe<MetaConnection>;
  channelLiveSchedule?: Maybe<MetaConnection>;
  channels?: Maybe<ChannelConnection>;
  channelsWithContractStatus?: Maybe<ChannelConnection>;
  checkTokenTimeout?: Maybe<AuthResult>;
  children?: Maybe<MetaConnection>;
  courseById?: Maybe<Course>;
  courseByMetaId?: Maybe<Course>;
  courseByRightId?: Maybe<Course>;
  deviceInfo?: Maybe<DeviceInfo>;
  entitled?: Maybe<EntitledResult>;
  entitlements?: Maybe<Array<Maybe<Entitlement>>>;
  episode?: Maybe<Meta>;
  favoritesByContentType?: Maybe<FavoritesByContentTypeResult>;
  formQuestions?: Maybe<FormQuestionsResponse>;
  genreAttributes?: Maybe<GenreAttributesResult>;
  genrePaletteEpisodes?: Maybe<GenrePaletteEpisodesResult>;
  getChatGuideLineAgreement?: Maybe<ChatGuidelineAgreement>;
  getEntitledStoreEpisodes?: Maybe<EntitledEpisodesResult>;
  getRoomToken?: Maybe<Token>;
  getRooms?: Maybe<ChatRooms>;
  getUserToken?: Maybe<Token>;
  howtoPlay?: Maybe<HowtoPlay>;
  htmlSnippet?: Maybe<HtmlSnippet>;
  idcTokenVerifyEndPoint?: Maybe<IdcTokenVerifyInfo>;
  idcUserInfoEndPoint?: Maybe<IdcUserInfo>;
  idcUserInfoEndPointAgeValidate?: Maybe<IdcUserInfo>;
  informations?: Maybe<InformarionConnection>;
  loginTerms?: Maybe<Array<Maybe<Term>>>;
  nextEpisode?: Maybe<Meta>;
  orders?: Maybe<OrdersResult>;
  palette?: Maybe<Palette>;
  paletteObjects?: Maybe<PaletteObjectConnection>;
  paymentInstrumentInfo?: Maybe<PaymentInstruments>;
  paymentInstruments?: Maybe<Array<Maybe<PaymentInstruments>>>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethods>>>;
  playbackAuth?: Maybe<Playback>;
  productById?: Maybe<Product>;
  productOrders?: Maybe<ProductOrdersResponse>;
  purchaseEstimate?: Maybe<PurchaseEstimate>;
  ranking?: Maybe<Array<Maybe<Ranking>>>;
  recommendArticle?: Maybe<RecommendArticle>;
  registTerms?: Maybe<Array<Maybe<Term>>>;
  search?: Maybe<MetaConnection>;
  searchConfig?: Maybe<SearchConfig>;
  searchTvShow?: Maybe<MetaConnection>;
  subscriptionCheckCancelable?: Maybe<SubscriptionCheckCancelableResponse>;
  subscriptionEstimate?: Maybe<SubscriptionEstimate>;
  subscriptionOne?: Maybe<Subscription>;
  subscriptionStatus?: Maybe<SubscriptionStatusResponse>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  terms?: Maybe<Array<Maybe<Term>>>;
  title?: Maybe<TvShowMeta>;
  titles?: Maybe<MetaConnection>;
  uid2Token?: Maybe<Uid2Token>;
  unSubscribedStatus?: Maybe<Subscription>;
  user?: Maybe<AccountUser>;
  userEntitlements?: Maybe<Array<Maybe<Entitlement>>>;
  userFavorites?: Maybe<UserFavorites>;
  userIsLogin?: Maybe<AccountUser>;
  viewingHistories?: Maybe<ViewingHistoriesResult>;
  webPage?: Maybe<WebPage>;
};


export type QueryAdvertisingArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCanvasArgs = {
  idKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelEpisodeSearchArgs = {
  episodeType?: InputMaybe<EpisodeType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelFeatureEpisodesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelLinearEpisodesArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelLiveScheduleArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelsArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelsWithContractStatusArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChildrenArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryCourseByIdArgs = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCourseByMetaIdArgs = {
  metaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCourseByRightIdArgs = {
  rightId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEntitledArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEntitlementsArgs = {
  metaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEpisodeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFavoritesByContentTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormQuestionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenreAttributesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryGenrePaletteEpisodesArgs = {
  channel?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntitledStoreEpisodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRoomTokenArgs = {
  roomId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRoomsArgs = {
  metaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserTokenArgs = {
  roomId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHowtoPlayArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHtmlSnippetArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  idKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInformationsArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLoginTermsArgs = {
  cacheMaxAge?: InputMaybe<Scalars['Int']['input']>;
  type: TermType;
};


export type QueryNextEpisodeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaletteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaletteObjectsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentInstrumentInfoArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentInstrumentsArgs = {
  scope?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaybackAuthArgs = {
  fl?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  vuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductByIdArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductOrdersArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
  with_entitlements?: InputMaybe<Scalars['Boolean']['input']>;
  with_order?: InputMaybe<Scalars['Boolean']['input']>;
  with_payment_instrument?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPurchaseEstimateArgs = {
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRankingArgs = {
  channel?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegistTermsArgs = {
  type: TermType;
};


export type QuerySearchArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchTvShowArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionCheckCancelableArgs = {
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionEstimateArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionOneArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionStatusArgs = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTermsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withAgreement?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTitleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTitlesArgs = {
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnSubscribedStatusArgs = {
  courseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViewingHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nocache?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWebPageArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Ranking = {
  __typename?: 'Ranking';
  id?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<MediaMeta>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type RecommendArticle = {
  __typename?: 'RecommendArticle';
  courses?: Maybe<Array<Maybe<Course>>>;
  products?: Maybe<Array<Maybe<Product>>>;
};

export type Result = {
  __typename?: 'Result';
  result?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Right = {
  __typename?: 'Right';
  contractAllowed?: Maybe<Scalars['Boolean']['output']>;
  discount_description?: Maybe<Scalars['String']['output']>;
  discount_price?: Maybe<Scalars['Int']['output']>;
  exercise_term?: Maybe<Scalars['Int']['output']>;
  exercise_term_unit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isSvod?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  package_type?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  push_rank?: Maybe<Scalars['Int']['output']>;
  rights_control_type?: Maybe<Scalars['Int']['output']>;
  validity_end_at?: Maybe<Scalars['String']['output']>;
  validity_start_at?: Maybe<Scalars['String']['output']>;
  view_limit_date?: Maybe<Scalars['String']['output']>;
  view_term?: Maybe<Scalars['Int']['output']>;
  view_term_unit?: Maybe<Scalars['Int']['output']>;
};

export type SearchConfig = {
  __typename?: 'SearchConfig';
  defaultMinScore?: Maybe<Scalars['Int']['output']>;
  keywordMinScore?: Maybe<Array<Maybe<KeywordMinScore>>>;
  livePaletteKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SeasonMeta = Meta & {
  __typename?: 'SeasonMeta';
  cast?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Meta>;
  copyright?: Maybe<Scalars['String']['output']>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  episode_count?: Maybe<Scalars['Int']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  parents?: Maybe<Array<Maybe<Meta>>>;
  production_country?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  production_year?: Maybe<Scalars['String']['output']>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type SendMailResult = {
  __typename?: 'SendMailResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Sender = {
  __typename?: 'Sender';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  course?: Maybe<Course>;
  course_id?: Maybe<Scalars['Int']['output']>;
  entitlements?: Maybe<Array<Maybe<Entitlement>>>;
  error?: Maybe<Scalars['String']['output']>;
  init_order_id?: Maybe<Scalars['Int']['output']>;
  initialTransactionAt?: Maybe<Scalars['String']['output']>;
  nextTransactionAt?: Maybe<Scalars['String']['output']>;
  orderPrice?: Maybe<Scalars['Int']['output']>;
  payment_instrument?: Maybe<PaymentInstrument>;
  payment_instrument_id?: Maybe<Scalars['Int']['output']>;
  payment_method_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['ID']['output']>;
  suspend_flag?: Maybe<Scalars['Boolean']['output']>;
  trialEndAt?: Maybe<Scalars['String']['output']>;
  trialStartAt?: Maybe<Scalars['String']['output']>;
  withdraw_at?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionCancel = {
  __typename?: 'SubscriptionCancel';
  course_id?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  withdraw_at?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionChangePaymentResult = {
  __typename?: 'SubscriptionChangePaymentResult';
  error?: Maybe<Scalars['String']['output']>;
  payment_instrument_id?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionCheckCancelableResponse = {
  __typename?: 'SubscriptionCheckCancelableResponse';
  cancelable?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<SubscriptionCheckCancelableSubscription>;
};

export type SubscriptionCheckCancelableSubscription = {
  __typename?: 'SubscriptionCheckCancelableSubscription';
  withdraw_at?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionEstimate = {
  __typename?: 'SubscriptionEstimate';
  campaignPrice?: Maybe<CoursePrice>;
  coursePricings?: Maybe<Array<Maybe<CoursePrice>>>;
  error?: Maybe<Scalars['String']['output']>;
  paymentPrice?: Maybe<CoursePrice>;
  subscription?: Maybe<Subscription>;
  voucherCode?: Maybe<VoucherCode>;
};

export type SubscriptionStatusResponse = {
  __typename?: 'SubscriptionStatusResponse';
  have_be_contracted?: Maybe<Scalars['Boolean']['output']>;
  is_contractable?: Maybe<Scalars['Boolean']['output']>;
  is_contracted?: Maybe<Scalars['Boolean']['output']>;
  is_trial_enabled?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<Subscription>;
};

export type TvShowMeta = Meta & {
  __typename?: 'TVShowMeta';
  bookmark?: Maybe<Bookmark>;
  cast?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Meta>;
  copyright?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  delivery_end_at?: Maybe<Scalars['String']['output']>;
  delivery_start_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<Scalars['String']['output']>;
  episode_num?: Maybe<Scalars['Int']['output']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllowedRating?: Maybe<Scalars['Boolean']['output']>;
  largeThumbnailUrl?: Maybe<Scalars['String']['output']>;
  mediumThumbnailUrl?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  parents?: Maybe<Array<Maybe<Meta>>>;
  production_country?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  production_year?: Maybe<Scalars['String']['output']>;
  push_rank?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  rights?: Maybe<Array<Maybe<Right>>>;
  rights_control_type?: Maybe<Scalars['String']['output']>;
  rtsid?: Maybe<Scalars['String']['output']>;
  schema_key?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type Term = {
  __typename?: 'Term';
  current_revision?: Maybe<TermRevision>;
  display_name?: Maybe<Scalars['String']['output']>;
  id_key?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  term_id: Scalars['ID']['output'];
};

export type TermAgreement = {
  __typename?: 'TermAgreement';
  agreed_at?: Maybe<Scalars['String']['output']>;
  agreement_id?: Maybe<Scalars['Int']['output']>;
  term_id?: Maybe<Scalars['Int']['output']>;
  term_revision_number?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type TermRevision = {
  __typename?: 'TermRevision';
  agreement?: Maybe<TermAgreement>;
  number?: Maybe<Scalars['Int']['output']>;
  term_id?: Maybe<Scalars['Int']['output']>;
  term_revision_id?: Maybe<Scalars['Int']['output']>;
  unique_key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum TermType {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type Token = {
  __typename?: 'Token';
  token?: Maybe<Scalars['String']['output']>;
};

export type Uid2Token = {
  __typename?: 'Uid2Token';
  token?: Maybe<Scalars['String']['output']>;
};

export type User = {
  birthday?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  profiles?: Maybe<Array<Maybe<ProfileUser>>>;
  user?: Maybe<AccountUser>;
};

export type UserDeleteResponse = {
  __typename?: 'UserDeleteResponse';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type UserFavorites = {
  __typename?: 'UserFavorites';
  id?: Maybe<Scalars['Int']['output']>;
  metas?: Maybe<Array<Maybe<FavoriteMeta>>>;
};

export type UserUpdate = {
  __typename?: 'UserUpdate';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AccountUser>;
};

export type VerifyResult = {
  __typename?: 'VerifyResult';
  error?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type ViewingHistoriesResult = {
  __typename?: 'ViewingHistoriesResult';
  data?: Maybe<Array<Maybe<MediaMeta>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Voucher = {
  __typename?: 'Voucher';
  description?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  limitPrice?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trialExtendEndOf?: Maybe<Scalars['String']['output']>;
  trialExtendTerm?: Maybe<Scalars['Int']['output']>;
  trialExtendTermUnit?: Maybe<Scalars['String']['output']>;
  validityEndAt?: Maybe<Scalars['String']['output']>;
  validityStartAt?: Maybe<Scalars['String']['output']>;
};

export type VoucherCode = {
  __typename?: 'VoucherCode';
  code?: Maybe<Scalars['String']['output']>;
  expire_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  validityEndAt?: Maybe<Scalars['String']['output']>;
  validityStartAt?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<Voucher>;
  voucherId?: Maybe<Scalars['Int']['output']>;
};

export type WebPage = {
  __typename?: 'WebPage';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  metatags?: Maybe<MetaTags>;
  script?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type OrderValue = {
  __typename?: 'orderValue';
  discount_name?: Maybe<Scalars['String']['output']>;
  product_price?: Maybe<Scalars['Int']['output']>;
  transaction_start_at?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentType = {
  __typename?: 'paymentInstrumentType';
  payment_method_id?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<PaymentInstrumentValue>;
};

export type PaymentInstrumentValue = {
  __typename?: 'paymentInstrumentValue';
  card_number?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
};

export type AdvertisingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdvertisingQuery = { __typename?: 'Query', advertising?: { __typename?: 'Result', url?: string | null } | null };

export type AppInitQueryVariables = Exact<{ [key: string]: never; }>;


export type AppInitQuery = { __typename?: 'Query', deviceInfo?: { __typename?: 'DeviceInfo', deviceType?: string | null, deviceVendor?: string | null, isAndroid?: boolean | null, isBot?: boolean | null, isChrome?: boolean | null, isChromeOS?: boolean | null, isDesktop?: boolean | null, isEdge?: boolean | null, isFirefox?: boolean | null, isIE?: boolean | null, isIOS?: boolean | null, isIPad?: boolean | null, isIPhone?: boolean | null, isMac?: boolean | null, isMobile?: boolean | null, isSafari?: boolean | null, isTablet?: boolean | null, isWindows?: boolean | null, ua?: string | null, isApp?: boolean | null, browser?: { __typename?: 'Browser', major?: number | null, name?: string | null, version?: number | null } | null, os?: { __typename?: 'OS', major?: number | null, name?: string | null, version?: number | null } | null } | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null, favorites?: { __typename?: 'UserFavorites', id?: number | null, metas?: Array<
      | { __typename?: 'ChannelMeta', id: string }
      | { __typename?: 'EpisodeMeta', id: string }
      | { __typename?: 'LiveMeta', id: string }
      | { __typename?: 'TVShowMeta', id: string }
     | null> | null } | null };

export type GenreAttributesQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type GenreAttributesQuery = { __typename?: 'Query', genreAttributes?: { __typename?: 'GenreAttributesResult', attributes?: Array<{ __typename?: 'Attributes', name?: string | null, id?: number | null } | null> | null } | null };

export type CanvasQueryVariables = Exact<{
  idKey?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withMeta?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CanvasQuery = { __typename?: 'Query', canvas?: { __typename?: 'CanvasStructureConnection', data?: Array<{ __typename?: 'CanvasStructure', type?: string | null, id?: number | null } | null> | null, meta?: { __typename?: 'CanvasPageMeta', title?: string | null, robots?: string | null, keywords?: string | null, description?: string | null } | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChannelsWithContractStatusQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChannelsWithContractStatusQuery = { __typename?: 'Query', channelsWithContractStatus?: { __typename?: 'ChannelConnection', data?: Array<{ __typename?: 'ChannelMeta', contractStatus?: boolean | null, contractAllowed?: boolean | null, id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChannelFeatureEpisodesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChannelFeatureEpisodesQuery = { __typename?: 'Query', channelFeatureEpisodes?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChannelDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  withTabMenu?: InputMaybe<Scalars['Boolean']['input']>;
  withEntitlement?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ChannelDetailQuery = { __typename?: 'Query', channel?: { __typename?: 'ChannelMeta', contractAllowed?: boolean | null, id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, tabMenu?: Array<{ __typename?: 'Link', id: string, title?: string | null, url?: string | null, values?: any | null } | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', id: string, user_id?: number | null, right_id?: number | null, start_at?: string | null, end_at?: string | null, exercised_at?: string | null, exercise_duration?: number | null, exercise_duration_unit?: number | null, exercisable_start_at?: string | null, exercisable_end_at?: string | null, suspend_flag?: boolean | null } | null> | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null };

export type ChannelEpisodeSearchQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  episodeType?: InputMaybe<EpisodeType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChannelEpisodeSearchQuery = { __typename?: 'Query', channelEpisodeSearch?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChannelLiveScheduleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChannelLiveScheduleQuery = { __typename?: 'Query', channelLiveSchedule?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChannelLinearEpisodesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ChannelLinearEpisodesQuery = { __typename?: 'Query', channelLinearEpisodes?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ChatGetAgreementQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatGetAgreementQuery = { __typename?: 'Query', getChatGuideLineAgreement?: { __typename?: 'ChatGuidelineAgreement', agreement?: boolean | null } | null };

export type ChatSetAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type ChatSetAgreementMutation = { __typename?: 'Mutation', setChatGuideLineAgreement?: { __typename?: 'ChatGuidelineAgreement', agreement?: boolean | null } | null };

export type RoomConfigFieldsFragment = { __typename?: 'ChatRoomConfig', messageLimit?: number | null, pollingInterval?: number | null, initialMessageLimit?: number | null, userLimit?: number | null };

export type RoomCustomDataFieldsFragment = { __typename?: 'ChatRoomCustomData', type?: string | null, liveStartBefore?: number | null, liveEndAfter?: number | null, skipMessageThreshold?: number | null, appMessageLimit?: number | null, chatEndDateTime?: string | null };

export type RoomFieldsFragment = { __typename?: 'ChatRoom', roomId?: string | null, config?: { __typename?: 'ChatRoomConfig', messageLimit?: number | null, pollingInterval?: number | null, initialMessageLimit?: number | null, userLimit?: number | null } | null, customData?: { __typename?: 'ChatRoomCustomData', type?: string | null, liveStartBefore?: number | null, liveEndAfter?: number | null, skipMessageThreshold?: number | null, appMessageLimit?: number | null, chatEndDateTime?: string | null } | null };

export type ChatGetRoomsQueryVariables = Exact<{
  metaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatGetRoomsQuery = { __typename?: 'Query', getRooms?: { __typename?: 'ChatRooms', totalCount?: number | null, rooms?: Array<{ __typename?: 'ChatRoom', roomId?: string | null, config?: { __typename?: 'ChatRoomConfig', messageLimit?: number | null, pollingInterval?: number | null, initialMessageLimit?: number | null, userLimit?: number | null } | null, customData?: { __typename?: 'ChatRoomCustomData', type?: string | null, liveStartBefore?: number | null, liveEndAfter?: number | null, skipMessageThreshold?: number | null, appMessageLimit?: number | null, chatEndDateTime?: string | null } | null } | null> | null } | null };

export type ChatGetRoomTokenQueryVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatGetRoomTokenQuery = { __typename?: 'Query', getRoomToken?: { __typename?: 'Token', token?: string | null } | null };

export type ChatCreateUserMutationVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
  metaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatCreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'ChatUser', roomId?: string | null, refId?: string | null, id?: string | null } | null };

export type ChatGetUserTokenQueryVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatGetUserTokenQuery = { __typename?: 'Query', getUserToken?: { __typename?: 'Token', token?: string | null } | null };

export type SenderFieldsFragment = { __typename?: 'Sender', displayName?: string | null, refId?: string | null, id?: string | null };

export type ChatPostMessageMutationVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatPostMessageMutation = { __typename?: 'Mutation', postChatMessage?: { __typename?: 'ChatMessage', message?: string | null, roomId?: string | null, isNGMessage?: boolean | null, id?: string | null, sender?: { __typename?: 'Sender', displayName?: string | null, refId?: string | null, id?: string | null } | null } | null };

export type ChatDeleteMessageMutationVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatDeleteMessageMutation = { __typename?: 'Mutation', deleteChatMessage?: { __typename?: 'MessageResult', result?: boolean | null } | null };

export type ChatReportMessageMutationVariables = Exact<{
  roomId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatReportMessageMutation = { __typename?: 'Mutation', reportChatMessage?: { __typename?: 'MessageResult', result?: boolean | null } | null };

export type TvShowEpisodesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type TvShowEpisodesQuery = { __typename?: 'Query', children?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type CourseByRightIdQueryVariables = Exact<{
  rightId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CourseByRightIdQuery = { __typename?: 'Query', courseByRightId?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null };

export type CourseByIdQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CourseByIdQuery = { __typename?: 'Query', course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null };

export type DeviceInfoFieldsFragment = { __typename?: 'DeviceInfo', deviceType?: string | null, deviceVendor?: string | null, isAndroid?: boolean | null, isBot?: boolean | null, isChrome?: boolean | null, isChromeOS?: boolean | null, isDesktop?: boolean | null, isEdge?: boolean | null, isFirefox?: boolean | null, isIE?: boolean | null, isIOS?: boolean | null, isIPad?: boolean | null, isIPhone?: boolean | null, isMac?: boolean | null, isMobile?: boolean | null, isSafari?: boolean | null, isTablet?: boolean | null, isWindows?: boolean | null, ua?: string | null, isApp?: boolean | null, browser?: { __typename?: 'Browser', major?: number | null, name?: string | null, version?: number | null } | null, os?: { __typename?: 'OS', major?: number | null, name?: string | null, version?: number | null } | null };

export type DeviceInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceInfoQuery = { __typename?: 'Query', deviceInfo?: { __typename?: 'DeviceInfo', deviceType?: string | null, deviceVendor?: string | null, isAndroid?: boolean | null, isBot?: boolean | null, isChrome?: boolean | null, isChromeOS?: boolean | null, isDesktop?: boolean | null, isEdge?: boolean | null, isFirefox?: boolean | null, isIE?: boolean | null, isIOS?: boolean | null, isIPad?: boolean | null, isIPhone?: boolean | null, isMac?: boolean | null, isMobile?: boolean | null, isSafari?: boolean | null, isTablet?: boolean | null, isWindows?: boolean | null, ua?: string | null, isApp?: boolean | null, browser?: { __typename?: 'Browser', major?: number | null, name?: string | null, version?: number | null } | null, os?: { __typename?: 'OS', major?: number | null, name?: string | null, version?: number | null } | null } | null };

export type GetEntitledStoreEpisodesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEntitledStoreEpisodesQuery = { __typename?: 'Query', getEntitledStoreEpisodes?: { __typename?: 'EntitledEpisodesResult', data?: Array<
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type GenrePaletteEpisodesQueryVariables = Exact<{
  channel?: InputMaybe<Scalars['Int']['input']>;
  genre?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenrePaletteEpisodesQuery = { __typename?: 'Query', genrePaletteEpisodes?: { __typename?: 'GenrePaletteEpisodesResult', data?: Array<
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type EntitledQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['Int']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntitledQuery = { __typename?: 'Query', entitled?: { __typename?: 'EntitledResult', data?: Array<
      | { __typename?: 'ChannelMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
          | { __typename?: 'ChannelMeta', id: string, name: string }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta' }
         | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type PageInfoFieldsFragment = { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null };

export type AdvertisingFieldsFragment = { __typename?: 'Advert', id: string, name?: string | null, description?: string | null, url?: string | null, targetBlank?: boolean | null, sort?: number | null, thumbnailUrl?: string | null, copyright?: string | null };

export type RightFieldsFragment = { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null };

export type ChannelMetaFieldsFragment = { __typename?: 'ChannelMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null };

export type EpisodeMetaFieldsFragment = { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null };

export type LiveMetaFieldsFragment = { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
    | { __typename?: 'ChannelMeta' }
    | { __typename?: 'EpisodeMeta' }
    | { __typename?: 'LiveMeta' }
    | { __typename?: 'SeasonMeta' }
    | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
   | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null };

export type TvShowMetaFieldsFragment = { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
    | { __typename?: 'ChannelMeta', id: string, name: string }
    | { __typename?: 'EpisodeMeta' }
    | { __typename?: 'LiveMeta' }
    | { __typename?: 'SeasonMeta' }
    | { __typename?: 'TVShowMeta' }
   | null };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null };

export type EntitlementFieldsFragment = { __typename?: 'Entitlement', id: string, user_id?: number | null, right_id?: number | null, start_at?: string | null, end_at?: string | null, exercised_at?: string | null, exercise_duration?: number | null, exercise_duration_unit?: number | null, exercisable_start_at?: string | null, exercisable_end_at?: string | null, suspend_flag?: boolean | null };

export type VoucherFildsFragment = { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null };

export type VoucherCodeFieldsFragment = { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null };

export type CampaignFieldsFragment = { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null };

export type CoursePriceFieldsFragment = { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null };

export type CourseFieldsFragment = { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null };

export type SubscriptionFieldsFragment = { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null };

export type HtmlSnippetQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  idKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type HtmlSnippetQuery = { __typename?: 'Query', htmlSnippet?: { __typename?: 'HtmlSnippet', id?: number | null, content?: string | null, style?: string | null, javascript?: string | null } | null };

export type IdcTokenEndPointMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdcTokenEndPointMutation = { __typename?: 'Mutation', idcTokenEndPoint?: { __typename?: 'IdcAccessTokenResponse', access_token?: string | null, expires_in?: string | null, refresh_token?: string | null, scope?: string | null, error?: string | null, error_description?: string | null, interval?: string | null } | null };

export type IdcUserInfoEndPointQueryVariables = Exact<{ [key: string]: never; }>;


export type IdcUserInfoEndPointQuery = { __typename?: 'Query', idcUserInfoEndPoint?: { __typename?: 'IdcUserInfo', sub?: string | null, iss?: string | null, aud?: string | null, email?: string | null, name?: string | null, namekana?: string | null, gender?: string | null, birthdate?: string | null } | null };

export type IdcUserInfoEndPointAgeValidateQueryVariables = Exact<{ [key: string]: never; }>;


export type IdcUserInfoEndPointAgeValidateQuery = { __typename?: 'Query', idcUserInfoEndPointAgeValidate?: { __typename?: 'IdcUserInfo', sub?: string | null, iss?: string | null, aud?: string | null, email?: string | null, name?: string | null, namekana?: string | null, gender?: string | null, birthdate?: string | null } | null };

export type IdcTokenVerifyEndPointQueryVariables = Exact<{ [key: string]: never; }>;


export type IdcTokenVerifyEndPointQuery = { __typename?: 'Query', idcTokenVerifyEndPoint?: { __typename?: 'IdcTokenVerifyInfo', access_token?: string | null, token_type?: string | null, expires_in?: string | null, user_id?: string | null, elipsis_flg?: string | null, client_id?: string | null } | null };

export type InformationsQueryVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InformationsQuery = { __typename?: 'Query', informations?: { __typename?: 'InformarionConnection', data?: Array<{ __typename?: 'Link', id: string, title?: string | null, url?: string | null, targetBlank?: boolean | null, date?: string | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type InquiryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
  membersId?: InputMaybe<Scalars['String']['input']>;
  pastSpooxId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  body: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type InquiryMutation = { __typename?: 'Mutation', sendInquiryMail?: { __typename?: 'Result', result?: boolean | null } | null };

export type ProductOrdersQueryVariables = Exact<{
  with_order?: InputMaybe<Scalars['Boolean']['input']>;
  with_payment_instrument?: InputMaybe<Scalars['Boolean']['input']>;
  with_entitlements?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductOrdersQuery = { __typename?: 'Query', productOrders?: { __typename?: 'ProductOrdersResponse', data?: Array<{ __typename?: 'ProductOrders', name?: string | null, order_id?: number | null, created_at?: string | null, order?: { __typename?: 'OrderType', finished_at?: string | null, payment_amount?: number | null, payment_instrument?: { __typename?: 'paymentInstrumentType', payment_method_id?: number | null, values?: { __typename?: 'paymentInstrumentValue', card_type?: string | null, card_number?: string | null } | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', end_at?: string | null, right_id?: number | null } | null> | null } | null> | null } | null };

export type OrdersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersResult', data?: Array<{ __typename?: 'OrderData', name?: string | null, created_at?: string | null, payment_amount?: number | null, order_type?: string | null, payment_instrument?: { __typename?: 'paymentInstrumentType', payment_method_id?: number | null, values?: { __typename?: 'paymentInstrumentValue', card_type?: string | null, card_number?: string | null } | null } | null, values?: { __typename?: 'orderValue', product_price?: number | null, discount_name?: string | null, transaction_start_at?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type PaletteQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaletteQuery = { __typename?: 'Query', palette?: { __typename?: 'Palette', palette_id: string, name?: string | null, id_key?: string | null, header?: string | null, description?: string | null, schema_id?: number | null, schema?: string | null, values?: any | null } | null, paletteObjects?: { __typename?: 'PaletteObjectConnection', data?: Array<{ __typename?: 'PaletteObject', id?: number | null, type?: string | null, meta?:
        | { __typename?: 'ChannelMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null }
        | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
            | { __typename?: 'ChannelMeta' }
            | { __typename?: 'EpisodeMeta' }
            | { __typename?: 'LiveMeta' }
            | { __typename?: 'SeasonMeta' }
            | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
           | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'SeasonMeta' }
        | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
            | { __typename?: 'ChannelMeta', id: string, name: string }
            | { __typename?: 'EpisodeMeta' }
            | { __typename?: 'LiveMeta' }
            | { __typename?: 'SeasonMeta' }
            | { __typename?: 'TVShowMeta' }
           | null }
       | null, advertising?: { __typename?: 'Advert', id: string, name?: string | null, description?: string | null, url?: string | null, targetBlank?: boolean | null, sort?: number | null, thumbnailUrl?: string | null, copyright?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type PaletteObjectsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaletteObjectsQuery = { __typename?: 'Query', paletteObjects?: { __typename?: 'PaletteObjectConnection', data?: Array<{ __typename?: 'PaletteObject', id?: number | null, type?: string | null, meta?:
        | { __typename?: 'ChannelMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null }
        | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
            | { __typename?: 'ChannelMeta' }
            | { __typename?: 'EpisodeMeta' }
            | { __typename?: 'LiveMeta' }
            | { __typename?: 'SeasonMeta' }
            | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
           | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'SeasonMeta' }
        | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
            | { __typename?: 'ChannelMeta', id: string, name: string }
            | { __typename?: 'EpisodeMeta' }
            | { __typename?: 'LiveMeta' }
            | { __typename?: 'SeasonMeta' }
            | { __typename?: 'TVShowMeta' }
           | null }
       | null, advertising?: { __typename?: 'Advert', id: string, name?: string | null, description?: string | null, url?: string | null, targetBlank?: boolean | null, sort?: number | null, thumbnailUrl?: string | null, copyright?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type PaymentInstrumentsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentInstrumentsQuery = { __typename?: 'Query', paymentInstruments?: Array<{ __typename?: 'PaymentInstruments', default_flag?: boolean | null, payment_method_id?: number | null, payment_instrument_id?: number | null, ref_id?: string | null, payment_method?: { __typename?: 'PaymentMethod', name?: string | null } | null, values?: { __typename?: 'PurchaseMethodsValues', card_number?: string | null, card_type?: string | null, expiry_date?: string | null } | null } | null> | null };

export type PaymentInstrumentInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentInstrumentInfoQuery = { __typename?: 'Query', paymentInstrumentInfo?: { __typename?: 'PaymentInstruments', default_flag?: boolean | null, payment_method_id?: number | null, payment_instrument_id?: number | null, ref_id?: string | null, payment_method?: { __typename?: 'PaymentMethod', name?: string | null } | null, values?: { __typename?: 'PurchaseMethodsValues', card_number?: string | null, card_type?: string | null, expiry_date?: string | null } | null } | null };

export type PaymentInstrumentsCreateCreditCardRecaptchaV2MutationVariables = Exact<{
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_key?: InputMaybe<Scalars['String']['input']>;
  tds_info_token?: InputMaybe<Scalars['String']['input']>;
  tds_info_token_key?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation = { __typename?: 'Mutation', paymentInstrumentsCreateCreditCardRecaptchaV2?: { __typename?: 'PaymentInstrumentsCreateCreditCardRecaptchaV2Result', redirect_link?: boolean | null, http_method?: string | null, redirect_url?: string | null, charset?: string | null, error?: string | null, recaptchaSuccessV2?: boolean | null, form_data?: { __typename?: 'FormData', pay_method?: string | null, merchant_id?: string | null, service_id?: string | null, cust_code?: string | null, order_id?: string | null, item_id?: string | null, item_name?: string | null, service_type?: number | null, terminal_type?: number | null, success_url?: string | null, cancel_url?: string | null, error_url?: string | null, pagecon_url?: string | null, free1?: string | null, free2?: string | null, free3?: string | null, request_date?: string | null, limit_second?: string | null, sps_hashcode?: string | null } | null } | null };

export type PaymentInstrumentsCreateCreditCardRecaptchaV3MutationVariables = Exact<{
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_key?: InputMaybe<Scalars['String']['input']>;
  tds_info_token?: InputMaybe<Scalars['String']['input']>;
  tds_info_token_key?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
  recaptchaTokenV3?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation = { __typename?: 'Mutation', paymentInstrumentsCreateCreditCardRecaptchaV3?: { __typename?: 'PaymentInstrumentsCreateCreditCardRecaptchaV3Result', redirect_link?: boolean | null, http_method?: string | null, redirect_url?: string | null, charset?: string | null, error?: string | null, recaptchaSuccessV3?: boolean | null, form_data?: { __typename?: 'FormData', pay_method?: string | null, merchant_id?: string | null, service_id?: string | null, cust_code?: string | null, order_id?: string | null, item_id?: string | null, item_name?: string | null, service_type?: number | null, terminal_type?: number | null, success_url?: string | null, cancel_url?: string | null, error_url?: string | null, pagecon_url?: string | null, free1?: string | null, free2?: string | null, free3?: string | null, request_date?: string | null, limit_second?: string | null, sps_hashcode?: string | null } | null } | null };

export type PaymentInstrumentsCreateOtherMutationVariables = Exact<{
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  replace_flag?: InputMaybe<Scalars['Boolean']['input']>;
  success_url?: InputMaybe<Scalars['String']['input']>;
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  error_url?: InputMaybe<Scalars['String']['input']>;
  tokenPayload?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type PaymentInstrumentsCreateOtherMutation = { __typename?: 'Mutation', paymentInstrumentsCreateOther?: { __typename?: 'PaymentInstrumentsCreateOther', redirect_link?: boolean | null, http_method?: string | null, redirect_url?: string | null, charset?: string | null, error?: string | null, form_data?: { __typename?: 'FormData', pay_method?: string | null, merchant_id?: string | null, service_id?: string | null, cust_code?: string | null, order_id?: string | null, item_id?: string | null, item_name?: string | null, service_type?: number | null, terminal_type?: number | null, success_url?: string | null, cancel_url?: string | null, error_url?: string | null, pagecon_url?: string | null, free1?: string | null, free2?: string | null, free3?: string | null, request_date?: string | null, limit_second?: string | null, sps_hashcode?: string | null } | null } | null };

export type PaymentInstrumentsActivateMutationVariables = Exact<{
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentInstrumentsActivateMutation = { __typename?: 'Mutation', paymentInstrumentsActivate?: { __typename?: 'PaymentInstrumentsActivate', payment_instrument_id?: number | null, error?: { __typename?: 'PaymentInstrumentsActivateError', message?: string | null } | null } | null };

export type PaymentInstrumentsDeactivateMutationVariables = Exact<{
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentInstrumentsDeactivateMutation = { __typename?: 'Mutation', paymentInstrumentsDeactivate?: { __typename?: 'PaymentInstrumentsDeactivate', payment_instrument_id?: number | null, error?: { __typename?: 'PaymentInstrumentsDeactivateError', message?: string | null } | null } | null };

export type PaymentInstrumentsSetDefaultMutationVariables = Exact<{
  payment_instrument_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentInstrumentsSetDefaultMutation = { __typename?: 'Mutation', paymentInstrumentsSetDefault?: { __typename?: 'PaymentInstrumentsSetDefault', result?: boolean | null } | null };

export type AddPaymentInstrumentSendMailMutationVariables = Exact<{
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddPaymentInstrumentSendMailMutation = { __typename?: 'Mutation', addPaymentInstrumentSendMail?: { __typename?: 'SendMailResult', result?: boolean | null } | null };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods?: Array<{ __typename?: 'PaymentMethods', name?: string | null, payment_method_id?: number | null, payment_method_type_name?: string | null } | null> | null, paymentInstruments?: Array<{ __typename?: 'PaymentInstruments', default_flag?: boolean | null, payment_method_id?: number | null, payment_instrument_id?: number | null, ref_id?: string | null, payment_method?: { __typename?: 'PaymentMethod', name?: string | null } | null, values?: { __typename?: 'PurchaseMethodsValues', card_number?: string | null, card_type?: string | null, expiry_date?: string | null } | null } | null> | null };

export type PinActivateMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type PinActivateMutation = { __typename?: 'Mutation', pinActivate?: { __typename?: 'PinActivateResult', status?: string | null, result?: boolean | null, deviceToken?: string | null } | null };

export type PlaybackAuthQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  vuid?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  fl?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaybackAuthQuery = { __typename?: 'Query', playbackAuth?: { __typename?: 'Playback', playback_session_id?: string | null, log_params?: any | null, resumePoint?: number | null, media?: { __typename?: 'PlaybackMedia', media_id: string, uuid?: string | null, ovp_id?: number | null, ovp_video_id?: string | null, thumbnail_tile_urls?: Array<string | null> | null } | null, rule?: { __typename?: 'PlaybackRule', playback_rule_id?: string | null, enable_seek_flag?: boolean | null, enable_cromecst_flag?: boolean | null, enable_airplay_flag?: boolean | null, enable_mirroring_flag?: boolean | null, enable_external_monitor_flag?: boolean | null, enable_catchup_flag?: boolean | null, enable_start_over_flag?: boolean | null, enable_pause_flag?: boolean | null, enable_background_play_flag?: boolean | null, enable_screen_capture_flag?: boolean | null, enable_playback_rate_change_flag?: boolean | null, enable_offline_play_flag?: boolean | null, maximum_bitrate?: number | null, minimum_bitrate?: number | null } | null, error?: { __typename?: 'PlaybackError', type?: string | null, message?: string | null, code?: number | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', id: string, user_id?: number | null, right_id?: number | null, start_at?: string | null, end_at?: string | null, exercised_at?: string | null, exercise_duration?: number | null, exercise_duration_unit?: number | null, exercisable_start_at?: string | null, exercisable_end_at?: string | null, suspend_flag?: boolean | null } | null> | null } | null };

export type PlaybackSessionOpenMutationVariables = Exact<{
  videoId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaybackSessionOpenMutation = { __typename?: 'Mutation', playbackSessionOpen?: { __typename?: 'MediaSource', media?: any | null, error?: { __typename?: 'PlaybackError', type?: string | null, message?: string | null, code?: number | null } | null } | null };

export type PlaybackSessionCheckMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaybackSessionCheckMutation = { __typename?: 'Mutation', playbackSessionCheck?: { __typename?: 'PlaybackSessionCheckResult', result?: boolean | null } | null };

export type PlaybackSessionCloseMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaybackSessionCloseMutation = { __typename?: 'Mutation', playbackSessionClose?: { __typename?: 'PlaybackSessionCloseResult', result?: boolean | null } | null };

export type ProductByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductByIdQuery = { __typename?: 'Query', product?: { __typename?: 'Product', purchased?: boolean | null, id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null, meta?:
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
     | null } | null };

export type PurchaseEstimateQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PurchaseEstimateQuery = { __typename?: 'Query', estimate?: { __typename?: 'PurchaseEstimate', error?: string | null, product?: { __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, voucherCode?: { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null } | null } | null } | null };

export type PurchaseEstimateWithCouponQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseEstimateWithCouponQuery = { __typename?: 'Query', estimateWithCoupon?: { __typename?: 'PurchaseEstimate', error?: string | null, product?: { __typename?: 'Product', discountPrice?: number | null, id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, voucherCode?: { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null } | null } | null } | null };

export type PurchaseExecuteMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseExecuteMutation = { __typename?: 'Mutation', purchaseExecute?: { __typename?: 'ProductOrder', product_order_id?: number | null, product_id?: number | null, status?: string | null, name?: string | null, created_at?: string | null, error?: string | null, order?: { __typename?: 'Order', order_id?: number | null, payment_method_id?: number | null, payment_amount?: number | null } | null } | null };

export type PurchaseTestMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  userVoucherId?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseTestMutation = { __typename?: 'Mutation', purchaseTest?: { __typename?: 'ProductOrder', product_order_id?: number | null, product_id?: number | null, status?: string | null, name?: string | null, created_at?: string | null, error?: string | null, order?: { __typename?: 'Order', order_id?: number | null, payment_method_id?: number | null, payment_amount?: number | null } | null } | null };

export type RankingQueryVariables = Exact<{
  target?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RankingQuery = { __typename?: 'Query', ranking?: Array<{ __typename?: 'Ranking', id?: string | null, rank?: number | null, meta?:
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
     | null } | null> | null };

export type RecommendArticleFieldsFragment = { __typename?: 'RecommendArticle', courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null } | null> | null };

export type RecommendArticleQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendArticleQuery = { __typename?: 'Query', recommendArticle?: { __typename?: 'RecommendArticle', courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null } | null> | null } | null };

export type UpdateRecommendArticleMutationVariables = Exact<{
  type: Scalars['String']['input'];
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type UpdateRecommendArticleMutation = { __typename?: 'Mutation', updateRecommendArticle?: { __typename?: 'RecommendArticle', courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null } | null> | null } | null };

export type ClearRecommendArticleMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearRecommendArticleMutation = { __typename?: 'Mutation', clearRecommendArticle?: { __typename?: 'RecommendArticle', courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null } | null> | null } | null };

export type SearchEpisodeQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchEpisodeQuery = { __typename?: 'Query', search?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type SearchTvShowQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTvShowQuery = { __typename?: 'Query', search?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta' }
      | { __typename?: 'LiveMeta' }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
          | { __typename?: 'ChannelMeta', id: string, name: string }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta' }
         | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type SearchConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchConfigQuery = { __typename?: 'Query', searchConfig?: { __typename?: 'SearchConfig', livePaletteKeywords?: Array<string | null> | null, defaultMinScore?: number | null, keywordMinScore?: Array<{ __typename?: 'KeywordMinScore', keyword?: string | null, score?: number | null } | null> | null } | null };

export type SignupQueryVariables = Exact<{ [key: string]: never; }>;


export type SignupQuery = { __typename?: 'Query', requiredTerms?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null, optionalTerms?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null, recommendArticle?: { __typename?: 'RecommendArticle', courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null, right?: { __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null } | null> | null } | null };

export type SubscribeMutationVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
  paymentInstrumentId?: InputMaybe<Scalars['Int']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  valuePlanTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscribeMutation = { __typename?: 'Mutation', subscribe?: { __typename?: 'Subscription', subscription_id?: string | null, status?: string | null, initialTransactionAt?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, init_order_id?: number | null, orderPrice?: number | null, error?: string | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null } | null };

export type SubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsQuery = { __typename?: 'Query', subscriptions?: Array<{ __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null> | null };

export type UnsubscribeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnsubscribeQuery = { __typename?: 'Query', subscription?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null, checkCancelable?: { __typename?: 'SubscriptionCheckCancelableResponse', cancelable?: boolean | null, subscription?: { __typename?: 'SubscriptionCheckCancelableSubscription', withdraw_at?: string | null } | null } | null };

export type FormQuestionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FormQuestionsQuery = { __typename?: 'Query', formQuestions?: { __typename?: 'FormQuestionsResponse', question_id?: number | null, values?: any | null, data?: Array<{ __typename?: 'FormQuestions', type?: string | null, label?: string | null, unique?: string | null, key_name?: string | null, help_text?: string | null, required?: boolean | null, schema_group_name?: string | null, options?: Array<{ __typename?: 'OptionsValue', label?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type SubscriptionCancelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['Int']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  withQuestionAnswer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubscriptionCancelMutation = { __typename?: 'Mutation', subscriptionCancel?: { __typename?: 'SubscriptionCancel', course_id?: number | null, status?: string | null, withdraw_at?: string | null, error?: string | null } | null, formQuestionAnswer?: { __typename?: 'FormQuestionAnswer', answer_id?: number | null } | null };

export type SubscriptionChangePaymentMutationVariables = Exact<{
  paymentInstrumentId: Scalars['Int']['input'];
  subscriptionId: Scalars['Int']['input'];
}>;


export type SubscriptionChangePaymentMutation = { __typename?: 'Mutation', subscriptionChangePayment?: { __typename?: 'SubscriptionChangePaymentResult', payment_instrument_id?: number | null, error?: string | null } | null };

export type SubscriptionCheckCancelableQueryVariables = Exact<{
  subscriptionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubscriptionCheckCancelableQuery = { __typename?: 'Query', checkCancelable?: { __typename?: 'SubscriptionCheckCancelableResponse', cancelable?: boolean | null, subscription?: { __typename?: 'SubscriptionCheckCancelableSubscription', withdraw_at?: string | null } | null } | null };

export type FormQuestionAnswerMutationVariables = Exact<{
  values?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FormQuestionAnswerMutation = { __typename?: 'Mutation', formQuestionAnswer?: { __typename?: 'FormQuestionAnswer', answer_id?: number | null } | null };

export type SubscriptionStatusQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubscriptionStatusQuery = { __typename?: 'Query', course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, subscriptionStatus?: { __typename?: 'SubscriptionStatusResponse', is_contractable?: boolean | null, is_contracted?: boolean | null, have_be_contracted?: boolean | null, is_trial_enabled?: boolean | null, subscription?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null } | null };

export type UnSubscribedStatusQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UnSubscribedStatusQuery = { __typename?: 'Query', unSubscribedStatus?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null };

export type EstimateFieldsFragment = { __typename?: 'SubscriptionEstimate', error?: string | null, subscription?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null, voucherCode?: { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null } | null, coursePricings?: Array<{ __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null> | null, paymentPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null, campaignPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null };

export type SubscriptionEstimateQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubscriptionEstimateQuery = { __typename?: 'Query', estimate?: { __typename?: 'SubscriptionEstimate', error?: string | null, subscription?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null, voucherCode?: { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null } | null, coursePricings?: Array<{ __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null> | null, paymentPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null, campaignPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null };

export type SubscriptionEstimateWithCouponQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscriptionEstimateWithCouponQuery = { __typename?: 'Query', estimateWithCoupon?: { __typename?: 'SubscriptionEstimate', error?: string | null, subscription?: { __typename?: 'Subscription', subscription_id?: string | null, course_id?: number | null, payment_method_id?: number | null, payment_instrument_id?: number | null, initialTransactionAt?: string | null, nextTransactionAt?: string | null, status?: string | null, withdraw_at?: string | null, trialStartAt?: string | null, trialEndAt?: string | null, suspend_flag?: boolean | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, payment_instrument?: { __typename?: 'PaymentInstrument', values?: { __typename?: 'PaymentInstrumentValues', card_number?: string | null, card_type?: string | null } | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', right_id?: number | null } | null> | null } | null, voucherCode?: { __typename?: 'VoucherCode', id?: string | null, code?: string | null, voucherId?: number | null, validityStartAt?: string | null, validityEndAt?: string | null, expire_at?: string | null, isAvailable?: boolean | null, voucher?: { __typename?: 'Voucher', id?: string | null, name?: string | null, description?: string | null, discountPrice?: number | null, limitPrice?: number | null, trialExtendTerm?: number | null, trialExtendTermUnit?: string | null, trialExtendEndOf?: string | null, validityStartAt?: string | null, validityEndAt?: string | null } | null } | null, coursePricings?: Array<{ __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null> | null, paymentPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null, campaignPrice?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null };

export type TermsFieldsFragment = { __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null };

export type TermsQueryVariables = Exact<{
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  withAgreement?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TermsQuery = { __typename?: 'Query', terms?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null };

export type ValuePlanTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type ValuePlanTermsQuery = { __typename?: 'Query', terms?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null };

export type RegistTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistTermsQuery = { __typename?: 'Query', required?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null, optional?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null };

export type LoginTermsQueryVariables = Exact<{
  cacheMaxAge?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LoginTermsQuery = { __typename?: 'Query', required?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null, optional?: Array<{ __typename?: 'Term', id_key?: string | null, display_name?: string | null, required?: boolean | null, current_revision?: { __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null } | null> | null };

export type TermsAgreeMutationVariables = Exact<{
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type TermsAgreeMutation = { __typename?: 'Mutation', agree?: Array<{ __typename?: 'TermRevision', unique_key?: string | null, number?: number | null, url?: string | null, agreement?: { __typename?: 'TermAgreement', agreement_id?: number | null, user_id?: number | null, term_id?: number | null, term_revision_number?: number | null } | null } | null> | null };

export type TitleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  withBookmark?: InputMaybe<Scalars['Boolean']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
  withCourse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TitleQuery = { __typename?: 'Query', title?: { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, bookmark?: { __typename?: 'Bookmark', meta_id?: number | null, bookmark_meta_id?: number | null, position?: number | null, bookmark_meta?:
        | { __typename?: 'ChannelMeta' }
        | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
            | { __typename?: 'ChannelMeta' }
            | { __typename?: 'EpisodeMeta' }
            | { __typename?: 'LiveMeta' }
            | { __typename?: 'SeasonMeta' }
            | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
           | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
        | { __typename?: 'SeasonMeta' }
        | { __typename?: 'TVShowMeta' }
       | null } | null, course?: { __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
      | { __typename?: 'ChannelMeta', id: string, name: string }
      | { __typename?: 'EpisodeMeta' }
      | { __typename?: 'LiveMeta' }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null } | null, children?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta' }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type TitlesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TitlesQuery = { __typename?: 'Query', titles?: { __typename?: 'MetaConnection', data?: Array<
      | { __typename?: 'ChannelMeta' }
      | { __typename?: 'EpisodeMeta' }
      | { __typename?: 'LiveMeta' }
      | { __typename?: 'SeasonMeta' }
      | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
          | { __typename?: 'ChannelMeta', id: string, name: string }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta' }
         | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type UserFavoritesFieldsFragment = { __typename?: 'UserFavorites', id?: number | null, metas?: Array<
    | { __typename?: 'ChannelMeta', id: string }
    | { __typename?: 'EpisodeMeta', id: string }
    | { __typename?: 'LiveMeta', id: string }
    | { __typename?: 'TVShowMeta', id: string }
   | null> | null };

export type ProfileFieldsFragment = { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null };

export type AccountFieldsFragment = { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null };

export type AuthLoginMutationVariables = Exact<{
  loginid: Scalars['String']['input'];
  password: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}>;


export type AuthLoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'Auth', token?: string | null, error?: { __typename?: 'IdcTokenAuthError', code?: string | null } | null } | null };

export type AuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserQuery = { __typename?: 'Query', user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null };

export type AuthUserWithFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserWithFavoritesQuery = { __typename?: 'Query', user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null, favorites?: { __typename?: 'UserFavorites', id?: number | null, metas?: Array<
      | { __typename?: 'ChannelMeta', id: string }
      | { __typename?: 'EpisodeMeta', id: string }
      | { __typename?: 'LiveMeta', id: string }
      | { __typename?: 'TVShowMeta', id: string }
     | null> | null } | null };

export type AuthLogoutMutationVariables = Exact<{
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuthLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'AuthResult', result?: boolean | null } | null };

export type AuthSelectProfileMutationVariables = Exact<{
  profileId: Scalars['Int']['input'];
  passcode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthSelectProfileMutation = { __typename?: 'Mutation', selectProfile?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null };

export type AuthProfileMutationVariables = Exact<{
  profileId?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthProfileMutation = { __typename?: 'Mutation', authProfile?: { __typename?: 'AuthOwnerProfileResponse', result?: boolean | null } | null };

export type AccountSendProfilePinResetTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountSendProfilePinResetTokenMutation = { __typename?: 'Mutation', sendProfilePinResetToken?: { __typename?: 'PinCodeResult', result?: boolean | null } | null };

export type AccountSendPasswordResetTokenMutationVariables = Exact<{
  mailAddress: Scalars['String']['input'];
}>;


export type AccountSendPasswordResetTokenMutation = { __typename?: 'Mutation', sendPasswordResetToken?: { __typename?: 'PinCodeResult', result?: boolean | null } | null };

export type AccountPasswordResetMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type AccountPasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'PinCodeResult', result?: boolean | null } | null };

export type AccountPasscodeResetMutationVariables = Exact<{
  passcode: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type AccountPasscodeResetMutation = { __typename?: 'Mutation', passcodeReset?: { __typename?: 'PinCodeResult', result?: boolean | null } | null };

export type AccountVerifyPinCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
}>;


export type AccountVerifyPinCodeMutation = { __typename?: 'Mutation', verifyPinCode?: { __typename?: 'VerifyResult', verified?: boolean | null, error?: string | null } | null };

export type AccountVerifyPasswordTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AccountVerifyPasswordTokenMutation = { __typename?: 'Mutation', verifyPasswordToken?: { __typename?: 'VerifyResult', verified?: boolean | null, error?: string | null } | null };

export type AccountSignupMutationVariables = Exact<{
  code: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  birthday: Scalars['String']['input'];
  sex: Scalars['String']['input'];
  terms: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}>;


export type AccountSignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'Auth', token?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type AddFavoriteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AddFavoriteMutation = { __typename?: 'Mutation', addFavorite?: { __typename?: 'FavoriteResult', result?: boolean | null, favorites?: { __typename?: 'UserFavorites', id?: number | null, metas?: Array<
        | { __typename?: 'ChannelMeta', id: string }
        | { __typename?: 'EpisodeMeta', id: string }
        | { __typename?: 'LiveMeta', id: string }
        | { __typename?: 'TVShowMeta', id: string }
       | null> | null } | null } | null };

export type DeleteFavoriteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFavoriteMutation = { __typename?: 'Mutation', deleteFavorite?: { __typename?: 'FavoriteResult', result?: boolean | null, favorites?: { __typename?: 'UserFavorites', id?: number | null, metas?: Array<
        | { __typename?: 'ChannelMeta', id: string }
        | { __typename?: 'EpisodeMeta', id: string }
        | { __typename?: 'LiveMeta', id: string }
        | { __typename?: 'TVShowMeta', id: string }
       | null> | null } | null } | null };

export type FavoritesByContentTypeQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FavoritesByContentTypeQuery = { __typename?: 'Query', favorites?: { __typename?: 'FavoritesByContentTypeResult', data?: Array<
      | { __typename?: 'ChannelMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, live_flag?: boolean | null, video_flag?: boolean | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, contractAllowed?: boolean | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, heroImage?: { __typename?: 'ChannelMetaHeroImage', pc?: string | null, mb?: string | null } | null }
      | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'TVShowMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, cast?: string | null, staff?: string | null, episode_num?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, distributor?: string | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null, rights_control_type?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?:
          | { __typename?: 'ChannelMeta', id: string, name: string }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta' }
         | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type ViewingHistoriesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  nocache?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ViewingHistoriesQuery = { __typename?: 'Query', viewingHistories?: { __typename?: 'ViewingHistoriesResult', data?: Array<
      | { __typename?: 'EpisodeMeta', resume_point?: number | null, last_viewing_at?: string | null, id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
      | { __typename?: 'LiveMeta', resume_point?: number | null, last_viewing_at?: string | null, id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
          | { __typename?: 'ChannelMeta' }
          | { __typename?: 'EpisodeMeta' }
          | { __typename?: 'LiveMeta' }
          | { __typename?: 'SeasonMeta' }
          | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
         | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
     | null> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, limit?: number | null, totalCount?: number | null, hasNextPage?: boolean | null } | null } | null };

export type DeleteViewingHistoryMutationVariables = Exact<{
  metaIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteViewingHistoryMutation = { __typename?: 'Mutation', deleteViewingHistory?: { __typename?: 'DeleteViewingHistoryResult', result?: boolean | null } | null };

export type AddResumeMutationVariables = Exact<{
  resume?: InputMaybe<Scalars['Int']['input']>;
  metaId?: InputMaybe<Scalars['Int']['input']>;
  groupedMetaId?: InputMaybe<Scalars['Int']['input']>;
  psid?: InputMaybe<Scalars['String']['input']>;
  reachToEnd?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddResumeMutation = { __typename?: 'Mutation', addResume?: { __typename?: 'AddResumeResult', result?: boolean | null } | null };

export type AccountUpdateMutationVariables = Exact<{
  mailAddress?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountUpdateMutation = { __typename?: 'Mutation', update?: { __typename?: 'UserUpdate', error?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type AccountUpdatePasswordMutationVariables = Exact<{
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountUpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UserUpdate', error?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type AccountUpdateOwnerProfileMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountUpdateOwnerProfileMutation = { __typename?: 'Mutation', updateOwnerProfile?: { __typename?: 'UserUpdate', error?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type AccountAddProfileMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountAddProfileMutation = { __typename?: 'Mutation', addProfile?: { __typename?: 'Profile', profile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null } | null };

export type AccountUpdateProfileMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  icon?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountUpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'Profile', profile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null } | null };

export type AccountDeleteProfileMutationVariables = Exact<{
  profileId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountDeleteProfileMutation = { __typename?: 'Mutation', deleteProfile?: { __typename?: 'DeleteProfileResponse', result?: boolean | null } | null };

export type AccountUserDeleteMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountUserDeleteMutation = { __typename?: 'Mutation', userDelete?: { __typename?: 'UserDeleteResponse', result?: boolean | null } | null };

export type UserEntitlementsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEntitlementsQuery = { __typename?: 'Query', entitlements?: Array<{ __typename?: 'Entitlement', id: string, user_id?: number | null, right_id?: number | null, start_at?: string | null, end_at?: string | null, exercised_at?: string | null, exercise_duration?: number | null, exercise_duration_unit?: number | null, exercisable_start_at?: string | null, exercisable_end_at?: string | null, suspend_flag?: boolean | null } | null> | null };

export type AccountAdvertisingPreferencesMutationVariables = Exact<{
  receiveAdvertisingMailFlag?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccountAdvertisingPreferencesMutation = { __typename?: 'Mutation', advertisingPreferences?: { __typename?: 'AdvertisingPreferencesResult', request_id?: string | null } | null };

export type CheckTokenTimeoutQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckTokenTimeoutQuery = { __typename?: 'Query', checkTokenTimeout?: { __typename?: 'AuthResult', result?: boolean | null } | null };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'AuthResult', result?: boolean | null } | null };

export type IdcTokenLoginMutationVariables = Exact<{
  signature: Scalars['String']['input'];
}>;


export type IdcTokenLoginMutation = { __typename?: 'Mutation', idcTokenLogin?: { __typename?: 'Auth', token?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null, error?: { __typename?: 'IdcTokenAuthError', code?: string | null } | null } | null };

export type AccountIdcTokenSignupMutationVariables = Exact<{
  password: Scalars['String']['input'];
  terms: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}>;


export type AccountIdcTokenSignupMutation = { __typename?: 'Mutation', idcTokenSignup?: { __typename?: 'Auth', token?: string | null, user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type SpooxIdIdcTokenMappingMutationVariables = Exact<{
  signature: Scalars['String']['input'];
}>;


export type SpooxIdIdcTokenMappingMutation = { __typename?: 'Mutation', idcTokenMapping?: { __typename?: 'MappingResponce', user?: { __typename?: 'AccountUser', id?: number | null, uuid: string, birthday?: string | null, age?: number | null, sex?: number | null, fullName?: string | null, test_flg?: boolean | null, hashedUserId?: string | null, receiveAdvertisingMailType?: number | null, displayName?: string | null, mailAddress?: string | null, firstName?: string | null, lastName?: string | null, rightsFreeFlag?: boolean | null, currentProfile?: { __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null, profiles?: Array<{ __typename?: 'ProfileUser', uuid: string, id?: number | null, birthday?: string | null, age?: number | null, sex?: number | null, ownerProfile?: boolean | null, needPasscode?: boolean | null, icon?: number | null, rating?: number | null, displayName?: string | null } | null> | null } | null } | null };

export type WatchQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WatchQuery = { __typename?: 'Query', episode?:
    | { __typename?: 'ChannelMeta' }
    | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
    | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
        | { __typename?: 'ChannelMeta' }
        | { __typename?: 'EpisodeMeta' }
        | { __typename?: 'LiveMeta' }
        | { __typename?: 'SeasonMeta' }
        | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
       | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
    | { __typename?: 'SeasonMeta' }
    | { __typename?: 'TVShowMeta' }
   | null, nextEpisode?:
    | { __typename?: 'ChannelMeta' }
    | { __typename?: 'EpisodeMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
    | { __typename?: 'LiveMeta', id: string, schema_key?: string | null, name: string, header?: string | null, description?: string | null, thumbnailUrl?: string | null, copyright?: string | null, delivery_start_at?: string | null, delivery_end_at?: string | null, rights_control_type?: string | null, rating?: string | null, isAllowedRating?: boolean | null, production_country?: Array<string | null> | null, production_year?: string | null, distributor?: string | null, cast?: string | null, staff?: string | null, duration?: number | null, meta_keywords?: Array<string | null> | null, meta_description?: string | null, area_control_flag?: boolean | null, is_live?: boolean | null, recommend?: number | null, start_over_flag?: boolean | null, catch_up_flag?: boolean | null, encode_start_date?: string | null, encode_end_date?: string | null, source_epg_id?: string | null, plalaFlag?: boolean | null, parents?: Array<
        | { __typename?: 'ChannelMeta' }
        | { __typename?: 'EpisodeMeta' }
        | { __typename?: 'LiveMeta' }
        | { __typename?: 'SeasonMeta' }
        | { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null }
       | null> | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, price?: number | null } | null> | null, genres?: Array<{ __typename?: 'Genre', id: string, name: string } | null> | null, channel?: { __typename?: 'ChannelMeta', id: string, name: string } | null, tvShow?: { __typename?: 'TVShowMeta', id: string, name: string, episode_num?: number | null } | null }
    | { __typename?: 'SeasonMeta' }
    | { __typename?: 'TVShowMeta' }
   | null, howtoPlay?: { __typename?: 'HowtoPlay', free?: boolean | null, member_only?: boolean | null, rights?: Array<{ __typename?: 'Right', id: string, name: string, exercise_term?: number | null, exercise_term_unit?: number | null, view_term?: number | null, view_term_unit?: number | null, view_limit_date?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, discount_price?: number | null, isSvod?: boolean | null, package_type?: number | null, discount_description?: string | null, contractAllowed?: boolean | null } | null> | null, courses?: Array<{ __typename?: 'Course', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, validity_start_at?: string | null, validity_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, defaultPrice?: number | null, defaultPriceWithoutTax?: number | null, discount_price?: number | null, rightIds?: Array<number | null> | null, trial_flag?: boolean | null, trial_date?: string | null, trialTerm?: string | null, trial_term_unit?: string | null, trialTermText?: string | null, trialText?: string | null, trialDate?: string | null, ref_id?: string | null, valuePlan?: boolean | null, questionId?: number | null, trialCampaignFlag?: boolean | null, contractAllowed?: boolean | null, active_pricing?: { __typename?: 'CoursePrice', id?: string | null, price?: number | null, payment_amount?: number | null, validity_start_at?: string | null, validity_end_at?: string | null, campaignId?: number | null, campaign?: { __typename?: 'Campaign', id?: string | null, name?: string | null, header?: string | null, description?: string | null, validityStartAt?: string | null, validityEndAt?: string | null, discountApplyCount?: number | null } | null } | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name: string, thumbnailUrl?: string | null, description?: string | null, product_type?: string | null, sales_start_at?: string | null, sales_end_at?: string | null, price?: number | null, priceWithoutTax?: number | null, rightIds?: Array<number | null> | null, purchaseAllowed?: boolean | null } | null> | null } | null, entitlements?: Array<{ __typename?: 'Entitlement', id: string, user_id?: number | null, right_id?: number | null, start_at?: string | null, end_at?: string | null, exercised_at?: string | null, exercise_duration?: number | null, exercise_duration_unit?: number | null, exercisable_start_at?: string | null, exercisable_end_at?: string | null, suspend_flag?: boolean | null } | null> | null, uid2Token?: { __typename?: 'Uid2Token', token?: string | null } | null };

export type WebPageQueryVariables = Exact<{
  path?: InputMaybe<Scalars['String']['input']>;
}>;


export type WebPageQuery = { __typename?: 'Query', webPage?: { __typename?: 'WebPage', id?: number | null, content?: string | null, style?: string | null, script?: string | null, metatags?: { __typename?: 'MetaTags', robots?: string | null, canonicalUrl?: string | null, title?: string | null, keywords?: string | null, description?: string | null } | null } | null };

export const RoomConfigFieldsFragmentDoc = gql`
    fragment roomConfigFields on ChatRoomConfig {
  messageLimit
  pollingInterval
  initialMessageLimit
  userLimit
}
    `;
export const RoomCustomDataFieldsFragmentDoc = gql`
    fragment roomCustomDataFields on ChatRoomCustomData {
  type
  liveStartBefore
  liveEndAfter
  skipMessageThreshold
  appMessageLimit
  chatEndDateTime
}
    `;
export const RoomFieldsFragmentDoc = gql`
    fragment roomFields on ChatRoom {
  roomId
  config {
    ...roomConfigFields
  }
  customData {
    ...roomCustomDataFields
  }
}
    ${RoomConfigFieldsFragmentDoc}
${RoomCustomDataFieldsFragmentDoc}`;
export const SenderFieldsFragmentDoc = gql`
    fragment senderFields on Sender {
  displayName
  refId
  id
}
    `;
export const DeviceInfoFieldsFragmentDoc = gql`
    fragment deviceInfoFields on DeviceInfo {
  browser {
    major
    name
    version
  }
  deviceType
  deviceVendor
  isAndroid
  isBot
  isChrome
  isChromeOS
  isDesktop
  isEdge
  isFirefox
  isIE
  isIOS
  isIPad
  isIPhone
  isMac
  isMobile
  isSafari
  isTablet
  isWindows
  os {
    major
    name
    version
  }
  ua
  isApp
}
    `;
export const PageInfoFieldsFragmentDoc = gql`
    fragment pageInfoFields on PageInfo {
  offset
  limit
  totalCount
  hasNextPage
}
    `;
export const AdvertisingFieldsFragmentDoc = gql`
    fragment advertisingFields on Advert {
  id
  name
  description
  url
  targetBlank
  sort
  thumbnailUrl
  copyright
}
    `;
export const ChannelMetaFieldsFragmentDoc = gql`
    fragment channelMetaFields on ChannelMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
      contractAllowed
    }
  }
  genres {
    id
    name
  }
  meta_keywords
  meta_description
  live_flag
  video_flag
  heroImage {
    pc
    mb
  }
  distributor
}
    `;
export const EpisodeMetaFieldsFragmentDoc = gql`
    fragment episodeMetaFields on EpisodeMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  distributor
  cast
  staff
  duration
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  tvShow {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  area_control_flag
  is_live
  recommend
  start_over_flag
  catch_up_flag
  encode_start_date
  encode_end_date
  source_epg_id
  plalaFlag
}
    `;
export const LiveMetaFieldsFragmentDoc = gql`
    fragment liveMetaFields on LiveMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  parents {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  distributor
  cast
  staff
  duration
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  tvShow {
    ... on TVShowMeta {
      id
      name
      episode_num
    }
  }
  area_control_flag
  is_live
  recommend
  start_over_flag
  catch_up_flag
  encode_start_date
  encode_end_date
  source_epg_id
  plalaFlag
}
    `;
export const TvShowMetaFieldsFragmentDoc = gql`
    fragment tvShowMetaFields on TVShowMeta {
  id
  schema_key
  name
  header
  description
  thumbnailUrl
  copyright
  delivery_start_at
  delivery_end_at
  rights_control_type
  rating
  isAllowedRating
  rights {
    ... on Right {
      id
      name
      price
      rights_control_type
    }
  }
  genres {
    id
    name
  }
  production_country
  production_year
  cast
  staff
  episode_num
  meta_keywords
  meta_description
  channel {
    ... on ChannelMeta {
      id
      name
    }
  }
  distributor
}
    `;
export const EntitlementFieldsFragmentDoc = gql`
    fragment entitlementFields on Entitlement {
  id
  user_id
  right_id
  start_at
  end_at
  exercised_at
  exercise_duration
  exercise_duration_unit
  exercisable_start_at
  exercisable_end_at
  suspend_flag
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment campaignFields on Campaign {
  id
  name
  header
  description
  validityStartAt
  validityEndAt
  discountApplyCount
}
    `;
export const CoursePriceFieldsFragmentDoc = gql`
    fragment coursePriceFields on CoursePrice {
  id
  price
  payment_amount
  validity_start_at
  validity_end_at
  campaignId
  campaign {
    ...campaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export const CourseFieldsFragmentDoc = gql`
    fragment courseFields on Course {
  id
  name
  thumbnailUrl
  description
  validity_start_at
  validity_end_at
  price
  priceWithoutTax
  defaultPrice
  defaultPriceWithoutTax
  discount_price
  active_pricing {
    ... on CoursePrice {
      ...coursePriceFields
    }
  }
  rightIds
  trial_flag
  trial_date
  trialTerm
  trial_term_unit
  trialTermText
  trialText
  trialDate
  ref_id
  valuePlan
  questionId
  trialCampaignFlag
  contractAllowed
}
    ${CoursePriceFieldsFragmentDoc}`;
export const ProductFieldsFragmentDoc = gql`
    fragment productFields on Product {
  id
  name
  thumbnailUrl
  description
  product_type
  sales_start_at
  sales_end_at
  price
  priceWithoutTax
  rightIds
  purchaseAllowed
}
    `;
export const RightFieldsFragmentDoc = gql`
    fragment rightFields on Right {
  id
  name
  exercise_term
  exercise_term_unit
  view_term
  view_term_unit
  view_limit_date
  validity_start_at
  validity_end_at
  price
  discount_price
  isSvod
  package_type
  discount_description
  contractAllowed
}
    `;
export const RecommendArticleFieldsFragmentDoc = gql`
    fragment recommendArticleFields on RecommendArticle {
  courses {
    ... on Course {
      ...courseFields
    }
  }
  products {
    ... on Product {
      ...productFields
      right {
        ... on Right {
          ...rightFields
        }
      }
    }
  }
}
    ${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}`;
export const SubscriptionFieldsFragmentDoc = gql`
    fragment subscriptionFields on Subscription {
  subscription_id
  course_id
  payment_method_id
  payment_instrument_id
  initialTransactionAt
  nextTransactionAt
  status
  course {
    ... on Course {
      ...courseFields
    }
  }
  payment_instrument {
    values {
      card_number
      card_type
    }
  }
  withdraw_at
  trialStartAt
  trialEndAt
  entitlements {
    right_id
  }
  suspend_flag
}
    ${CourseFieldsFragmentDoc}`;
export const VoucherFildsFragmentDoc = gql`
    fragment voucherFilds on Voucher {
  id
  name
  description
  discountPrice
  limitPrice
  trialExtendTerm
  trialExtendTermUnit
  trialExtendEndOf
  validityStartAt
  validityEndAt
}
    `;
export const VoucherCodeFieldsFragmentDoc = gql`
    fragment voucherCodeFields on VoucherCode {
  id
  code
  voucherId
  validityStartAt
  validityEndAt
  expire_at
  isAvailable
  voucher {
    ...voucherFilds
  }
}
    ${VoucherFildsFragmentDoc}`;
export const EstimateFieldsFragmentDoc = gql`
    fragment estimateFields on SubscriptionEstimate {
  subscription {
    ...subscriptionFields
  }
  voucherCode {
    ...voucherCodeFields
  }
  coursePricings {
    ...coursePriceFields
  }
  paymentPrice {
    ...coursePriceFields
  }
  campaignPrice {
    ...coursePriceFields
  }
  error
}
    ${SubscriptionFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}
${CoursePriceFieldsFragmentDoc}`;
export const TermsFieldsFragmentDoc = gql`
    fragment termsFields on Term {
  id_key
  display_name
  required
  current_revision {
    unique_key
    number
    url
    agreement {
      agreement_id
      user_id
      term_id
      term_revision_number
    }
  }
}
    `;
export const UserFavoritesFieldsFragmentDoc = gql`
    fragment userFavoritesFields on UserFavorites {
  id
  metas {
    ... on EpisodeMeta {
      id
    }
    ... on LiveMeta {
      id
    }
    ... on TVShowMeta {
      id
    }
    ... on ChannelMeta {
      id
    }
  }
}
    `;
export const ProfileFieldsFragmentDoc = gql`
    fragment profileFields on ProfileUser {
  uuid
  id
  displayName: display_name
  birthday
  age
  sex
  ownerProfile
  needPasscode
  icon
  rating
}
    `;
export const AccountFieldsFragmentDoc = gql`
    fragment accountFields on AccountUser {
  id
  uuid
  displayName: display_name
  birthday
  age
  sex
  mailAddress: mail_address
  firstName: first_name
  lastName: last_name
  fullName
  rightsFreeFlag: rights_free_flag
  currentProfile {
    ...profileFields
  }
  profiles {
    ...profileFields
  }
  test_flg
  hashedUserId
  receiveAdvertisingMailType
}
    ${ProfileFieldsFragmentDoc}`;
export const AdvertisingDocument = gql`
    query Advertising($id: Int) {
  advertising(id: $id) {
    url
  }
}
    `;

/**
 * __useAdvertisingQuery__
 *
 * To run a query within a React component, call `useAdvertisingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvertisingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvertisingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvertisingQuery(baseOptions?: Apollo.QueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvertisingQuery, AdvertisingQueryVariables>(AdvertisingDocument, options);
      }
export function useAdvertisingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvertisingQuery, AdvertisingQueryVariables>(AdvertisingDocument, options);
        }
// @ts-ignore
export function useAdvertisingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>): Apollo.UseSuspenseQueryResult<AdvertisingQuery, AdvertisingQueryVariables>;
export function useAdvertisingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>): Apollo.UseSuspenseQueryResult<AdvertisingQuery | undefined, AdvertisingQueryVariables>;
export function useAdvertisingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvertisingQuery, AdvertisingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvertisingQuery, AdvertisingQueryVariables>(AdvertisingDocument, options);
        }
export type AdvertisingQueryHookResult = ReturnType<typeof useAdvertisingQuery>;
export type AdvertisingLazyQueryHookResult = ReturnType<typeof useAdvertisingLazyQuery>;
export type AdvertisingSuspenseQueryHookResult = ReturnType<typeof useAdvertisingSuspenseQuery>;
export type AdvertisingQueryResult = Apollo.QueryResult<AdvertisingQuery, AdvertisingQueryVariables>;
export const AppInitDocument = gql`
    query AppInit {
  deviceInfo {
    ...deviceInfoFields
  }
  user {
    ...accountFields
  }
  favorites: userFavorites {
    ...userFavoritesFields
  }
}
    ${DeviceInfoFieldsFragmentDoc}
${AccountFieldsFragmentDoc}
${UserFavoritesFieldsFragmentDoc}`;

/**
 * __useAppInitQuery__
 *
 * To run a query within a React component, call `useAppInitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInitQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppInitQuery(baseOptions?: Apollo.QueryHookOptions<AppInitQuery, AppInitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppInitQuery, AppInitQueryVariables>(AppInitDocument, options);
      }
export function useAppInitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppInitQuery, AppInitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppInitQuery, AppInitQueryVariables>(AppInitDocument, options);
        }
// @ts-ignore
export function useAppInitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppInitQuery, AppInitQueryVariables>): Apollo.UseSuspenseQueryResult<AppInitQuery, AppInitQueryVariables>;
export function useAppInitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInitQuery, AppInitQueryVariables>): Apollo.UseSuspenseQueryResult<AppInitQuery | undefined, AppInitQueryVariables>;
export function useAppInitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInitQuery, AppInitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppInitQuery, AppInitQueryVariables>(AppInitDocument, options);
        }
export type AppInitQueryHookResult = ReturnType<typeof useAppInitQuery>;
export type AppInitLazyQueryHookResult = ReturnType<typeof useAppInitLazyQuery>;
export type AppInitSuspenseQueryHookResult = ReturnType<typeof useAppInitSuspenseQuery>;
export type AppInitQueryResult = Apollo.QueryResult<AppInitQuery, AppInitQueryVariables>;
export const GenreAttributesDocument = gql`
    query GenreAttributes($ids: [Int]) {
  genreAttributes(ids: $ids) {
    attributes {
      name
      id
    }
  }
}
    `;

/**
 * __useGenreAttributesQuery__
 *
 * To run a query within a React component, call `useGenreAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenreAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenreAttributesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGenreAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GenreAttributesQuery, GenreAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenreAttributesQuery, GenreAttributesQueryVariables>(GenreAttributesDocument, options);
      }
export function useGenreAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenreAttributesQuery, GenreAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenreAttributesQuery, GenreAttributesQueryVariables>(GenreAttributesDocument, options);
        }
// @ts-ignore
export function useGenreAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenreAttributesQuery, GenreAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GenreAttributesQuery, GenreAttributesQueryVariables>;
export function useGenreAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenreAttributesQuery, GenreAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GenreAttributesQuery | undefined, GenreAttributesQueryVariables>;
export function useGenreAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenreAttributesQuery, GenreAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenreAttributesQuery, GenreAttributesQueryVariables>(GenreAttributesDocument, options);
        }
export type GenreAttributesQueryHookResult = ReturnType<typeof useGenreAttributesQuery>;
export type GenreAttributesLazyQueryHookResult = ReturnType<typeof useGenreAttributesLazyQuery>;
export type GenreAttributesSuspenseQueryHookResult = ReturnType<typeof useGenreAttributesSuspenseQuery>;
export type GenreAttributesQueryResult = Apollo.QueryResult<GenreAttributesQuery, GenreAttributesQueryVariables>;
export const CanvasDocument = gql`
    query canvas($idKey: String, $offset: Int, $limit: Int, $withMeta: Boolean = false) {
  canvas(idKey: $idKey, offset: $offset, limit: $limit) {
    data {
      type
      id
    }
    meta @include(if: $withMeta) {
      title
      robots
      keywords
      description
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useCanvasQuery__
 *
 * To run a query within a React component, call `useCanvasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasQuery({
 *   variables: {
 *      idKey: // value for 'idKey'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      withMeta: // value for 'withMeta'
 *   },
 * });
 */
export function useCanvasQuery(baseOptions?: Apollo.QueryHookOptions<CanvasQuery, CanvasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanvasQuery, CanvasQueryVariables>(CanvasDocument, options);
      }
export function useCanvasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanvasQuery, CanvasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanvasQuery, CanvasQueryVariables>(CanvasDocument, options);
        }
// @ts-ignore
export function useCanvasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanvasQuery, CanvasQueryVariables>): Apollo.UseSuspenseQueryResult<CanvasQuery, CanvasQueryVariables>;
export function useCanvasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasQuery, CanvasQueryVariables>): Apollo.UseSuspenseQueryResult<CanvasQuery | undefined, CanvasQueryVariables>;
export function useCanvasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasQuery, CanvasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanvasQuery, CanvasQueryVariables>(CanvasDocument, options);
        }
export type CanvasQueryHookResult = ReturnType<typeof useCanvasQuery>;
export type CanvasLazyQueryHookResult = ReturnType<typeof useCanvasLazyQuery>;
export type CanvasSuspenseQueryHookResult = ReturnType<typeof useCanvasSuspenseQuery>;
export type CanvasQueryResult = Apollo.QueryResult<CanvasQuery, CanvasQueryVariables>;
export const ChannelsWithContractStatusDocument = gql`
    query ChannelsWithContractStatus($offset: Int, $limit: Int, $filter: JSONObject, $sort: String, $uuid: String) {
  channelsWithContractStatus(
    offset: $offset
    limit: $limit
    filter: $filter
    sort: $sort
    uuid: $uuid
  ) {
    data {
      ... on ChannelMeta {
        ...channelMetaFields
      }
      contractStatus
      contractAllowed
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useChannelsWithContractStatusQuery__
 *
 * To run a query within a React component, call `useChannelsWithContractStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelsWithContractStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelsWithContractStatusQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useChannelsWithContractStatusQuery(baseOptions?: Apollo.QueryHookOptions<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>(ChannelsWithContractStatusDocument, options);
      }
export function useChannelsWithContractStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>(ChannelsWithContractStatusDocument, options);
        }
// @ts-ignore
export function useChannelsWithContractStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>;
export function useChannelsWithContractStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelsWithContractStatusQuery | undefined, ChannelsWithContractStatusQueryVariables>;
export function useChannelsWithContractStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>(ChannelsWithContractStatusDocument, options);
        }
export type ChannelsWithContractStatusQueryHookResult = ReturnType<typeof useChannelsWithContractStatusQuery>;
export type ChannelsWithContractStatusLazyQueryHookResult = ReturnType<typeof useChannelsWithContractStatusLazyQuery>;
export type ChannelsWithContractStatusSuspenseQueryHookResult = ReturnType<typeof useChannelsWithContractStatusSuspenseQuery>;
export type ChannelsWithContractStatusQueryResult = Apollo.QueryResult<ChannelsWithContractStatusQuery, ChannelsWithContractStatusQueryVariables>;
export const ChannelFeatureEpisodesDocument = gql`
    query ChannelFeatureEpisodes($id: Int, $offset: Int, $limit: Int) {
  channelFeatureEpisodes(id: $id, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useChannelFeatureEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelFeatureEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelFeatureEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelFeatureEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelFeatureEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>(ChannelFeatureEpisodesDocument, options);
      }
export function useChannelFeatureEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>(ChannelFeatureEpisodesDocument, options);
        }
// @ts-ignore
export function useChannelFeatureEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>;
export function useChannelFeatureEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelFeatureEpisodesQuery | undefined, ChannelFeatureEpisodesQueryVariables>;
export function useChannelFeatureEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>(ChannelFeatureEpisodesDocument, options);
        }
export type ChannelFeatureEpisodesQueryHookResult = ReturnType<typeof useChannelFeatureEpisodesQuery>;
export type ChannelFeatureEpisodesLazyQueryHookResult = ReturnType<typeof useChannelFeatureEpisodesLazyQuery>;
export type ChannelFeatureEpisodesSuspenseQueryHookResult = ReturnType<typeof useChannelFeatureEpisodesSuspenseQuery>;
export type ChannelFeatureEpisodesQueryResult = Apollo.QueryResult<ChannelFeatureEpisodesQuery, ChannelFeatureEpisodesQueryVariables>;
export const ChannelDetailDocument = gql`
    query ChannelDetail($id: Int, $withTabMenu: Boolean = false, $withEntitlement: Boolean = false) {
  channel: channelDetail(id: $id) {
    ... on ChannelMeta {
      ...channelMetaFields
    }
    contractAllowed
    tabMenu @include(if: $withTabMenu) {
      id
      title
      url
      values
    }
  }
  entitlements(metaId: $id) @include(if: $withEntitlement) {
    ...entitlementFields
  }
  course: courseByMetaId(metaId: $id) @include(if: $withEntitlement) {
    ...courseFields
  }
}
    ${ChannelMetaFieldsFragmentDoc}
${EntitlementFieldsFragmentDoc}
${CourseFieldsFragmentDoc}`;

/**
 * __useChannelDetailQuery__
 *
 * To run a query within a React component, call `useChannelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTabMenu: // value for 'withTabMenu'
 *      withEntitlement: // value for 'withEntitlement'
 *   },
 * });
 */
export function useChannelDetailQuery(baseOptions?: Apollo.QueryHookOptions<ChannelDetailQuery, ChannelDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelDetailQuery, ChannelDetailQueryVariables>(ChannelDetailDocument, options);
      }
export function useChannelDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelDetailQuery, ChannelDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelDetailQuery, ChannelDetailQueryVariables>(ChannelDetailDocument, options);
        }
// @ts-ignore
export function useChannelDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelDetailQuery, ChannelDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelDetailQuery, ChannelDetailQueryVariables>;
export function useChannelDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelDetailQuery, ChannelDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelDetailQuery | undefined, ChannelDetailQueryVariables>;
export function useChannelDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelDetailQuery, ChannelDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelDetailQuery, ChannelDetailQueryVariables>(ChannelDetailDocument, options);
        }
export type ChannelDetailQueryHookResult = ReturnType<typeof useChannelDetailQuery>;
export type ChannelDetailLazyQueryHookResult = ReturnType<typeof useChannelDetailLazyQuery>;
export type ChannelDetailSuspenseQueryHookResult = ReturnType<typeof useChannelDetailSuspenseQuery>;
export type ChannelDetailQueryResult = Apollo.QueryResult<ChannelDetailQuery, ChannelDetailQueryVariables>;
export const ChannelEpisodeSearchDocument = gql`
    query ChannelEpisodeSearch($keyword: String, $id: Int, $episodeType: EpisodeType, $offset: Int, $limit: Int) {
  channelEpisodeSearch(
    keyword: $keyword
    id: $id
    episodeType: $episodeType
    offset: $offset
    limit: $limit
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useChannelEpisodeSearchQuery__
 *
 * To run a query within a React component, call `useChannelEpisodeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelEpisodeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelEpisodeSearchQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      id: // value for 'id'
 *      episodeType: // value for 'episodeType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelEpisodeSearchQuery(baseOptions?: Apollo.QueryHookOptions<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>(ChannelEpisodeSearchDocument, options);
      }
export function useChannelEpisodeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>(ChannelEpisodeSearchDocument, options);
        }
// @ts-ignore
export function useChannelEpisodeSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>;
export function useChannelEpisodeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelEpisodeSearchQuery | undefined, ChannelEpisodeSearchQueryVariables>;
export function useChannelEpisodeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>(ChannelEpisodeSearchDocument, options);
        }
export type ChannelEpisodeSearchQueryHookResult = ReturnType<typeof useChannelEpisodeSearchQuery>;
export type ChannelEpisodeSearchLazyQueryHookResult = ReturnType<typeof useChannelEpisodeSearchLazyQuery>;
export type ChannelEpisodeSearchSuspenseQueryHookResult = ReturnType<typeof useChannelEpisodeSearchSuspenseQuery>;
export type ChannelEpisodeSearchQueryResult = Apollo.QueryResult<ChannelEpisodeSearchQuery, ChannelEpisodeSearchQueryVariables>;
export const ChannelLiveScheduleDocument = gql`
    query ChannelLiveSchedule($id: Int, $day: String, $offset: Int, $limit: Int) {
  channelLiveSchedule(id: $id, day: $day, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useChannelLiveScheduleQuery__
 *
 * To run a query within a React component, call `useChannelLiveScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLiveScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLiveScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      day: // value for 'day'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChannelLiveScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>(ChannelLiveScheduleDocument, options);
      }
export function useChannelLiveScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>(ChannelLiveScheduleDocument, options);
        }
// @ts-ignore
export function useChannelLiveScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>;
export function useChannelLiveScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelLiveScheduleQuery | undefined, ChannelLiveScheduleQueryVariables>;
export function useChannelLiveScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>(ChannelLiveScheduleDocument, options);
        }
export type ChannelLiveScheduleQueryHookResult = ReturnType<typeof useChannelLiveScheduleQuery>;
export type ChannelLiveScheduleLazyQueryHookResult = ReturnType<typeof useChannelLiveScheduleLazyQuery>;
export type ChannelLiveScheduleSuspenseQueryHookResult = ReturnType<typeof useChannelLiveScheduleSuspenseQuery>;
export type ChannelLiveScheduleQueryResult = Apollo.QueryResult<ChannelLiveScheduleQuery, ChannelLiveScheduleQueryVariables>;
export const ChannelLinearEpisodesDocument = gql`
    query ChannelLinearEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject) {
  channelLinearEpisodes(id: $id, offset: $offset, limit: $limit, filter: $filter) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useChannelLinearEpisodesQuery__
 *
 * To run a query within a React component, call `useChannelLinearEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelLinearEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelLinearEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChannelLinearEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>(ChannelLinearEpisodesDocument, options);
      }
export function useChannelLinearEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>(ChannelLinearEpisodesDocument, options);
        }
// @ts-ignore
export function useChannelLinearEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>;
export function useChannelLinearEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ChannelLinearEpisodesQuery | undefined, ChannelLinearEpisodesQueryVariables>;
export function useChannelLinearEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>(ChannelLinearEpisodesDocument, options);
        }
export type ChannelLinearEpisodesQueryHookResult = ReturnType<typeof useChannelLinearEpisodesQuery>;
export type ChannelLinearEpisodesLazyQueryHookResult = ReturnType<typeof useChannelLinearEpisodesLazyQuery>;
export type ChannelLinearEpisodesSuspenseQueryHookResult = ReturnType<typeof useChannelLinearEpisodesSuspenseQuery>;
export type ChannelLinearEpisodesQueryResult = Apollo.QueryResult<ChannelLinearEpisodesQuery, ChannelLinearEpisodesQueryVariables>;
export const ChatGetAgreementDocument = gql`
    query ChatGetAgreement {
  getChatGuideLineAgreement {
    agreement
  }
}
    `;

/**
 * __useChatGetAgreementQuery__
 *
 * To run a query within a React component, call `useChatGetAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetAgreementQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatGetAgreementQuery(baseOptions?: Apollo.QueryHookOptions<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>(ChatGetAgreementDocument, options);
      }
export function useChatGetAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>(ChatGetAgreementDocument, options);
        }
// @ts-ignore
export function useChatGetAgreementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>;
export function useChatGetAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetAgreementQuery | undefined, ChatGetAgreementQueryVariables>;
export function useChatGetAgreementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>(ChatGetAgreementDocument, options);
        }
export type ChatGetAgreementQueryHookResult = ReturnType<typeof useChatGetAgreementQuery>;
export type ChatGetAgreementLazyQueryHookResult = ReturnType<typeof useChatGetAgreementLazyQuery>;
export type ChatGetAgreementSuspenseQueryHookResult = ReturnType<typeof useChatGetAgreementSuspenseQuery>;
export type ChatGetAgreementQueryResult = Apollo.QueryResult<ChatGetAgreementQuery, ChatGetAgreementQueryVariables>;
export const ChatSetAgreementDocument = gql`
    mutation ChatSetAgreement {
  setChatGuideLineAgreement {
    agreement
  }
}
    `;
export type ChatSetAgreementMutationFn = Apollo.MutationFunction<ChatSetAgreementMutation, ChatSetAgreementMutationVariables>;

/**
 * __useChatSetAgreementMutation__
 *
 * To run a mutation, you first call `useChatSetAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatSetAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatSetAgreementMutation, { data, loading, error }] = useChatSetAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useChatSetAgreementMutation(baseOptions?: Apollo.MutationHookOptions<ChatSetAgreementMutation, ChatSetAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatSetAgreementMutation, ChatSetAgreementMutationVariables>(ChatSetAgreementDocument, options);
      }
export type ChatSetAgreementMutationHookResult = ReturnType<typeof useChatSetAgreementMutation>;
export type ChatSetAgreementMutationResult = Apollo.MutationResult<ChatSetAgreementMutation>;
export type ChatSetAgreementMutationOptions = Apollo.BaseMutationOptions<ChatSetAgreementMutation, ChatSetAgreementMutationVariables>;
export const ChatGetRoomsDocument = gql`
    query ChatGetRooms($metaId: Int) {
  getRooms(metaId: $metaId) {
    totalCount
    rooms {
      ...roomFields
    }
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useChatGetRoomsQuery__
 *
 * To run a query within a React component, call `useChatGetRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetRoomsQuery({
 *   variables: {
 *      metaId: // value for 'metaId'
 *   },
 * });
 */
export function useChatGetRoomsQuery(baseOptions?: Apollo.QueryHookOptions<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>(ChatGetRoomsDocument, options);
      }
export function useChatGetRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>(ChatGetRoomsDocument, options);
        }
// @ts-ignore
export function useChatGetRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>;
export function useChatGetRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetRoomsQuery | undefined, ChatGetRoomsQueryVariables>;
export function useChatGetRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>(ChatGetRoomsDocument, options);
        }
export type ChatGetRoomsQueryHookResult = ReturnType<typeof useChatGetRoomsQuery>;
export type ChatGetRoomsLazyQueryHookResult = ReturnType<typeof useChatGetRoomsLazyQuery>;
export type ChatGetRoomsSuspenseQueryHookResult = ReturnType<typeof useChatGetRoomsSuspenseQuery>;
export type ChatGetRoomsQueryResult = Apollo.QueryResult<ChatGetRoomsQuery, ChatGetRoomsQueryVariables>;
export const ChatGetRoomTokenDocument = gql`
    query ChatGetRoomToken($roomId: String) {
  getRoomToken(roomId: $roomId) {
    token
  }
}
    `;

/**
 * __useChatGetRoomTokenQuery__
 *
 * To run a query within a React component, call `useChatGetRoomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetRoomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetRoomTokenQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useChatGetRoomTokenQuery(baseOptions?: Apollo.QueryHookOptions<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>(ChatGetRoomTokenDocument, options);
      }
export function useChatGetRoomTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>(ChatGetRoomTokenDocument, options);
        }
// @ts-ignore
export function useChatGetRoomTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>;
export function useChatGetRoomTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetRoomTokenQuery | undefined, ChatGetRoomTokenQueryVariables>;
export function useChatGetRoomTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>(ChatGetRoomTokenDocument, options);
        }
export type ChatGetRoomTokenQueryHookResult = ReturnType<typeof useChatGetRoomTokenQuery>;
export type ChatGetRoomTokenLazyQueryHookResult = ReturnType<typeof useChatGetRoomTokenLazyQuery>;
export type ChatGetRoomTokenSuspenseQueryHookResult = ReturnType<typeof useChatGetRoomTokenSuspenseQuery>;
export type ChatGetRoomTokenQueryResult = Apollo.QueryResult<ChatGetRoomTokenQuery, ChatGetRoomTokenQueryVariables>;
export const ChatCreateUserDocument = gql`
    mutation ChatCreateUser($roomId: String, $metaId: Int) {
  createUser(roomId: $roomId, metaId: $metaId) {
    roomId
    refId
    id
  }
}
    `;
export type ChatCreateUserMutationFn = Apollo.MutationFunction<ChatCreateUserMutation, ChatCreateUserMutationVariables>;

/**
 * __useChatCreateUserMutation__
 *
 * To run a mutation, you first call `useChatCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatCreateUserMutation, { data, loading, error }] = useChatCreateUserMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      metaId: // value for 'metaId'
 *   },
 * });
 */
export function useChatCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<ChatCreateUserMutation, ChatCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatCreateUserMutation, ChatCreateUserMutationVariables>(ChatCreateUserDocument, options);
      }
export type ChatCreateUserMutationHookResult = ReturnType<typeof useChatCreateUserMutation>;
export type ChatCreateUserMutationResult = Apollo.MutationResult<ChatCreateUserMutation>;
export type ChatCreateUserMutationOptions = Apollo.BaseMutationOptions<ChatCreateUserMutation, ChatCreateUserMutationVariables>;
export const ChatGetUserTokenDocument = gql`
    query ChatGetUserToken($roomId: String, $userId: String) {
  getUserToken(roomId: $roomId, userId: $userId) {
    token
  }
}
    `;

/**
 * __useChatGetUserTokenQuery__
 *
 * To run a query within a React component, call `useChatGetUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatGetUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatGetUserTokenQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatGetUserTokenQuery(baseOptions?: Apollo.QueryHookOptions<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>(ChatGetUserTokenDocument, options);
      }
export function useChatGetUserTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>(ChatGetUserTokenDocument, options);
        }
// @ts-ignore
export function useChatGetUserTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>;
export function useChatGetUserTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>): Apollo.UseSuspenseQueryResult<ChatGetUserTokenQuery | undefined, ChatGetUserTokenQueryVariables>;
export function useChatGetUserTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>(ChatGetUserTokenDocument, options);
        }
export type ChatGetUserTokenQueryHookResult = ReturnType<typeof useChatGetUserTokenQuery>;
export type ChatGetUserTokenLazyQueryHookResult = ReturnType<typeof useChatGetUserTokenLazyQuery>;
export type ChatGetUserTokenSuspenseQueryHookResult = ReturnType<typeof useChatGetUserTokenSuspenseQuery>;
export type ChatGetUserTokenQueryResult = Apollo.QueryResult<ChatGetUserTokenQuery, ChatGetUserTokenQueryVariables>;
export const ChatPostMessageDocument = gql`
    mutation ChatPostMessage($roomId: String, $userId: String, $message: String, $refId: String, $displayName: String, $token: String) {
  postChatMessage(
    roomId: $roomId
    userId: $userId
    message: $message
    refId: $refId
    displayName: $displayName
    token: $token
  ) {
    message
    sender {
      ...senderFields
    }
    roomId
    isNGMessage
    id
  }
}
    ${SenderFieldsFragmentDoc}`;
export type ChatPostMessageMutationFn = Apollo.MutationFunction<ChatPostMessageMutation, ChatPostMessageMutationVariables>;

/**
 * __useChatPostMessageMutation__
 *
 * To run a mutation, you first call `useChatPostMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPostMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPostMessageMutation, { data, loading, error }] = useChatPostMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      userId: // value for 'userId'
 *      message: // value for 'message'
 *      refId: // value for 'refId'
 *      displayName: // value for 'displayName'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useChatPostMessageMutation(baseOptions?: Apollo.MutationHookOptions<ChatPostMessageMutation, ChatPostMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatPostMessageMutation, ChatPostMessageMutationVariables>(ChatPostMessageDocument, options);
      }
export type ChatPostMessageMutationHookResult = ReturnType<typeof useChatPostMessageMutation>;
export type ChatPostMessageMutationResult = Apollo.MutationResult<ChatPostMessageMutation>;
export type ChatPostMessageMutationOptions = Apollo.BaseMutationOptions<ChatPostMessageMutation, ChatPostMessageMutationVariables>;
export const ChatDeleteMessageDocument = gql`
    mutation ChatDeleteMessage($roomId: String, $messageId: String) {
  deleteChatMessage(roomId: $roomId, messageId: $messageId) {
    result
  }
}
    `;
export type ChatDeleteMessageMutationFn = Apollo.MutationFunction<ChatDeleteMessageMutation, ChatDeleteMessageMutationVariables>;

/**
 * __useChatDeleteMessageMutation__
 *
 * To run a mutation, you first call `useChatDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatDeleteMessageMutation, { data, loading, error }] = useChatDeleteMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useChatDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<ChatDeleteMessageMutation, ChatDeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatDeleteMessageMutation, ChatDeleteMessageMutationVariables>(ChatDeleteMessageDocument, options);
      }
export type ChatDeleteMessageMutationHookResult = ReturnType<typeof useChatDeleteMessageMutation>;
export type ChatDeleteMessageMutationResult = Apollo.MutationResult<ChatDeleteMessageMutation>;
export type ChatDeleteMessageMutationOptions = Apollo.BaseMutationOptions<ChatDeleteMessageMutation, ChatDeleteMessageMutationVariables>;
export const ChatReportMessageDocument = gql`
    mutation ChatReportMessage($roomId: String, $messageId: String, $reason: String) {
  reportChatMessage(roomId: $roomId, messageId: $messageId, reason: $reason) {
    result
  }
}
    `;
export type ChatReportMessageMutationFn = Apollo.MutationFunction<ChatReportMessageMutation, ChatReportMessageMutationVariables>;

/**
 * __useChatReportMessageMutation__
 *
 * To run a mutation, you first call `useChatReportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatReportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatReportMessageMutation, { data, loading, error }] = useChatReportMessageMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      messageId: // value for 'messageId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useChatReportMessageMutation(baseOptions?: Apollo.MutationHookOptions<ChatReportMessageMutation, ChatReportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatReportMessageMutation, ChatReportMessageMutationVariables>(ChatReportMessageDocument, options);
      }
export type ChatReportMessageMutationHookResult = ReturnType<typeof useChatReportMessageMutation>;
export type ChatReportMessageMutationResult = Apollo.MutationResult<ChatReportMessageMutation>;
export type ChatReportMessageMutationOptions = Apollo.BaseMutationOptions<ChatReportMessageMutation, ChatReportMessageMutationVariables>;
export const TvShowEpisodesDocument = gql`
    query TvShowEpisodes($id: Int, $offset: Int, $limit: Int, $filter: JSONObject, $sort: JSONObject) {
  children(id: $id, offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    data {
      ...episodeMetaFields
      ...liveMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useTvShowEpisodesQuery__
 *
 * To run a query within a React component, call `useTvShowEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTvShowEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTvShowEpisodesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTvShowEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>(TvShowEpisodesDocument, options);
      }
export function useTvShowEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>(TvShowEpisodesDocument, options);
        }
// @ts-ignore
export function useTvShowEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>;
export function useTvShowEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<TvShowEpisodesQuery | undefined, TvShowEpisodesQueryVariables>;
export function useTvShowEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>(TvShowEpisodesDocument, options);
        }
export type TvShowEpisodesQueryHookResult = ReturnType<typeof useTvShowEpisodesQuery>;
export type TvShowEpisodesLazyQueryHookResult = ReturnType<typeof useTvShowEpisodesLazyQuery>;
export type TvShowEpisodesSuspenseQueryHookResult = ReturnType<typeof useTvShowEpisodesSuspenseQuery>;
export type TvShowEpisodesQueryResult = Apollo.QueryResult<TvShowEpisodesQuery, TvShowEpisodesQueryVariables>;
export const CourseByRightIdDocument = gql`
    query CourseByRightId($rightId: Int) {
  courseByRightId(rightId: $rightId) {
    ...courseFields
  }
}
    ${CourseFieldsFragmentDoc}`;

/**
 * __useCourseByRightIdQuery__
 *
 * To run a query within a React component, call `useCourseByRightIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByRightIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByRightIdQuery({
 *   variables: {
 *      rightId: // value for 'rightId'
 *   },
 * });
 */
export function useCourseByRightIdQuery(baseOptions?: Apollo.QueryHookOptions<CourseByRightIdQuery, CourseByRightIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseByRightIdQuery, CourseByRightIdQueryVariables>(CourseByRightIdDocument, options);
      }
export function useCourseByRightIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseByRightIdQuery, CourseByRightIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseByRightIdQuery, CourseByRightIdQueryVariables>(CourseByRightIdDocument, options);
        }
// @ts-ignore
export function useCourseByRightIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseByRightIdQuery, CourseByRightIdQueryVariables>): Apollo.UseSuspenseQueryResult<CourseByRightIdQuery, CourseByRightIdQueryVariables>;
export function useCourseByRightIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseByRightIdQuery, CourseByRightIdQueryVariables>): Apollo.UseSuspenseQueryResult<CourseByRightIdQuery | undefined, CourseByRightIdQueryVariables>;
export function useCourseByRightIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseByRightIdQuery, CourseByRightIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseByRightIdQuery, CourseByRightIdQueryVariables>(CourseByRightIdDocument, options);
        }
export type CourseByRightIdQueryHookResult = ReturnType<typeof useCourseByRightIdQuery>;
export type CourseByRightIdLazyQueryHookResult = ReturnType<typeof useCourseByRightIdLazyQuery>;
export type CourseByRightIdSuspenseQueryHookResult = ReturnType<typeof useCourseByRightIdSuspenseQuery>;
export type CourseByRightIdQueryResult = Apollo.QueryResult<CourseByRightIdQuery, CourseByRightIdQueryVariables>;
export const CourseByIdDocument = gql`
    query CourseById($courseId: Int) {
  course: courseById(courseId: $courseId) {
    ... on Course {
      ...courseFields
    }
  }
}
    ${CourseFieldsFragmentDoc}`;

/**
 * __useCourseByIdQuery__
 *
 * To run a query within a React component, call `useCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCourseByIdQuery(baseOptions?: Apollo.QueryHookOptions<CourseByIdQuery, CourseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseByIdQuery, CourseByIdQueryVariables>(CourseByIdDocument, options);
      }
export function useCourseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseByIdQuery, CourseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseByIdQuery, CourseByIdQueryVariables>(CourseByIdDocument, options);
        }
// @ts-ignore
export function useCourseByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseByIdQuery, CourseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CourseByIdQuery, CourseByIdQueryVariables>;
export function useCourseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseByIdQuery, CourseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CourseByIdQuery | undefined, CourseByIdQueryVariables>;
export function useCourseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseByIdQuery, CourseByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseByIdQuery, CourseByIdQueryVariables>(CourseByIdDocument, options);
        }
export type CourseByIdQueryHookResult = ReturnType<typeof useCourseByIdQuery>;
export type CourseByIdLazyQueryHookResult = ReturnType<typeof useCourseByIdLazyQuery>;
export type CourseByIdSuspenseQueryHookResult = ReturnType<typeof useCourseByIdSuspenseQuery>;
export type CourseByIdQueryResult = Apollo.QueryResult<CourseByIdQuery, CourseByIdQueryVariables>;
export const DeviceInfoDocument = gql`
    query DeviceInfo {
  deviceInfo {
    ...deviceInfoFields
  }
}
    ${DeviceInfoFieldsFragmentDoc}`;

/**
 * __useDeviceInfoQuery__
 *
 * To run a query within a React component, call `useDeviceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceInfoQuery(baseOptions?: Apollo.QueryHookOptions<DeviceInfoQuery, DeviceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceInfoQuery, DeviceInfoQueryVariables>(DeviceInfoDocument, options);
      }
export function useDeviceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceInfoQuery, DeviceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceInfoQuery, DeviceInfoQueryVariables>(DeviceInfoDocument, options);
        }
// @ts-ignore
export function useDeviceInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeviceInfoQuery, DeviceInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceInfoQuery, DeviceInfoQueryVariables>;
export function useDeviceInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceInfoQuery, DeviceInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DeviceInfoQuery | undefined, DeviceInfoQueryVariables>;
export function useDeviceInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceInfoQuery, DeviceInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceInfoQuery, DeviceInfoQueryVariables>(DeviceInfoDocument, options);
        }
export type DeviceInfoQueryHookResult = ReturnType<typeof useDeviceInfoQuery>;
export type DeviceInfoLazyQueryHookResult = ReturnType<typeof useDeviceInfoLazyQuery>;
export type DeviceInfoSuspenseQueryHookResult = ReturnType<typeof useDeviceInfoSuspenseQuery>;
export type DeviceInfoQueryResult = Apollo.QueryResult<DeviceInfoQuery, DeviceInfoQueryVariables>;
export const GetEntitledStoreEpisodesDocument = gql`
    query GetEntitledStoreEpisodes($offset: Int, $limit: Int) {
  getEntitledStoreEpisodes(offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useGetEntitledStoreEpisodesQuery__
 *
 * To run a query within a React component, call `useGetEntitledStoreEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitledStoreEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitledStoreEpisodesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEntitledStoreEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>(GetEntitledStoreEpisodesDocument, options);
      }
export function useGetEntitledStoreEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>(GetEntitledStoreEpisodesDocument, options);
        }
// @ts-ignore
export function useGetEntitledStoreEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>;
export function useGetEntitledStoreEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEntitledStoreEpisodesQuery | undefined, GetEntitledStoreEpisodesQueryVariables>;
export function useGetEntitledStoreEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>(GetEntitledStoreEpisodesDocument, options);
        }
export type GetEntitledStoreEpisodesQueryHookResult = ReturnType<typeof useGetEntitledStoreEpisodesQuery>;
export type GetEntitledStoreEpisodesLazyQueryHookResult = ReturnType<typeof useGetEntitledStoreEpisodesLazyQuery>;
export type GetEntitledStoreEpisodesSuspenseQueryHookResult = ReturnType<typeof useGetEntitledStoreEpisodesSuspenseQuery>;
export type GetEntitledStoreEpisodesQueryResult = Apollo.QueryResult<GetEntitledStoreEpisodesQuery, GetEntitledStoreEpisodesQueryVariables>;
export const GenrePaletteEpisodesDocument = gql`
    query GenrePaletteEpisodes($channel: Int, $genre: [Int], $offset: Int, $limit: Int, $sortOrder: String, $type: String) {
  genrePaletteEpisodes(
    channel: $channel
    genre: $genre
    offset: $offset
    limit: $limit
    sortOrder: $sortOrder
    type: $type
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useGenrePaletteEpisodesQuery__
 *
 * To run a query within a React component, call `useGenrePaletteEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenrePaletteEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenrePaletteEpisodesQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      genre: // value for 'genre'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortOrder: // value for 'sortOrder'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenrePaletteEpisodesQuery(baseOptions?: Apollo.QueryHookOptions<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>(GenrePaletteEpisodesDocument, options);
      }
export function useGenrePaletteEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>(GenrePaletteEpisodesDocument, options);
        }
// @ts-ignore
export function useGenrePaletteEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>;
export function useGenrePaletteEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<GenrePaletteEpisodesQuery | undefined, GenrePaletteEpisodesQueryVariables>;
export function useGenrePaletteEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>(GenrePaletteEpisodesDocument, options);
        }
export type GenrePaletteEpisodesQueryHookResult = ReturnType<typeof useGenrePaletteEpisodesQuery>;
export type GenrePaletteEpisodesLazyQueryHookResult = ReturnType<typeof useGenrePaletteEpisodesLazyQuery>;
export type GenrePaletteEpisodesSuspenseQueryHookResult = ReturnType<typeof useGenrePaletteEpisodesSuspenseQuery>;
export type GenrePaletteEpisodesQueryResult = Apollo.QueryResult<GenrePaletteEpisodesQuery, GenrePaletteEpisodesQueryVariables>;
export const EntitledDocument = gql`
    query Entitled($channelId: Int, $contentType: String, $offset: Int, $limit: Int) {
  entitled(
    channelId: $channelId
    contentType: $contentType
    offset: $offset
    limit: $limit
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
      ... on ChannelMeta {
        ...channelMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useEntitledQuery__
 *
 * To run a query within a React component, call `useEntitledQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      contentType: // value for 'contentType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEntitledQuery(baseOptions?: Apollo.QueryHookOptions<EntitledQuery, EntitledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitledQuery, EntitledQueryVariables>(EntitledDocument, options);
      }
export function useEntitledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitledQuery, EntitledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitledQuery, EntitledQueryVariables>(EntitledDocument, options);
        }
// @ts-ignore
export function useEntitledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitledQuery, EntitledQueryVariables>): Apollo.UseSuspenseQueryResult<EntitledQuery, EntitledQueryVariables>;
export function useEntitledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitledQuery, EntitledQueryVariables>): Apollo.UseSuspenseQueryResult<EntitledQuery | undefined, EntitledQueryVariables>;
export function useEntitledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitledQuery, EntitledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitledQuery, EntitledQueryVariables>(EntitledDocument, options);
        }
export type EntitledQueryHookResult = ReturnType<typeof useEntitledQuery>;
export type EntitledLazyQueryHookResult = ReturnType<typeof useEntitledLazyQuery>;
export type EntitledSuspenseQueryHookResult = ReturnType<typeof useEntitledSuspenseQuery>;
export type EntitledQueryResult = Apollo.QueryResult<EntitledQuery, EntitledQueryVariables>;
export const HtmlSnippetDocument = gql`
    query HtmlSnippet($id: Int, $idKey: String) {
  htmlSnippet(id: $id, idKey: $idKey) {
    id
    content
    style
    javascript
  }
}
    `;

/**
 * __useHtmlSnippetQuery__
 *
 * To run a query within a React component, call `useHtmlSnippetQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtmlSnippetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtmlSnippetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      idKey: // value for 'idKey'
 *   },
 * });
 */
export function useHtmlSnippetQuery(baseOptions?: Apollo.QueryHookOptions<HtmlSnippetQuery, HtmlSnippetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HtmlSnippetQuery, HtmlSnippetQueryVariables>(HtmlSnippetDocument, options);
      }
export function useHtmlSnippetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HtmlSnippetQuery, HtmlSnippetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HtmlSnippetQuery, HtmlSnippetQueryVariables>(HtmlSnippetDocument, options);
        }
// @ts-ignore
export function useHtmlSnippetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HtmlSnippetQuery, HtmlSnippetQueryVariables>): Apollo.UseSuspenseQueryResult<HtmlSnippetQuery, HtmlSnippetQueryVariables>;
export function useHtmlSnippetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HtmlSnippetQuery, HtmlSnippetQueryVariables>): Apollo.UseSuspenseQueryResult<HtmlSnippetQuery | undefined, HtmlSnippetQueryVariables>;
export function useHtmlSnippetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HtmlSnippetQuery, HtmlSnippetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HtmlSnippetQuery, HtmlSnippetQueryVariables>(HtmlSnippetDocument, options);
        }
export type HtmlSnippetQueryHookResult = ReturnType<typeof useHtmlSnippetQuery>;
export type HtmlSnippetLazyQueryHookResult = ReturnType<typeof useHtmlSnippetLazyQuery>;
export type HtmlSnippetSuspenseQueryHookResult = ReturnType<typeof useHtmlSnippetSuspenseQuery>;
export type HtmlSnippetQueryResult = Apollo.QueryResult<HtmlSnippetQuery, HtmlSnippetQueryVariables>;
export const IdcTokenEndPointDocument = gql`
    mutation IdcTokenEndPoint($code: String, $redirectUri: String) {
  idcTokenEndPoint(code: $code, redirectUri: $redirectUri) {
    access_token
    expires_in
    refresh_token
    scope
    error
    error_description
    interval
  }
}
    `;
export type IdcTokenEndPointMutationFn = Apollo.MutationFunction<IdcTokenEndPointMutation, IdcTokenEndPointMutationVariables>;

/**
 * __useIdcTokenEndPointMutation__
 *
 * To run a mutation, you first call `useIdcTokenEndPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenEndPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idcTokenEndPointMutation, { data, loading, error }] = useIdcTokenEndPointMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useIdcTokenEndPointMutation(baseOptions?: Apollo.MutationHookOptions<IdcTokenEndPointMutation, IdcTokenEndPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdcTokenEndPointMutation, IdcTokenEndPointMutationVariables>(IdcTokenEndPointDocument, options);
      }
export type IdcTokenEndPointMutationHookResult = ReturnType<typeof useIdcTokenEndPointMutation>;
export type IdcTokenEndPointMutationResult = Apollo.MutationResult<IdcTokenEndPointMutation>;
export type IdcTokenEndPointMutationOptions = Apollo.BaseMutationOptions<IdcTokenEndPointMutation, IdcTokenEndPointMutationVariables>;
export const IdcUserInfoEndPointDocument = gql`
    query IdcUserInfoEndPoint {
  idcUserInfoEndPoint {
    sub
    iss
    aud
    email
    name
    namekana
    gender
    birthdate
  }
}
    `;

/**
 * __useIdcUserInfoEndPointQuery__
 *
 * To run a query within a React component, call `useIdcUserInfoEndPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcUserInfoEndPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcUserInfoEndPointQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdcUserInfoEndPointQuery(baseOptions?: Apollo.QueryHookOptions<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>(IdcUserInfoEndPointDocument, options);
      }
export function useIdcUserInfoEndPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>(IdcUserInfoEndPointDocument, options);
        }
// @ts-ignore
export function useIdcUserInfoEndPointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>): Apollo.UseSuspenseQueryResult<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>;
export function useIdcUserInfoEndPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>): Apollo.UseSuspenseQueryResult<IdcUserInfoEndPointQuery | undefined, IdcUserInfoEndPointQueryVariables>;
export function useIdcUserInfoEndPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>(IdcUserInfoEndPointDocument, options);
        }
export type IdcUserInfoEndPointQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointQuery>;
export type IdcUserInfoEndPointLazyQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointLazyQuery>;
export type IdcUserInfoEndPointSuspenseQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointSuspenseQuery>;
export type IdcUserInfoEndPointQueryResult = Apollo.QueryResult<IdcUserInfoEndPointQuery, IdcUserInfoEndPointQueryVariables>;
export const IdcUserInfoEndPointAgeValidateDocument = gql`
    query IdcUserInfoEndPointAgeValidate {
  idcUserInfoEndPointAgeValidate {
    sub
    iss
    aud
    email
    name
    namekana
    gender
    birthdate
  }
}
    `;

/**
 * __useIdcUserInfoEndPointAgeValidateQuery__
 *
 * To run a query within a React component, call `useIdcUserInfoEndPointAgeValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcUserInfoEndPointAgeValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcUserInfoEndPointAgeValidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdcUserInfoEndPointAgeValidateQuery(baseOptions?: Apollo.QueryHookOptions<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>(IdcUserInfoEndPointAgeValidateDocument, options);
      }
export function useIdcUserInfoEndPointAgeValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>(IdcUserInfoEndPointAgeValidateDocument, options);
        }
// @ts-ignore
export function useIdcUserInfoEndPointAgeValidateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>): Apollo.UseSuspenseQueryResult<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>;
export function useIdcUserInfoEndPointAgeValidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>): Apollo.UseSuspenseQueryResult<IdcUserInfoEndPointAgeValidateQuery | undefined, IdcUserInfoEndPointAgeValidateQueryVariables>;
export function useIdcUserInfoEndPointAgeValidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>(IdcUserInfoEndPointAgeValidateDocument, options);
        }
export type IdcUserInfoEndPointAgeValidateQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointAgeValidateQuery>;
export type IdcUserInfoEndPointAgeValidateLazyQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointAgeValidateLazyQuery>;
export type IdcUserInfoEndPointAgeValidateSuspenseQueryHookResult = ReturnType<typeof useIdcUserInfoEndPointAgeValidateSuspenseQuery>;
export type IdcUserInfoEndPointAgeValidateQueryResult = Apollo.QueryResult<IdcUserInfoEndPointAgeValidateQuery, IdcUserInfoEndPointAgeValidateQueryVariables>;
export const IdcTokenVerifyEndPointDocument = gql`
    query IdcTokenVerifyEndPoint {
  idcTokenVerifyEndPoint {
    access_token
    token_type
    expires_in
    user_id
    elipsis_flg
    client_id
  }
}
    `;

/**
 * __useIdcTokenVerifyEndPointQuery__
 *
 * To run a query within a React component, call `useIdcTokenVerifyEndPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenVerifyEndPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdcTokenVerifyEndPointQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdcTokenVerifyEndPointQuery(baseOptions?: Apollo.QueryHookOptions<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>(IdcTokenVerifyEndPointDocument, options);
      }
export function useIdcTokenVerifyEndPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>(IdcTokenVerifyEndPointDocument, options);
        }
// @ts-ignore
export function useIdcTokenVerifyEndPointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>): Apollo.UseSuspenseQueryResult<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>;
export function useIdcTokenVerifyEndPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>): Apollo.UseSuspenseQueryResult<IdcTokenVerifyEndPointQuery | undefined, IdcTokenVerifyEndPointQueryVariables>;
export function useIdcTokenVerifyEndPointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>(IdcTokenVerifyEndPointDocument, options);
        }
export type IdcTokenVerifyEndPointQueryHookResult = ReturnType<typeof useIdcTokenVerifyEndPointQuery>;
export type IdcTokenVerifyEndPointLazyQueryHookResult = ReturnType<typeof useIdcTokenVerifyEndPointLazyQuery>;
export type IdcTokenVerifyEndPointSuspenseQueryHookResult = ReturnType<typeof useIdcTokenVerifyEndPointSuspenseQuery>;
export type IdcTokenVerifyEndPointQueryResult = Apollo.QueryResult<IdcTokenVerifyEndPointQuery, IdcTokenVerifyEndPointQueryVariables>;
export const InformationsDocument = gql`
    query Informations($key: String, $offset: Int, $limit: Int) {
  informations(key: $key, offset: $offset, limit: $limit) {
    data {
      id
      title
      url
      targetBlank
      date
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useInformationsQuery__
 *
 * To run a query within a React component, call `useInformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformationsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInformationsQuery(baseOptions?: Apollo.QueryHookOptions<InformationsQuery, InformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InformationsQuery, InformationsQueryVariables>(InformationsDocument, options);
      }
export function useInformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InformationsQuery, InformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InformationsQuery, InformationsQueryVariables>(InformationsDocument, options);
        }
// @ts-ignore
export function useInformationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InformationsQuery, InformationsQueryVariables>): Apollo.UseSuspenseQueryResult<InformationsQuery, InformationsQueryVariables>;
export function useInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InformationsQuery, InformationsQueryVariables>): Apollo.UseSuspenseQueryResult<InformationsQuery | undefined, InformationsQueryVariables>;
export function useInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InformationsQuery, InformationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InformationsQuery, InformationsQueryVariables>(InformationsDocument, options);
        }
export type InformationsQueryHookResult = ReturnType<typeof useInformationsQuery>;
export type InformationsLazyQueryHookResult = ReturnType<typeof useInformationsLazyQuery>;
export type InformationsSuspenseQueryHookResult = ReturnType<typeof useInformationsSuspenseQuery>;
export type InformationsQueryResult = Apollo.QueryResult<InformationsQuery, InformationsQueryVariables>;
export const InquiryDocument = gql`
    mutation Inquiry($name: String!, $mailAddress: String!, $membersId: String, $pastSpooxId: String, $subject: String!, $body: String!, $comment: String!) {
  sendInquiryMail(
    name: $name
    mailAddress: $mailAddress
    membersId: $membersId
    pastSpooxId: $pastSpooxId
    subject: $subject
    body: $body
    comment: $comment
  ) {
    result
  }
}
    `;
export type InquiryMutationFn = Apollo.MutationFunction<InquiryMutation, InquiryMutationVariables>;

/**
 * __useInquiryMutation__
 *
 * To run a mutation, you first call `useInquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inquiryMutation, { data, loading, error }] = useInquiryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      mailAddress: // value for 'mailAddress'
 *      membersId: // value for 'membersId'
 *      pastSpooxId: // value for 'pastSpooxId'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useInquiryMutation(baseOptions?: Apollo.MutationHookOptions<InquiryMutation, InquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InquiryMutation, InquiryMutationVariables>(InquiryDocument, options);
      }
export type InquiryMutationHookResult = ReturnType<typeof useInquiryMutation>;
export type InquiryMutationResult = Apollo.MutationResult<InquiryMutation>;
export type InquiryMutationOptions = Apollo.BaseMutationOptions<InquiryMutation, InquiryMutationVariables>;
export const ProductOrdersDocument = gql`
    query ProductOrders($with_order: Boolean, $with_payment_instrument: Boolean, $with_entitlements: Boolean, $type: String) {
  productOrders(
    with_order: $with_order
    with_payment_instrument: $with_payment_instrument
    with_entitlements: $with_entitlements
    type: $type
  ) {
    data {
      name
      order_id
      created_at
      order {
        finished_at
        payment_amount
        payment_instrument {
          payment_method_id
          values {
            card_type
            card_number
          }
        }
      }
      entitlements {
        end_at
        right_id
      }
    }
  }
}
    `;

/**
 * __useProductOrdersQuery__
 *
 * To run a query within a React component, call `useProductOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOrdersQuery({
 *   variables: {
 *      with_order: // value for 'with_order'
 *      with_payment_instrument: // value for 'with_payment_instrument'
 *      with_entitlements: // value for 'with_entitlements'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProductOrdersQuery(baseOptions?: Apollo.QueryHookOptions<ProductOrdersQuery, ProductOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductOrdersQuery, ProductOrdersQueryVariables>(ProductOrdersDocument, options);
      }
export function useProductOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductOrdersQuery, ProductOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductOrdersQuery, ProductOrdersQueryVariables>(ProductOrdersDocument, options);
        }
// @ts-ignore
export function useProductOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductOrdersQuery, ProductOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<ProductOrdersQuery, ProductOrdersQueryVariables>;
export function useProductOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductOrdersQuery, ProductOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<ProductOrdersQuery | undefined, ProductOrdersQueryVariables>;
export function useProductOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductOrdersQuery, ProductOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductOrdersQuery, ProductOrdersQueryVariables>(ProductOrdersDocument, options);
        }
export type ProductOrdersQueryHookResult = ReturnType<typeof useProductOrdersQuery>;
export type ProductOrdersLazyQueryHookResult = ReturnType<typeof useProductOrdersLazyQuery>;
export type ProductOrdersSuspenseQueryHookResult = ReturnType<typeof useProductOrdersSuspenseQuery>;
export type ProductOrdersQueryResult = Apollo.QueryResult<ProductOrdersQuery, ProductOrdersQueryVariables>;
export const OrdersDocument = gql`
    query Orders($offset: Int, $limit: Int, $year: Int) {
  orders(offset: $offset, limit: $limit, year: $year) {
    data {
      name
      created_at
      payment_amount
      order_type
      payment_instrument {
        payment_method_id
        values {
          card_type
          card_number
        }
      }
      values {
        product_price
        discount_name
        transaction_start_at
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
// @ts-ignore
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersQuery, OrdersQueryVariables>;
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersQuery | undefined, OrdersQueryVariables>;
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersSuspenseQueryHookResult = ReturnType<typeof useOrdersSuspenseQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const PaletteDocument = gql`
    query Palette($id: Int, $offset: Int, $limit: Int) {
  palette(id: $id) {
    palette_id
    name
    id_key
    header
    description
    schema_id
    schema
    values
  }
  paletteObjects(id: $id, offset: $offset, limit: $limit) {
    data {
      id
      type
      meta {
        ... on EpisodeMeta {
          ...episodeMetaFields
        }
        ... on LiveMeta {
          ...liveMetaFields
        }
        ... on TVShowMeta {
          ...tvShowMetaFields
        }
        ... on ChannelMeta {
          ...channelMetaFields
        }
      }
      advertising {
        ...advertisingFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${AdvertisingFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __usePaletteQuery__
 *
 * To run a query within a React component, call `usePaletteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaletteQuery(baseOptions?: Apollo.QueryHookOptions<PaletteQuery, PaletteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaletteQuery, PaletteQueryVariables>(PaletteDocument, options);
      }
export function usePaletteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaletteQuery, PaletteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaletteQuery, PaletteQueryVariables>(PaletteDocument, options);
        }
// @ts-ignore
export function usePaletteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaletteQuery, PaletteQueryVariables>): Apollo.UseSuspenseQueryResult<PaletteQuery, PaletteQueryVariables>;
export function usePaletteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaletteQuery, PaletteQueryVariables>): Apollo.UseSuspenseQueryResult<PaletteQuery | undefined, PaletteQueryVariables>;
export function usePaletteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaletteQuery, PaletteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaletteQuery, PaletteQueryVariables>(PaletteDocument, options);
        }
export type PaletteQueryHookResult = ReturnType<typeof usePaletteQuery>;
export type PaletteLazyQueryHookResult = ReturnType<typeof usePaletteLazyQuery>;
export type PaletteSuspenseQueryHookResult = ReturnType<typeof usePaletteSuspenseQuery>;
export type PaletteQueryResult = Apollo.QueryResult<PaletteQuery, PaletteQueryVariables>;
export const PaletteObjectsDocument = gql`
    query PaletteObjects($id: Int, $offset: Int, $limit: Int) {
  paletteObjects(id: $id, offset: $offset, limit: $limit) {
    data {
      id
      type
      meta {
        ... on EpisodeMeta {
          ...episodeMetaFields
        }
        ... on LiveMeta {
          ...liveMetaFields
        }
        ... on TVShowMeta {
          ...tvShowMetaFields
        }
        ... on ChannelMeta {
          ...channelMetaFields
        }
      }
      advertising {
        ...advertisingFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${AdvertisingFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __usePaletteObjectsQuery__
 *
 * To run a query within a React component, call `usePaletteObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaletteObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaletteObjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePaletteObjectsQuery(baseOptions?: Apollo.QueryHookOptions<PaletteObjectsQuery, PaletteObjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaletteObjectsQuery, PaletteObjectsQueryVariables>(PaletteObjectsDocument, options);
      }
export function usePaletteObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaletteObjectsQuery, PaletteObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaletteObjectsQuery, PaletteObjectsQueryVariables>(PaletteObjectsDocument, options);
        }
// @ts-ignore
export function usePaletteObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaletteObjectsQuery, PaletteObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<PaletteObjectsQuery, PaletteObjectsQueryVariables>;
export function usePaletteObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaletteObjectsQuery, PaletteObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<PaletteObjectsQuery | undefined, PaletteObjectsQueryVariables>;
export function usePaletteObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaletteObjectsQuery, PaletteObjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaletteObjectsQuery, PaletteObjectsQueryVariables>(PaletteObjectsDocument, options);
        }
export type PaletteObjectsQueryHookResult = ReturnType<typeof usePaletteObjectsQuery>;
export type PaletteObjectsLazyQueryHookResult = ReturnType<typeof usePaletteObjectsLazyQuery>;
export type PaletteObjectsSuspenseQueryHookResult = ReturnType<typeof usePaletteObjectsSuspenseQuery>;
export type PaletteObjectsQueryResult = Apollo.QueryResult<PaletteObjectsQuery, PaletteObjectsQueryVariables>;
export const PaymentInstrumentsDocument = gql`
    query PaymentInstruments($type: String, $scope: String) {
  paymentInstruments(type: $type, scope: $scope) {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;

/**
 * __usePaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function usePaymentInstrumentsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
      }
export function usePaymentInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
        }
// @ts-ignore
export function usePaymentInstrumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>;
export function usePaymentInstrumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentInstrumentsQuery | undefined, PaymentInstrumentsQueryVariables>;
export function usePaymentInstrumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
        }
export type PaymentInstrumentsQueryHookResult = ReturnType<typeof usePaymentInstrumentsQuery>;
export type PaymentInstrumentsLazyQueryHookResult = ReturnType<typeof usePaymentInstrumentsLazyQuery>;
export type PaymentInstrumentsSuspenseQueryHookResult = ReturnType<typeof usePaymentInstrumentsSuspenseQuery>;
export type PaymentInstrumentsQueryResult = Apollo.QueryResult<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>;
export const PaymentInstrumentInfoDocument = gql`
    query PaymentInstrumentInfo($id: Int) {
  paymentInstrumentInfo(id: $id) {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;

/**
 * __usePaymentInstrumentInfoQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentInstrumentInfoQuery(baseOptions?: Apollo.QueryHookOptions<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>(PaymentInstrumentInfoDocument, options);
      }
export function usePaymentInstrumentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>(PaymentInstrumentInfoDocument, options);
        }
// @ts-ignore
export function usePaymentInstrumentInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>;
export function usePaymentInstrumentInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentInstrumentInfoQuery | undefined, PaymentInstrumentInfoQueryVariables>;
export function usePaymentInstrumentInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>(PaymentInstrumentInfoDocument, options);
        }
export type PaymentInstrumentInfoQueryHookResult = ReturnType<typeof usePaymentInstrumentInfoQuery>;
export type PaymentInstrumentInfoLazyQueryHookResult = ReturnType<typeof usePaymentInstrumentInfoLazyQuery>;
export type PaymentInstrumentInfoSuspenseQueryHookResult = ReturnType<typeof usePaymentInstrumentInfoSuspenseQuery>;
export type PaymentInstrumentInfoQueryResult = Apollo.QueryResult<PaymentInstrumentInfoQuery, PaymentInstrumentInfoQueryVariables>;
export const PaymentInstrumentsCreateCreditCardRecaptchaV2Document = gql`
    mutation PaymentInstrumentsCreateCreditCardRecaptchaV2($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $token: String, $token_key: String, $tds_info_token: String, $tds_info_token_key: String, $tokenPayload: JSONObject, $recaptchaTokenV2: String) {
  paymentInstrumentsCreateCreditCardRecaptchaV2(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    token: $token
    token_key: $token_key
    tds_info_token: $tds_info_token
    tds_info_token_key: $tds_info_token_key
    tokenPayload: $tokenPayload
    recaptchaTokenV2: $recaptchaTokenV2
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
    recaptchaSuccessV2
  }
}
    `;
export type PaymentInstrumentsCreateCreditCardRecaptchaV2MutationFn = Apollo.MutationFunction<PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV2MutationVariables>;

/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV2Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      tds_info_token: // value for 'tds_info_token'
 *      tds_info_token_key: // value for 'tds_info_token_key'
 *      tokenPayload: // value for 'tokenPayload'
 *      recaptchaTokenV2: // value for 'recaptchaTokenV2'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV2MutationVariables>(PaymentInstrumentsCreateCreditCardRecaptchaV2Document, options);
      }
export type PaymentInstrumentsCreateCreditCardRecaptchaV2MutationHookResult = ReturnType<typeof usePaymentInstrumentsCreateCreditCardRecaptchaV2Mutation>;
export type PaymentInstrumentsCreateCreditCardRecaptchaV2MutationResult = Apollo.MutationResult<PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation>;
export type PaymentInstrumentsCreateCreditCardRecaptchaV2MutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsCreateCreditCardRecaptchaV2Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV2MutationVariables>;
export const PaymentInstrumentsCreateCreditCardRecaptchaV3Document = gql`
    mutation PaymentInstrumentsCreateCreditCardRecaptchaV3($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $token: String, $token_key: String, $tds_info_token: String, $tds_info_token_key: String, $tokenPayload: JSONObject, $recaptchaTokenV3: String) {
  paymentInstrumentsCreateCreditCardRecaptchaV3(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    token: $token
    token_key: $token_key
    tds_info_token: $tds_info_token
    tds_info_token_key: $tds_info_token_key
    tokenPayload: $tokenPayload
    recaptchaTokenV3: $recaptchaTokenV3
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
    recaptchaSuccessV3
  }
}
    `;
export type PaymentInstrumentsCreateCreditCardRecaptchaV3MutationFn = Apollo.MutationFunction<PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV3MutationVariables>;

/**
 * __usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateCreditCardRecaptchaV3Mutation, { data, loading, error }] = usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      token: // value for 'token'
 *      token_key: // value for 'token_key'
 *      tds_info_token: // value for 'tds_info_token'
 *      tds_info_token_key: // value for 'tds_info_token_key'
 *      tokenPayload: // value for 'tokenPayload'
 *      recaptchaTokenV3: // value for 'recaptchaTokenV3'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV3MutationVariables>(PaymentInstrumentsCreateCreditCardRecaptchaV3Document, options);
      }
export type PaymentInstrumentsCreateCreditCardRecaptchaV3MutationHookResult = ReturnType<typeof usePaymentInstrumentsCreateCreditCardRecaptchaV3Mutation>;
export type PaymentInstrumentsCreateCreditCardRecaptchaV3MutationResult = Apollo.MutationResult<PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation>;
export type PaymentInstrumentsCreateCreditCardRecaptchaV3MutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsCreateCreditCardRecaptchaV3Mutation, PaymentInstrumentsCreateCreditCardRecaptchaV3MutationVariables>;
export const PaymentInstrumentsCreateOtherDocument = gql`
    mutation PaymentInstrumentsCreateOther($payment_method_id: Int, $replace_flag: Boolean, $success_url: String, $cancel_url: String, $error_url: String, $tokenPayload: JSONObject) {
  paymentInstrumentsCreateOther(
    payment_method_id: $payment_method_id
    replace_flag: $replace_flag
    success_url: $success_url
    cancel_url: $cancel_url
    error_url: $error_url
    tokenPayload: $tokenPayload
  ) {
    redirect_link
    http_method
    redirect_url
    charset
    form_data {
      pay_method
      merchant_id
      service_id
      cust_code
      order_id
      item_id
      item_name
      service_type
      terminal_type
      success_url
      cancel_url
      error_url
      pagecon_url
      free1
      free2
      free3
      request_date
      limit_second
      sps_hashcode
    }
    error
  }
}
    `;
export type PaymentInstrumentsCreateOtherMutationFn = Apollo.MutationFunction<PaymentInstrumentsCreateOtherMutation, PaymentInstrumentsCreateOtherMutationVariables>;

/**
 * __usePaymentInstrumentsCreateOtherMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsCreateOtherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsCreateOtherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsCreateOtherMutation, { data, loading, error }] = usePaymentInstrumentsCreateOtherMutation({
 *   variables: {
 *      payment_method_id: // value for 'payment_method_id'
 *      replace_flag: // value for 'replace_flag'
 *      success_url: // value for 'success_url'
 *      cancel_url: // value for 'cancel_url'
 *      error_url: // value for 'error_url'
 *      tokenPayload: // value for 'tokenPayload'
 *   },
 * });
 */
export function usePaymentInstrumentsCreateOtherMutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsCreateOtherMutation, PaymentInstrumentsCreateOtherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsCreateOtherMutation, PaymentInstrumentsCreateOtherMutationVariables>(PaymentInstrumentsCreateOtherDocument, options);
      }
export type PaymentInstrumentsCreateOtherMutationHookResult = ReturnType<typeof usePaymentInstrumentsCreateOtherMutation>;
export type PaymentInstrumentsCreateOtherMutationResult = Apollo.MutationResult<PaymentInstrumentsCreateOtherMutation>;
export type PaymentInstrumentsCreateOtherMutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsCreateOtherMutation, PaymentInstrumentsCreateOtherMutationVariables>;
export const PaymentInstrumentsActivateDocument = gql`
    mutation PaymentInstrumentsActivate($payment_instrument_id: Int) {
  paymentInstrumentsActivate(payment_instrument_id: $payment_instrument_id) {
    payment_instrument_id
    error {
      message
    }
  }
}
    `;
export type PaymentInstrumentsActivateMutationFn = Apollo.MutationFunction<PaymentInstrumentsActivateMutation, PaymentInstrumentsActivateMutationVariables>;

/**
 * __usePaymentInstrumentsActivateMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsActivateMutation, { data, loading, error }] = usePaymentInstrumentsActivateMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */
export function usePaymentInstrumentsActivateMutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsActivateMutation, PaymentInstrumentsActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsActivateMutation, PaymentInstrumentsActivateMutationVariables>(PaymentInstrumentsActivateDocument, options);
      }
export type PaymentInstrumentsActivateMutationHookResult = ReturnType<typeof usePaymentInstrumentsActivateMutation>;
export type PaymentInstrumentsActivateMutationResult = Apollo.MutationResult<PaymentInstrumentsActivateMutation>;
export type PaymentInstrumentsActivateMutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsActivateMutation, PaymentInstrumentsActivateMutationVariables>;
export const PaymentInstrumentsDeactivateDocument = gql`
    mutation PaymentInstrumentsDeactivate($payment_instrument_id: Int) {
  paymentInstrumentsDeactivate(payment_instrument_id: $payment_instrument_id) {
    payment_instrument_id
    error {
      message
    }
  }
}
    `;
export type PaymentInstrumentsDeactivateMutationFn = Apollo.MutationFunction<PaymentInstrumentsDeactivateMutation, PaymentInstrumentsDeactivateMutationVariables>;

/**
 * __usePaymentInstrumentsDeactivateMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsDeactivateMutation, { data, loading, error }] = usePaymentInstrumentsDeactivateMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */
export function usePaymentInstrumentsDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsDeactivateMutation, PaymentInstrumentsDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsDeactivateMutation, PaymentInstrumentsDeactivateMutationVariables>(PaymentInstrumentsDeactivateDocument, options);
      }
export type PaymentInstrumentsDeactivateMutationHookResult = ReturnType<typeof usePaymentInstrumentsDeactivateMutation>;
export type PaymentInstrumentsDeactivateMutationResult = Apollo.MutationResult<PaymentInstrumentsDeactivateMutation>;
export type PaymentInstrumentsDeactivateMutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsDeactivateMutation, PaymentInstrumentsDeactivateMutationVariables>;
export const PaymentInstrumentsSetDefaultDocument = gql`
    mutation PaymentInstrumentsSetDefault($payment_instrument_id: Int) {
  paymentInstrumentsSetDefault(payment_instrument_id: $payment_instrument_id) {
    result
  }
}
    `;
export type PaymentInstrumentsSetDefaultMutationFn = Apollo.MutationFunction<PaymentInstrumentsSetDefaultMutation, PaymentInstrumentsSetDefaultMutationVariables>;

/**
 * __usePaymentInstrumentsSetDefaultMutation__
 *
 * To run a mutation, you first call `usePaymentInstrumentsSetDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsSetDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentInstrumentsSetDefaultMutation, { data, loading, error }] = usePaymentInstrumentsSetDefaultMutation({
 *   variables: {
 *      payment_instrument_id: // value for 'payment_instrument_id'
 *   },
 * });
 */
export function usePaymentInstrumentsSetDefaultMutation(baseOptions?: Apollo.MutationHookOptions<PaymentInstrumentsSetDefaultMutation, PaymentInstrumentsSetDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentInstrumentsSetDefaultMutation, PaymentInstrumentsSetDefaultMutationVariables>(PaymentInstrumentsSetDefaultDocument, options);
      }
export type PaymentInstrumentsSetDefaultMutationHookResult = ReturnType<typeof usePaymentInstrumentsSetDefaultMutation>;
export type PaymentInstrumentsSetDefaultMutationResult = Apollo.MutationResult<PaymentInstrumentsSetDefaultMutation>;
export type PaymentInstrumentsSetDefaultMutationOptions = Apollo.BaseMutationOptions<PaymentInstrumentsSetDefaultMutation, PaymentInstrumentsSetDefaultMutationVariables>;
export const AddPaymentInstrumentSendMailDocument = gql`
    mutation AddPaymentInstrumentSendMail($paymentInstrumentId: Int) {
  addPaymentInstrumentSendMail(paymentInstrumentId: $paymentInstrumentId) {
    result
  }
}
    `;
export type AddPaymentInstrumentSendMailMutationFn = Apollo.MutationFunction<AddPaymentInstrumentSendMailMutation, AddPaymentInstrumentSendMailMutationVariables>;

/**
 * __useAddPaymentInstrumentSendMailMutation__
 *
 * To run a mutation, you first call `useAddPaymentInstrumentSendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentInstrumentSendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentInstrumentSendMailMutation, { data, loading, error }] = useAddPaymentInstrumentSendMailMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *   },
 * });
 */
export function useAddPaymentInstrumentSendMailMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentInstrumentSendMailMutation, AddPaymentInstrumentSendMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentInstrumentSendMailMutation, AddPaymentInstrumentSendMailMutationVariables>(AddPaymentInstrumentSendMailDocument, options);
      }
export type AddPaymentInstrumentSendMailMutationHookResult = ReturnType<typeof useAddPaymentInstrumentSendMailMutation>;
export type AddPaymentInstrumentSendMailMutationResult = Apollo.MutationResult<AddPaymentInstrumentSendMailMutation>;
export type AddPaymentInstrumentSendMailMutationOptions = Apollo.BaseMutationOptions<AddPaymentInstrumentSendMailMutation, AddPaymentInstrumentSendMailMutationVariables>;
export const PaymentMethodsDocument = gql`
    query PaymentMethods {
  paymentMethods {
    name
    payment_method_id
    payment_method_type_name
  }
  paymentInstruments {
    default_flag
    payment_method {
      name
    }
    payment_method_id
    payment_instrument_id
    ref_id
    values {
      card_number
      card_type
      expiry_date
    }
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
// @ts-ignore
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery | undefined, PaymentMethodsQueryVariables>;
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsSuspenseQueryHookResult = ReturnType<typeof usePaymentMethodsSuspenseQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const PinActivateDocument = gql`
    mutation PinActivate($code: String) {
  pinActivate(code: $code) {
    status
    result
    deviceToken
  }
}
    `;
export type PinActivateMutationFn = Apollo.MutationFunction<PinActivateMutation, PinActivateMutationVariables>;

/**
 * __usePinActivateMutation__
 *
 * To run a mutation, you first call `usePinActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinActivateMutation, { data, loading, error }] = usePinActivateMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function usePinActivateMutation(baseOptions?: Apollo.MutationHookOptions<PinActivateMutation, PinActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinActivateMutation, PinActivateMutationVariables>(PinActivateDocument, options);
      }
export type PinActivateMutationHookResult = ReturnType<typeof usePinActivateMutation>;
export type PinActivateMutationResult = Apollo.MutationResult<PinActivateMutation>;
export type PinActivateMutationOptions = Apollo.BaseMutationOptions<PinActivateMutation, PinActivateMutationVariables>;
export const PlaybackAuthDocument = gql`
    query PlaybackAuth($id: Int, $vuid: String, $sessionId: String, $fl: Int) {
  playbackAuth(id: $id, vuid: $vuid, sessionId: $sessionId, fl: $fl) {
    media {
      media_id
      uuid
      ovp_id
      ovp_video_id
      thumbnail_tile_urls
    }
    rule {
      playback_rule_id
      enable_seek_flag
      enable_cromecst_flag
      enable_airplay_flag
      enable_mirroring_flag
      enable_external_monitor_flag
      enable_catchup_flag
      enable_start_over_flag
      enable_pause_flag
      enable_background_play_flag
      enable_screen_capture_flag
      enable_playback_rate_change_flag
      enable_offline_play_flag
      maximum_bitrate
      minimum_bitrate
    }
    playback_session_id
    log_params
    resumePoint
    error {
      type
      message
      code
    }
    entitlements {
      ...entitlementFields
    }
  }
}
    ${EntitlementFieldsFragmentDoc}`;

/**
 * __usePlaybackAuthQuery__
 *
 * To run a query within a React component, call `usePlaybackAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybackAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybackAuthQuery({
 *   variables: {
 *      id: // value for 'id'
 *      vuid: // value for 'vuid'
 *      sessionId: // value for 'sessionId'
 *      fl: // value for 'fl'
 *   },
 * });
 */
export function usePlaybackAuthQuery(baseOptions?: Apollo.QueryHookOptions<PlaybackAuthQuery, PlaybackAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybackAuthQuery, PlaybackAuthQueryVariables>(PlaybackAuthDocument, options);
      }
export function usePlaybackAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybackAuthQuery, PlaybackAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybackAuthQuery, PlaybackAuthQueryVariables>(PlaybackAuthDocument, options);
        }
// @ts-ignore
export function usePlaybackAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaybackAuthQuery, PlaybackAuthQueryVariables>): Apollo.UseSuspenseQueryResult<PlaybackAuthQuery, PlaybackAuthQueryVariables>;
export function usePlaybackAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaybackAuthQuery, PlaybackAuthQueryVariables>): Apollo.UseSuspenseQueryResult<PlaybackAuthQuery | undefined, PlaybackAuthQueryVariables>;
export function usePlaybackAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaybackAuthQuery, PlaybackAuthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaybackAuthQuery, PlaybackAuthQueryVariables>(PlaybackAuthDocument, options);
        }
export type PlaybackAuthQueryHookResult = ReturnType<typeof usePlaybackAuthQuery>;
export type PlaybackAuthLazyQueryHookResult = ReturnType<typeof usePlaybackAuthLazyQuery>;
export type PlaybackAuthSuspenseQueryHookResult = ReturnType<typeof usePlaybackAuthSuspenseQuery>;
export type PlaybackAuthQueryResult = Apollo.QueryResult<PlaybackAuthQuery, PlaybackAuthQueryVariables>;
export const PlaybackSessionOpenDocument = gql`
    mutation PlaybackSessionOpen($videoId: String, $sessionId: String) {
  playbackSessionOpen(videoId: $videoId, sessionId: $sessionId) {
    media
    error {
      type
      message
      code
    }
  }
}
    `;
export type PlaybackSessionOpenMutationFn = Apollo.MutationFunction<PlaybackSessionOpenMutation, PlaybackSessionOpenMutationVariables>;

/**
 * __usePlaybackSessionOpenMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionOpenMutation, { data, loading, error }] = usePlaybackSessionOpenMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionOpenMutation(baseOptions?: Apollo.MutationHookOptions<PlaybackSessionOpenMutation, PlaybackSessionOpenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaybackSessionOpenMutation, PlaybackSessionOpenMutationVariables>(PlaybackSessionOpenDocument, options);
      }
export type PlaybackSessionOpenMutationHookResult = ReturnType<typeof usePlaybackSessionOpenMutation>;
export type PlaybackSessionOpenMutationResult = Apollo.MutationResult<PlaybackSessionOpenMutation>;
export type PlaybackSessionOpenMutationOptions = Apollo.BaseMutationOptions<PlaybackSessionOpenMutation, PlaybackSessionOpenMutationVariables>;
export const PlaybackSessionCheckDocument = gql`
    mutation PlaybackSessionCheck($sessionId: String) {
  playbackSessionCheck(sessionId: $sessionId) {
    result
  }
}
    `;
export type PlaybackSessionCheckMutationFn = Apollo.MutationFunction<PlaybackSessionCheckMutation, PlaybackSessionCheckMutationVariables>;

/**
 * __usePlaybackSessionCheckMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCheckMutation, { data, loading, error }] = usePlaybackSessionCheckMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionCheckMutation(baseOptions?: Apollo.MutationHookOptions<PlaybackSessionCheckMutation, PlaybackSessionCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaybackSessionCheckMutation, PlaybackSessionCheckMutationVariables>(PlaybackSessionCheckDocument, options);
      }
export type PlaybackSessionCheckMutationHookResult = ReturnType<typeof usePlaybackSessionCheckMutation>;
export type PlaybackSessionCheckMutationResult = Apollo.MutationResult<PlaybackSessionCheckMutation>;
export type PlaybackSessionCheckMutationOptions = Apollo.BaseMutationOptions<PlaybackSessionCheckMutation, PlaybackSessionCheckMutationVariables>;
export const PlaybackSessionCloseDocument = gql`
    mutation PlaybackSessionClose($sessionId: String) {
  playbackSessionClose(sessionId: $sessionId) {
    result
  }
}
    `;
export type PlaybackSessionCloseMutationFn = Apollo.MutationFunction<PlaybackSessionCloseMutation, PlaybackSessionCloseMutationVariables>;

/**
 * __usePlaybackSessionCloseMutation__
 *
 * To run a mutation, you first call `usePlaybackSessionCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackSessionCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackSessionCloseMutation, { data, loading, error }] = usePlaybackSessionCloseMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function usePlaybackSessionCloseMutation(baseOptions?: Apollo.MutationHookOptions<PlaybackSessionCloseMutation, PlaybackSessionCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaybackSessionCloseMutation, PlaybackSessionCloseMutationVariables>(PlaybackSessionCloseDocument, options);
      }
export type PlaybackSessionCloseMutationHookResult = ReturnType<typeof usePlaybackSessionCloseMutation>;
export type PlaybackSessionCloseMutationResult = Apollo.MutationResult<PlaybackSessionCloseMutation>;
export type PlaybackSessionCloseMutationOptions = Apollo.BaseMutationOptions<PlaybackSessionCloseMutation, PlaybackSessionCloseMutationVariables>;
export const ProductByIdDocument = gql`
    query ProductById($id: Int) {
  product: productById(id: $id) {
    ...productFields
    purchased
    right {
      ... on Right {
        ...rightFields
      }
    }
    meta {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}
${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}`;

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions?: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
      }
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
// @ts-ignore
export function useProductByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export function useProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductByIdQuery | undefined, ProductByIdQueryVariables>;
export function useProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>;
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>;
export type ProductByIdSuspenseQueryHookResult = ReturnType<typeof useProductByIdSuspenseQuery>;
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export const PurchaseEstimateDocument = gql`
    query PurchaseEstimate($productId: Int, $paymentMethodId: Int) {
  estimate: purchaseEstimate(
    productId: $productId
    paymentMethodId: $paymentMethodId
  ) {
    product {
      ... on Product {
        ...productFields
        voucherCode {
          ... on VoucherCode {
            ...voucherCodeFields
          }
        }
      }
    }
    error
  }
}
    ${ProductFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}`;

/**
 * __usePurchaseEstimateQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePurchaseEstimateQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>(PurchaseEstimateDocument, options);
      }
export function usePurchaseEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>(PurchaseEstimateDocument, options);
        }
// @ts-ignore
export function usePurchaseEstimateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>;
export function usePurchaseEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseEstimateQuery | undefined, PurchaseEstimateQueryVariables>;
export function usePurchaseEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>(PurchaseEstimateDocument, options);
        }
export type PurchaseEstimateQueryHookResult = ReturnType<typeof usePurchaseEstimateQuery>;
export type PurchaseEstimateLazyQueryHookResult = ReturnType<typeof usePurchaseEstimateLazyQuery>;
export type PurchaseEstimateSuspenseQueryHookResult = ReturnType<typeof usePurchaseEstimateSuspenseQuery>;
export type PurchaseEstimateQueryResult = Apollo.QueryResult<PurchaseEstimateQuery, PurchaseEstimateQueryVariables>;
export const PurchaseEstimateWithCouponDocument = gql`
    query PurchaseEstimateWithCoupon($productId: Int, $paymentMethodId: Int, $voucherCode: String) {
  estimateWithCoupon: purchaseEstimate(
    productId: $productId
    paymentMethodId: $paymentMethodId
    voucherCode: $voucherCode
  ) {
    product {
      ... on Product {
        ...productFields
        voucherCode {
          ... on VoucherCode {
            ...voucherCodeFields
          }
        }
        discountPrice
      }
    }
    error
  }
}
    ${ProductFieldsFragmentDoc}
${VoucherCodeFieldsFragmentDoc}`;

/**
 * __usePurchaseEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `usePurchaseEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseEstimateWithCouponQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */
export function usePurchaseEstimateWithCouponQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>(PurchaseEstimateWithCouponDocument, options);
      }
export function usePurchaseEstimateWithCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>(PurchaseEstimateWithCouponDocument, options);
        }
// @ts-ignore
export function usePurchaseEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>;
export function usePurchaseEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>): Apollo.UseSuspenseQueryResult<PurchaseEstimateWithCouponQuery | undefined, PurchaseEstimateWithCouponQueryVariables>;
export function usePurchaseEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>(PurchaseEstimateWithCouponDocument, options);
        }
export type PurchaseEstimateWithCouponQueryHookResult = ReturnType<typeof usePurchaseEstimateWithCouponQuery>;
export type PurchaseEstimateWithCouponLazyQueryHookResult = ReturnType<typeof usePurchaseEstimateWithCouponLazyQuery>;
export type PurchaseEstimateWithCouponSuspenseQueryHookResult = ReturnType<typeof usePurchaseEstimateWithCouponSuspenseQuery>;
export type PurchaseEstimateWithCouponQueryResult = Apollo.QueryResult<PurchaseEstimateWithCouponQuery, PurchaseEstimateWithCouponQueryVariables>;
export const PurchaseExecuteDocument = gql`
    mutation PurchaseExecute($productId: Int, $paymentInstrumentId: Int, $voucherCode: String) {
  purchaseExecute(
    productId: $productId
    paymentInstrumentId: $paymentInstrumentId
    voucherCode: $voucherCode
  ) {
    product_order_id
    product_id
    status
    name
    created_at
    error
    order {
      order_id
      payment_method_id
      payment_amount
    }
  }
}
    `;
export type PurchaseExecuteMutationFn = Apollo.MutationFunction<PurchaseExecuteMutation, PurchaseExecuteMutationVariables>;

/**
 * __usePurchaseExecuteMutation__
 *
 * To run a mutation, you first call `usePurchaseExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseExecuteMutation, { data, loading, error }] = usePurchaseExecuteMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */
export function usePurchaseExecuteMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseExecuteMutation, PurchaseExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseExecuteMutation, PurchaseExecuteMutationVariables>(PurchaseExecuteDocument, options);
      }
export type PurchaseExecuteMutationHookResult = ReturnType<typeof usePurchaseExecuteMutation>;
export type PurchaseExecuteMutationResult = Apollo.MutationResult<PurchaseExecuteMutation>;
export type PurchaseExecuteMutationOptions = Apollo.BaseMutationOptions<PurchaseExecuteMutation, PurchaseExecuteMutationVariables>;
export const PurchaseTestDocument = gql`
    mutation PurchaseTest($productId: Int, $paymentInstrumentId: Int, $voucherCode: String, $userVoucherId: Int, $mode: String) {
  purchaseTest(
    productId: $productId
    paymentInstrumentId: $paymentInstrumentId
    voucherCode: $voucherCode
    userVoucherId: $userVoucherId
    mode: $mode
  ) {
    product_order_id
    product_id
    status
    name
    created_at
    error
    order {
      order_id
      payment_method_id
      payment_amount
    }
  }
}
    `;
export type PurchaseTestMutationFn = Apollo.MutationFunction<PurchaseTestMutation, PurchaseTestMutationVariables>;

/**
 * __usePurchaseTestMutation__
 *
 * To run a mutation, you first call `usePurchaseTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseTestMutation, { data, loading, error }] = usePurchaseTestMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      userVoucherId: // value for 'userVoucherId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function usePurchaseTestMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseTestMutation, PurchaseTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseTestMutation, PurchaseTestMutationVariables>(PurchaseTestDocument, options);
      }
export type PurchaseTestMutationHookResult = ReturnType<typeof usePurchaseTestMutation>;
export type PurchaseTestMutationResult = Apollo.MutationResult<PurchaseTestMutation>;
export type PurchaseTestMutationOptions = Apollo.BaseMutationOptions<PurchaseTestMutation, PurchaseTestMutationVariables>;
export const RankingDocument = gql`
    query ranking($target: String, $range: String, $channel: Int, $count: Int) {
  ranking(target: $target, range: $range, channel: $channel, count: $count) {
    id
    rank
    meta {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}`;

/**
 * __useRankingQuery__
 *
 * To run a query within a React component, call `useRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingQuery({
 *   variables: {
 *      target: // value for 'target'
 *      range: // value for 'range'
 *      channel: // value for 'channel'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useRankingQuery(baseOptions?: Apollo.QueryHookOptions<RankingQuery, RankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RankingQuery, RankingQueryVariables>(RankingDocument, options);
      }
export function useRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RankingQuery, RankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RankingQuery, RankingQueryVariables>(RankingDocument, options);
        }
// @ts-ignore
export function useRankingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RankingQuery, RankingQueryVariables>): Apollo.UseSuspenseQueryResult<RankingQuery, RankingQueryVariables>;
export function useRankingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RankingQuery, RankingQueryVariables>): Apollo.UseSuspenseQueryResult<RankingQuery | undefined, RankingQueryVariables>;
export function useRankingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RankingQuery, RankingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RankingQuery, RankingQueryVariables>(RankingDocument, options);
        }
export type RankingQueryHookResult = ReturnType<typeof useRankingQuery>;
export type RankingLazyQueryHookResult = ReturnType<typeof useRankingLazyQuery>;
export type RankingSuspenseQueryHookResult = ReturnType<typeof useRankingSuspenseQuery>;
export type RankingQueryResult = Apollo.QueryResult<RankingQuery, RankingQueryVariables>;
export const RecommendArticleDocument = gql`
    query RecommendArticle {
  recommendArticle {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;

/**
 * __useRecommendArticleQuery__
 *
 * To run a query within a React component, call `useRecommendArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendArticleQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendArticleQuery(baseOptions?: Apollo.QueryHookOptions<RecommendArticleQuery, RecommendArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendArticleQuery, RecommendArticleQueryVariables>(RecommendArticleDocument, options);
      }
export function useRecommendArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendArticleQuery, RecommendArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendArticleQuery, RecommendArticleQueryVariables>(RecommendArticleDocument, options);
        }
// @ts-ignore
export function useRecommendArticleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecommendArticleQuery, RecommendArticleQueryVariables>): Apollo.UseSuspenseQueryResult<RecommendArticleQuery, RecommendArticleQueryVariables>;
export function useRecommendArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendArticleQuery, RecommendArticleQueryVariables>): Apollo.UseSuspenseQueryResult<RecommendArticleQuery | undefined, RecommendArticleQueryVariables>;
export function useRecommendArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendArticleQuery, RecommendArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendArticleQuery, RecommendArticleQueryVariables>(RecommendArticleDocument, options);
        }
export type RecommendArticleQueryHookResult = ReturnType<typeof useRecommendArticleQuery>;
export type RecommendArticleLazyQueryHookResult = ReturnType<typeof useRecommendArticleLazyQuery>;
export type RecommendArticleSuspenseQueryHookResult = ReturnType<typeof useRecommendArticleSuspenseQuery>;
export type RecommendArticleQueryResult = Apollo.QueryResult<RecommendArticleQuery, RecommendArticleQueryVariables>;
export const UpdateRecommendArticleDocument = gql`
    mutation UpdateRecommendArticle($type: String!, $id: [Int]) {
  updateRecommendArticle(type: $type, id: $id) {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;
export type UpdateRecommendArticleMutationFn = Apollo.MutationFunction<UpdateRecommendArticleMutation, UpdateRecommendArticleMutationVariables>;

/**
 * __useUpdateRecommendArticleMutation__
 *
 * To run a mutation, you first call `useUpdateRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecommendArticleMutation, { data, loading, error }] = useUpdateRecommendArticleMutation({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateRecommendArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecommendArticleMutation, UpdateRecommendArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecommendArticleMutation, UpdateRecommendArticleMutationVariables>(UpdateRecommendArticleDocument, options);
      }
export type UpdateRecommendArticleMutationHookResult = ReturnType<typeof useUpdateRecommendArticleMutation>;
export type UpdateRecommendArticleMutationResult = Apollo.MutationResult<UpdateRecommendArticleMutation>;
export type UpdateRecommendArticleMutationOptions = Apollo.BaseMutationOptions<UpdateRecommendArticleMutation, UpdateRecommendArticleMutationVariables>;
export const ClearRecommendArticleDocument = gql`
    mutation ClearRecommendArticle {
  clearRecommendArticle {
    ... on RecommendArticle {
      ...recommendArticleFields
    }
  }
}
    ${RecommendArticleFieldsFragmentDoc}`;
export type ClearRecommendArticleMutationFn = Apollo.MutationFunction<ClearRecommendArticleMutation, ClearRecommendArticleMutationVariables>;

/**
 * __useClearRecommendArticleMutation__
 *
 * To run a mutation, you first call `useClearRecommendArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecommendArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecommendArticleMutation, { data, loading, error }] = useClearRecommendArticleMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearRecommendArticleMutation(baseOptions?: Apollo.MutationHookOptions<ClearRecommendArticleMutation, ClearRecommendArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearRecommendArticleMutation, ClearRecommendArticleMutationVariables>(ClearRecommendArticleDocument, options);
      }
export type ClearRecommendArticleMutationHookResult = ReturnType<typeof useClearRecommendArticleMutation>;
export type ClearRecommendArticleMutationResult = Apollo.MutationResult<ClearRecommendArticleMutation>;
export type ClearRecommendArticleMutationOptions = Apollo.BaseMutationOptions<ClearRecommendArticleMutation, ClearRecommendArticleMutationVariables>;
export const SearchEpisodeDocument = gql`
    query SearchEpisode($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {
  search(
    keyword: $keyword
    filter: $filter
    sort: $sort
    offset: $offset
    limit: $limit
    minScore: $minScore
  ) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useSearchEpisodeQuery__
 *
 * To run a query within a React component, call `useSearchEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEpisodeQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */
export function useSearchEpisodeQuery(baseOptions?: Apollo.QueryHookOptions<SearchEpisodeQuery, SearchEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEpisodeQuery, SearchEpisodeQueryVariables>(SearchEpisodeDocument, options);
      }
export function useSearchEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEpisodeQuery, SearchEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEpisodeQuery, SearchEpisodeQueryVariables>(SearchEpisodeDocument, options);
        }
// @ts-ignore
export function useSearchEpisodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchEpisodeQuery, SearchEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<SearchEpisodeQuery, SearchEpisodeQueryVariables>;
export function useSearchEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEpisodeQuery, SearchEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<SearchEpisodeQuery | undefined, SearchEpisodeQueryVariables>;
export function useSearchEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEpisodeQuery, SearchEpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEpisodeQuery, SearchEpisodeQueryVariables>(SearchEpisodeDocument, options);
        }
export type SearchEpisodeQueryHookResult = ReturnType<typeof useSearchEpisodeQuery>;
export type SearchEpisodeLazyQueryHookResult = ReturnType<typeof useSearchEpisodeLazyQuery>;
export type SearchEpisodeSuspenseQueryHookResult = ReturnType<typeof useSearchEpisodeSuspenseQuery>;
export type SearchEpisodeQueryResult = Apollo.QueryResult<SearchEpisodeQuery, SearchEpisodeQueryVariables>;
export const SearchTvShowDocument = gql`
    query SearchTvShow($keyword: String, $filter: JSONObject, $sort: String, $offset: Int, $limit: Int, $minScore: Int) {
  search: searchTvShow(
    keyword: $keyword
    filter: $filter
    sort: $sort
    offset: $offset
    limit: $limit
    minScore: $minScore
  ) {
    data {
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useSearchTvShowQuery__
 *
 * To run a query within a React component, call `useSearchTvShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTvShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTvShowQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      minScore: // value for 'minScore'
 *   },
 * });
 */
export function useSearchTvShowQuery(baseOptions?: Apollo.QueryHookOptions<SearchTvShowQuery, SearchTvShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTvShowQuery, SearchTvShowQueryVariables>(SearchTvShowDocument, options);
      }
export function useSearchTvShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTvShowQuery, SearchTvShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTvShowQuery, SearchTvShowQueryVariables>(SearchTvShowDocument, options);
        }
// @ts-ignore
export function useSearchTvShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTvShowQuery, SearchTvShowQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTvShowQuery, SearchTvShowQueryVariables>;
export function useSearchTvShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTvShowQuery, SearchTvShowQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTvShowQuery | undefined, SearchTvShowQueryVariables>;
export function useSearchTvShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTvShowQuery, SearchTvShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTvShowQuery, SearchTvShowQueryVariables>(SearchTvShowDocument, options);
        }
export type SearchTvShowQueryHookResult = ReturnType<typeof useSearchTvShowQuery>;
export type SearchTvShowLazyQueryHookResult = ReturnType<typeof useSearchTvShowLazyQuery>;
export type SearchTvShowSuspenseQueryHookResult = ReturnType<typeof useSearchTvShowSuspenseQuery>;
export type SearchTvShowQueryResult = Apollo.QueryResult<SearchTvShowQuery, SearchTvShowQueryVariables>;
export const SearchConfigDocument = gql`
    query SearchConfig {
  searchConfig {
    livePaletteKeywords
    keywordMinScore {
      keyword
      score
    }
    defaultMinScore
  }
}
    `;

/**
 * __useSearchConfigQuery__
 *
 * To run a query within a React component, call `useSearchConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchConfigQuery(baseOptions?: Apollo.QueryHookOptions<SearchConfigQuery, SearchConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchConfigQuery, SearchConfigQueryVariables>(SearchConfigDocument, options);
      }
export function useSearchConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchConfigQuery, SearchConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchConfigQuery, SearchConfigQueryVariables>(SearchConfigDocument, options);
        }
// @ts-ignore
export function useSearchConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchConfigQuery, SearchConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SearchConfigQuery, SearchConfigQueryVariables>;
export function useSearchConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchConfigQuery, SearchConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SearchConfigQuery | undefined, SearchConfigQueryVariables>;
export function useSearchConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchConfigQuery, SearchConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchConfigQuery, SearchConfigQueryVariables>(SearchConfigDocument, options);
        }
export type SearchConfigQueryHookResult = ReturnType<typeof useSearchConfigQuery>;
export type SearchConfigLazyQueryHookResult = ReturnType<typeof useSearchConfigLazyQuery>;
export type SearchConfigSuspenseQueryHookResult = ReturnType<typeof useSearchConfigSuspenseQuery>;
export type SearchConfigQueryResult = Apollo.QueryResult<SearchConfigQuery, SearchConfigQueryVariables>;
export const SignupDocument = gql`
    query Signup {
  requiredTerms: registTerms(type: REQUIRED) {
    ...termsFields
  }
  optionalTerms: registTerms(type: OPTIONAL) {
    ...termsFields
  }
  recommendArticle {
    courses {
      ... on Course {
        ...courseFields
      }
    }
    products {
      ... on Product {
        ...productFields
        right {
          ... on Right {
            ...rightFields
          }
        }
      }
    }
  }
}
    ${TermsFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${RightFieldsFragmentDoc}`;

/**
 * __useSignupQuery__
 *
 * To run a query within a React component, call `useSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignupQuery(baseOptions?: Apollo.QueryHookOptions<SignupQuery, SignupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignupQuery, SignupQueryVariables>(SignupDocument, options);
      }
export function useSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignupQuery, SignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignupQuery, SignupQueryVariables>(SignupDocument, options);
        }
// @ts-ignore
export function useSignupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignupQuery, SignupQueryVariables>): Apollo.UseSuspenseQueryResult<SignupQuery, SignupQueryVariables>;
export function useSignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignupQuery, SignupQueryVariables>): Apollo.UseSuspenseQueryResult<SignupQuery | undefined, SignupQueryVariables>;
export function useSignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignupQuery, SignupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignupQuery, SignupQueryVariables>(SignupDocument, options);
        }
export type SignupQueryHookResult = ReturnType<typeof useSignupQuery>;
export type SignupLazyQueryHookResult = ReturnType<typeof useSignupLazyQuery>;
export type SignupSuspenseQueryHookResult = ReturnType<typeof useSignupSuspenseQuery>;
export type SignupQueryResult = Apollo.QueryResult<SignupQuery, SignupQueryVariables>;
export const SubscribeDocument = gql`
    mutation Subscribe($courseId: Int, $paymentInstrumentId: Int, $voucherCode: String, $campaignCode: String, $valuePlanTerm: String) {
  subscribe(
    courseId: $courseId
    paymentInstrumentId: $paymentInstrumentId
    campaignCode: $campaignCode
    voucherCode: $voucherCode
    valuePlanTerm: $valuePlanTerm
  ) {
    subscription_id
    status
    initialTransactionAt
    trialStartAt
    trialEndAt
    init_order_id
    course {
      ...courseFields
    }
    orderPrice
    error
  }
}
    ${CourseFieldsFragmentDoc}`;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      voucherCode: // value for 'voucherCode'
 *      campaignCode: // value for 'campaignCode'
 *      valuePlanTerm: // value for 'valuePlanTerm'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions {
  subscriptions {
    ...subscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
// @ts-ignore
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionsQuery | undefined, SubscriptionsQueryVariables>;
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionsSuspenseQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const UnsubscribeDocument = gql`
    query Unsubscribe($id: Int) {
  subscription: subscriptionOne(id: $id) {
    ...subscriptionFields
  }
  checkCancelable: subscriptionCheckCancelable(subscriptionId: $id) {
    cancelable
    subscription {
      withdraw_at
    }
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useUnsubscribeQuery__
 *
 * To run a query within a React component, call `useUnsubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnsubscribeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeQuery(baseOptions?: Apollo.QueryHookOptions<UnsubscribeQuery, UnsubscribeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnsubscribeQuery, UnsubscribeQueryVariables>(UnsubscribeDocument, options);
      }
export function useUnsubscribeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnsubscribeQuery, UnsubscribeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnsubscribeQuery, UnsubscribeQueryVariables>(UnsubscribeDocument, options);
        }
// @ts-ignore
export function useUnsubscribeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnsubscribeQuery, UnsubscribeQueryVariables>): Apollo.UseSuspenseQueryResult<UnsubscribeQuery, UnsubscribeQueryVariables>;
export function useUnsubscribeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnsubscribeQuery, UnsubscribeQueryVariables>): Apollo.UseSuspenseQueryResult<UnsubscribeQuery | undefined, UnsubscribeQueryVariables>;
export function useUnsubscribeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnsubscribeQuery, UnsubscribeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnsubscribeQuery, UnsubscribeQueryVariables>(UnsubscribeDocument, options);
        }
export type UnsubscribeQueryHookResult = ReturnType<typeof useUnsubscribeQuery>;
export type UnsubscribeLazyQueryHookResult = ReturnType<typeof useUnsubscribeLazyQuery>;
export type UnsubscribeSuspenseQueryHookResult = ReturnType<typeof useUnsubscribeSuspenseQuery>;
export type UnsubscribeQueryResult = Apollo.QueryResult<UnsubscribeQuery, UnsubscribeQueryVariables>;
export const FormQuestionsDocument = gql`
    query FormQuestions($id: Int) {
  formQuestions(id: $id) {
    question_id
    data {
      type
      label
      unique
      key_name
      help_text
      required
      schema_group_name
      options {
        label
        value
      }
    }
    values
  }
}
    `;

/**
 * __useFormQuestionsQuery__
 *
 * To run a query within a React component, call `useFormQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuestionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<FormQuestionsQuery, FormQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuestionsQuery, FormQuestionsQueryVariables>(FormQuestionsDocument, options);
      }
export function useFormQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuestionsQuery, FormQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuestionsQuery, FormQuestionsQueryVariables>(FormQuestionsDocument, options);
        }
// @ts-ignore
export function useFormQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormQuestionsQuery, FormQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<FormQuestionsQuery, FormQuestionsQueryVariables>;
export function useFormQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FormQuestionsQuery, FormQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<FormQuestionsQuery | undefined, FormQuestionsQueryVariables>;
export function useFormQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FormQuestionsQuery, FormQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormQuestionsQuery, FormQuestionsQueryVariables>(FormQuestionsDocument, options);
        }
export type FormQuestionsQueryHookResult = ReturnType<typeof useFormQuestionsQuery>;
export type FormQuestionsLazyQueryHookResult = ReturnType<typeof useFormQuestionsLazyQuery>;
export type FormQuestionsSuspenseQueryHookResult = ReturnType<typeof useFormQuestionsSuspenseQuery>;
export type FormQuestionsQueryResult = Apollo.QueryResult<FormQuestionsQuery, FormQuestionsQueryVariables>;
export const SubscriptionCancelDocument = gql`
    mutation SubscriptionCancel($id: Int, $questionId: Int, $answer: String, $withQuestionAnswer: Boolean = false) {
  subscriptionCancel(id: $id) {
    course_id
    status
    withdraw_at
    error
  }
  formQuestionAnswer(id: $questionId, values: $answer) @include(if: $withQuestionAnswer) {
    answer_id
  }
}
    `;
export type SubscriptionCancelMutationFn = Apollo.MutationFunction<SubscriptionCancelMutation, SubscriptionCancelMutationVariables>;

/**
 * __useSubscriptionCancelMutation__
 *
 * To run a mutation, you first call `useSubscriptionCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancelMutation, { data, loading, error }] = useSubscriptionCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionId: // value for 'questionId'
 *      answer: // value for 'answer'
 *      withQuestionAnswer: // value for 'withQuestionAnswer'
 *   },
 * });
 */
export function useSubscriptionCancelMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionCancelMutation, SubscriptionCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionCancelMutation, SubscriptionCancelMutationVariables>(SubscriptionCancelDocument, options);
      }
export type SubscriptionCancelMutationHookResult = ReturnType<typeof useSubscriptionCancelMutation>;
export type SubscriptionCancelMutationResult = Apollo.MutationResult<SubscriptionCancelMutation>;
export type SubscriptionCancelMutationOptions = Apollo.BaseMutationOptions<SubscriptionCancelMutation, SubscriptionCancelMutationVariables>;
export const SubscriptionChangePaymentDocument = gql`
    mutation SubscriptionChangePayment($paymentInstrumentId: Int!, $subscriptionId: Int!) {
  subscriptionChangePayment(
    paymentInstrumentId: $paymentInstrumentId
    subscriptionId: $subscriptionId
  ) {
    payment_instrument_id
    error
  }
}
    `;
export type SubscriptionChangePaymentMutationFn = Apollo.MutationFunction<SubscriptionChangePaymentMutation, SubscriptionChangePaymentMutationVariables>;

/**
 * __useSubscriptionChangePaymentMutation__
 *
 * To run a mutation, you first call `useSubscriptionChangePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionChangePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionChangePaymentMutation, { data, loading, error }] = useSubscriptionChangePaymentMutation({
 *   variables: {
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionChangePaymentMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionChangePaymentMutation, SubscriptionChangePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriptionChangePaymentMutation, SubscriptionChangePaymentMutationVariables>(SubscriptionChangePaymentDocument, options);
      }
export type SubscriptionChangePaymentMutationHookResult = ReturnType<typeof useSubscriptionChangePaymentMutation>;
export type SubscriptionChangePaymentMutationResult = Apollo.MutationResult<SubscriptionChangePaymentMutation>;
export type SubscriptionChangePaymentMutationOptions = Apollo.BaseMutationOptions<SubscriptionChangePaymentMutation, SubscriptionChangePaymentMutationVariables>;
export const SubscriptionCheckCancelableDocument = gql`
    query SubscriptionCheckCancelable($subscriptionId: Int) {
  checkCancelable: subscriptionCheckCancelable(subscriptionId: $subscriptionId) {
    cancelable
    subscription {
      withdraw_at
    }
  }
}
    `;

/**
 * __useSubscriptionCheckCancelableQuery__
 *
 * To run a query within a React component, call `useSubscriptionCheckCancelableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCheckCancelableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCheckCancelableQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionCheckCancelableQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>(SubscriptionCheckCancelableDocument, options);
      }
export function useSubscriptionCheckCancelableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>(SubscriptionCheckCancelableDocument, options);
        }
// @ts-ignore
export function useSubscriptionCheckCancelableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>;
export function useSubscriptionCheckCancelableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionCheckCancelableQuery | undefined, SubscriptionCheckCancelableQueryVariables>;
export function useSubscriptionCheckCancelableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>(SubscriptionCheckCancelableDocument, options);
        }
export type SubscriptionCheckCancelableQueryHookResult = ReturnType<typeof useSubscriptionCheckCancelableQuery>;
export type SubscriptionCheckCancelableLazyQueryHookResult = ReturnType<typeof useSubscriptionCheckCancelableLazyQuery>;
export type SubscriptionCheckCancelableSuspenseQueryHookResult = ReturnType<typeof useSubscriptionCheckCancelableSuspenseQuery>;
export type SubscriptionCheckCancelableQueryResult = Apollo.QueryResult<SubscriptionCheckCancelableQuery, SubscriptionCheckCancelableQueryVariables>;
export const FormQuestionAnswerDocument = gql`
    mutation FormQuestionAnswer($values: String, $id: Int) {
  formQuestionAnswer(values: $values, id: $id) {
    answer_id
  }
}
    `;
export type FormQuestionAnswerMutationFn = Apollo.MutationFunction<FormQuestionAnswerMutation, FormQuestionAnswerMutationVariables>;

/**
 * __useFormQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useFormQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formQuestionAnswerMutation, { data, loading, error }] = useFormQuestionAnswerMutation({
 *   variables: {
 *      values: // value for 'values'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuestionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<FormQuestionAnswerMutation, FormQuestionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormQuestionAnswerMutation, FormQuestionAnswerMutationVariables>(FormQuestionAnswerDocument, options);
      }
export type FormQuestionAnswerMutationHookResult = ReturnType<typeof useFormQuestionAnswerMutation>;
export type FormQuestionAnswerMutationResult = Apollo.MutationResult<FormQuestionAnswerMutation>;
export type FormQuestionAnswerMutationOptions = Apollo.BaseMutationOptions<FormQuestionAnswerMutation, FormQuestionAnswerMutationVariables>;
export const SubscriptionStatusDocument = gql`
    query SubscriptionStatus($courseId: Int) {
  course: courseById(courseId: $courseId) {
    ... on Course {
      ...courseFields
    }
    channel {
      id
      name
    }
  }
  subscriptionStatus(courseId: $courseId) {
    is_contractable
    is_contracted
    have_be_contracted
    is_trial_enabled
    subscription {
      ...subscriptionFields
    }
  }
}
    ${CourseFieldsFragmentDoc}
${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatusQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useSubscriptionStatusQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
      }
export function useSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
        }
// @ts-ignore
export function useSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>;
export function useSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionStatusQuery | undefined, SubscriptionStatusQueryVariables>;
export function useSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>(SubscriptionStatusDocument, options);
        }
export type SubscriptionStatusQueryHookResult = ReturnType<typeof useSubscriptionStatusQuery>;
export type SubscriptionStatusLazyQueryHookResult = ReturnType<typeof useSubscriptionStatusLazyQuery>;
export type SubscriptionStatusSuspenseQueryHookResult = ReturnType<typeof useSubscriptionStatusSuspenseQuery>;
export type SubscriptionStatusQueryResult = Apollo.QueryResult<SubscriptionStatusQuery, SubscriptionStatusQueryVariables>;
export const UnSubscribedStatusDocument = gql`
    query UnSubscribedStatus($courseId: Int) {
  unSubscribedStatus(courseId: $courseId) {
    ...subscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useUnSubscribedStatusQuery__
 *
 * To run a query within a React component, call `useUnSubscribedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnSubscribedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnSubscribedStatusQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useUnSubscribedStatusQuery(baseOptions?: Apollo.QueryHookOptions<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>(UnSubscribedStatusDocument, options);
      }
export function useUnSubscribedStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>(UnSubscribedStatusDocument, options);
        }
// @ts-ignore
export function useUnSubscribedStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>): Apollo.UseSuspenseQueryResult<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>;
export function useUnSubscribedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>): Apollo.UseSuspenseQueryResult<UnSubscribedStatusQuery | undefined, UnSubscribedStatusQueryVariables>;
export function useUnSubscribedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>(UnSubscribedStatusDocument, options);
        }
export type UnSubscribedStatusQueryHookResult = ReturnType<typeof useUnSubscribedStatusQuery>;
export type UnSubscribedStatusLazyQueryHookResult = ReturnType<typeof useUnSubscribedStatusLazyQuery>;
export type UnSubscribedStatusSuspenseQueryHookResult = ReturnType<typeof useUnSubscribedStatusSuspenseQuery>;
export type UnSubscribedStatusQueryResult = Apollo.QueryResult<UnSubscribedStatusQuery, UnSubscribedStatusQueryVariables>;
export const SubscriptionEstimateDocument = gql`
    query SubscriptionEstimate($courseId: Int, $paymentMethodId: Int) {
  estimate: subscriptionEstimate(
    courseId: $courseId
    paymentMethodId: $paymentMethodId
  ) {
    ...estimateFields
  }
}
    ${EstimateFieldsFragmentDoc}`;

/**
 * __useSubscriptionEstimateQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSubscriptionEstimateQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>(SubscriptionEstimateDocument, options);
      }
export function useSubscriptionEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>(SubscriptionEstimateDocument, options);
        }
// @ts-ignore
export function useSubscriptionEstimateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>;
export function useSubscriptionEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionEstimateQuery | undefined, SubscriptionEstimateQueryVariables>;
export function useSubscriptionEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>(SubscriptionEstimateDocument, options);
        }
export type SubscriptionEstimateQueryHookResult = ReturnType<typeof useSubscriptionEstimateQuery>;
export type SubscriptionEstimateLazyQueryHookResult = ReturnType<typeof useSubscriptionEstimateLazyQuery>;
export type SubscriptionEstimateSuspenseQueryHookResult = ReturnType<typeof useSubscriptionEstimateSuspenseQuery>;
export type SubscriptionEstimateQueryResult = Apollo.QueryResult<SubscriptionEstimateQuery, SubscriptionEstimateQueryVariables>;
export const SubscriptionEstimateWithCouponDocument = gql`
    query SubscriptionEstimateWithCoupon($courseId: Int, $paymentMethodId: Int, $couponCode: String) {
  estimateWithCoupon: subscriptionEstimate(
    courseId: $courseId
    paymentMethodId: $paymentMethodId
    couponCode: $couponCode
  ) {
    ...estimateFields
  }
}
    ${EstimateFieldsFragmentDoc}`;

/**
 * __useSubscriptionEstimateWithCouponQuery__
 *
 * To run a query within a React component, call `useSubscriptionEstimateWithCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEstimateWithCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEstimateWithCouponQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useSubscriptionEstimateWithCouponQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>(SubscriptionEstimateWithCouponDocument, options);
      }
export function useSubscriptionEstimateWithCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>(SubscriptionEstimateWithCouponDocument, options);
        }
// @ts-ignore
export function useSubscriptionEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>;
export function useSubscriptionEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionEstimateWithCouponQuery | undefined, SubscriptionEstimateWithCouponQueryVariables>;
export function useSubscriptionEstimateWithCouponSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>(SubscriptionEstimateWithCouponDocument, options);
        }
export type SubscriptionEstimateWithCouponQueryHookResult = ReturnType<typeof useSubscriptionEstimateWithCouponQuery>;
export type SubscriptionEstimateWithCouponLazyQueryHookResult = ReturnType<typeof useSubscriptionEstimateWithCouponLazyQuery>;
export type SubscriptionEstimateWithCouponSuspenseQueryHookResult = ReturnType<typeof useSubscriptionEstimateWithCouponSuspenseQuery>;
export type SubscriptionEstimateWithCouponQueryResult = Apollo.QueryResult<SubscriptionEstimateWithCouponQuery, SubscriptionEstimateWithCouponQueryVariables>;
export const TermsDocument = gql`
    query Terms($keys: [String], $withAgreement: Boolean = false) {
  terms(keys: $keys, withAgreement: $withAgreement) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;

/**
 * __useTermsQuery__
 *
 * To run a query within a React component, call `useTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *      withAgreement: // value for 'withAgreement'
 *   },
 * });
 */
export function useTermsQuery(baseOptions?: Apollo.QueryHookOptions<TermsQuery, TermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsQuery, TermsQueryVariables>(TermsDocument, options);
      }
export function useTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsQuery, TermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsQuery, TermsQueryVariables>(TermsDocument, options);
        }
// @ts-ignore
export function useTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TermsQuery, TermsQueryVariables>): Apollo.UseSuspenseQueryResult<TermsQuery, TermsQueryVariables>;
export function useTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TermsQuery, TermsQueryVariables>): Apollo.UseSuspenseQueryResult<TermsQuery | undefined, TermsQueryVariables>;
export function useTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TermsQuery, TermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TermsQuery, TermsQueryVariables>(TermsDocument, options);
        }
export type TermsQueryHookResult = ReturnType<typeof useTermsQuery>;
export type TermsLazyQueryHookResult = ReturnType<typeof useTermsLazyQuery>;
export type TermsSuspenseQueryHookResult = ReturnType<typeof useTermsSuspenseQuery>;
export type TermsQueryResult = Apollo.QueryResult<TermsQuery, TermsQueryVariables>;
export const ValuePlanTermsDocument = gql`
    query ValuePlanTerms {
  terms(keys: ["valueplan_term"], withAgreement: true) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;

/**
 * __useValuePlanTermsQuery__
 *
 * To run a query within a React component, call `useValuePlanTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuePlanTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuePlanTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useValuePlanTermsQuery(baseOptions?: Apollo.QueryHookOptions<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>(ValuePlanTermsDocument, options);
      }
export function useValuePlanTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>(ValuePlanTermsDocument, options);
        }
// @ts-ignore
export function useValuePlanTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>): Apollo.UseSuspenseQueryResult<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>;
export function useValuePlanTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>): Apollo.UseSuspenseQueryResult<ValuePlanTermsQuery | undefined, ValuePlanTermsQueryVariables>;
export function useValuePlanTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>(ValuePlanTermsDocument, options);
        }
export type ValuePlanTermsQueryHookResult = ReturnType<typeof useValuePlanTermsQuery>;
export type ValuePlanTermsLazyQueryHookResult = ReturnType<typeof useValuePlanTermsLazyQuery>;
export type ValuePlanTermsSuspenseQueryHookResult = ReturnType<typeof useValuePlanTermsSuspenseQuery>;
export type ValuePlanTermsQueryResult = Apollo.QueryResult<ValuePlanTermsQuery, ValuePlanTermsQueryVariables>;
export const RegistTermsDocument = gql`
    query RegistTerms {
  required: registTerms(type: REQUIRED) {
    ...termsFields
  }
  optional: registTerms(type: OPTIONAL) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;

/**
 * __useRegistTermsQuery__
 *
 * To run a query within a React component, call `useRegistTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistTermsQuery(baseOptions?: Apollo.QueryHookOptions<RegistTermsQuery, RegistTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistTermsQuery, RegistTermsQueryVariables>(RegistTermsDocument, options);
      }
export function useRegistTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistTermsQuery, RegistTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistTermsQuery, RegistTermsQueryVariables>(RegistTermsDocument, options);
        }
// @ts-ignore
export function useRegistTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegistTermsQuery, RegistTermsQueryVariables>): Apollo.UseSuspenseQueryResult<RegistTermsQuery, RegistTermsQueryVariables>;
export function useRegistTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegistTermsQuery, RegistTermsQueryVariables>): Apollo.UseSuspenseQueryResult<RegistTermsQuery | undefined, RegistTermsQueryVariables>;
export function useRegistTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegistTermsQuery, RegistTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegistTermsQuery, RegistTermsQueryVariables>(RegistTermsDocument, options);
        }
export type RegistTermsQueryHookResult = ReturnType<typeof useRegistTermsQuery>;
export type RegistTermsLazyQueryHookResult = ReturnType<typeof useRegistTermsLazyQuery>;
export type RegistTermsSuspenseQueryHookResult = ReturnType<typeof useRegistTermsSuspenseQuery>;
export type RegistTermsQueryResult = Apollo.QueryResult<RegistTermsQuery, RegistTermsQueryVariables>;
export const LoginTermsDocument = gql`
    query LoginTerms($cacheMaxAge: Int) {
  required: loginTerms(type: REQUIRED, cacheMaxAge: $cacheMaxAge) {
    ...termsFields
  }
  optional: loginTerms(type: OPTIONAL, cacheMaxAge: $cacheMaxAge) {
    ...termsFields
  }
}
    ${TermsFieldsFragmentDoc}`;

/**
 * __useLoginTermsQuery__
 *
 * To run a query within a React component, call `useLoginTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginTermsQuery({
 *   variables: {
 *      cacheMaxAge: // value for 'cacheMaxAge'
 *   },
 * });
 */
export function useLoginTermsQuery(baseOptions?: Apollo.QueryHookOptions<LoginTermsQuery, LoginTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginTermsQuery, LoginTermsQueryVariables>(LoginTermsDocument, options);
      }
export function useLoginTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginTermsQuery, LoginTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginTermsQuery, LoginTermsQueryVariables>(LoginTermsDocument, options);
        }
// @ts-ignore
export function useLoginTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoginTermsQuery, LoginTermsQueryVariables>): Apollo.UseSuspenseQueryResult<LoginTermsQuery, LoginTermsQueryVariables>;
export function useLoginTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginTermsQuery, LoginTermsQueryVariables>): Apollo.UseSuspenseQueryResult<LoginTermsQuery | undefined, LoginTermsQueryVariables>;
export function useLoginTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginTermsQuery, LoginTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginTermsQuery, LoginTermsQueryVariables>(LoginTermsDocument, options);
        }
export type LoginTermsQueryHookResult = ReturnType<typeof useLoginTermsQuery>;
export type LoginTermsLazyQueryHookResult = ReturnType<typeof useLoginTermsLazyQuery>;
export type LoginTermsSuspenseQueryHookResult = ReturnType<typeof useLoginTermsSuspenseQuery>;
export type LoginTermsQueryResult = Apollo.QueryResult<LoginTermsQuery, LoginTermsQueryVariables>;
export const TermsAgreeDocument = gql`
    mutation TermsAgree($keys: [String]) {
  agree(keys: $keys) {
    unique_key
    number
    url
    agreement {
      agreement_id
      user_id
      term_id
      term_revision_number
    }
  }
}
    `;
export type TermsAgreeMutationFn = Apollo.MutationFunction<TermsAgreeMutation, TermsAgreeMutationVariables>;

/**
 * __useTermsAgreeMutation__
 *
 * To run a mutation, you first call `useTermsAgreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTermsAgreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [termsAgreeMutation, { data, loading, error }] = useTermsAgreeMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useTermsAgreeMutation(baseOptions?: Apollo.MutationHookOptions<TermsAgreeMutation, TermsAgreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TermsAgreeMutation, TermsAgreeMutationVariables>(TermsAgreeDocument, options);
      }
export type TermsAgreeMutationHookResult = ReturnType<typeof useTermsAgreeMutation>;
export type TermsAgreeMutationResult = Apollo.MutationResult<TermsAgreeMutation>;
export type TermsAgreeMutationOptions = Apollo.BaseMutationOptions<TermsAgreeMutation, TermsAgreeMutationVariables>;
export const TitleDocument = gql`
    query Title($id: Int, $withBookmark: Boolean = false, $withChildren: Boolean = false, $withCourse: Boolean = false) {
  title(id: $id) {
    ...tvShowMetaFields
    bookmark @include(if: $withBookmark) {
      meta_id
      bookmark_meta_id
      position
      bookmark_meta {
        ...episodeMetaFields
        ...liveMetaFields
      }
    }
    course @include(if: $withCourse) {
      ...courseFields
    }
  }
  children(id: $id, offset: 0, limit: 10) @include(if: $withChildren) {
    data {
      ...episodeMetaFields
      ...liveMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useTitleQuery__
 *
 * To run a query within a React component, call `useTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withBookmark: // value for 'withBookmark'
 *      withChildren: // value for 'withChildren'
 *      withCourse: // value for 'withCourse'
 *   },
 * });
 */
export function useTitleQuery(baseOptions?: Apollo.QueryHookOptions<TitleQuery, TitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitleQuery, TitleQueryVariables>(TitleDocument, options);
      }
export function useTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitleQuery, TitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitleQuery, TitleQueryVariables>(TitleDocument, options);
        }
// @ts-ignore
export function useTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TitleQuery, TitleQueryVariables>): Apollo.UseSuspenseQueryResult<TitleQuery, TitleQueryVariables>;
export function useTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TitleQuery, TitleQueryVariables>): Apollo.UseSuspenseQueryResult<TitleQuery | undefined, TitleQueryVariables>;
export function useTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TitleQuery, TitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TitleQuery, TitleQueryVariables>(TitleDocument, options);
        }
export type TitleQueryHookResult = ReturnType<typeof useTitleQuery>;
export type TitleLazyQueryHookResult = ReturnType<typeof useTitleLazyQuery>;
export type TitleSuspenseQueryHookResult = ReturnType<typeof useTitleSuspenseQuery>;
export type TitleQueryResult = Apollo.QueryResult<TitleQuery, TitleQueryVariables>;
export const TitlesDocument = gql`
    query Titles($filter: JSONObject, $sort: String, $offset: Int, $limit: Int) {
  titles(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    data {
      ...tvShowMetaFields
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${TvShowMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useTitlesQuery__
 *
 * To run a query within a React component, call `useTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTitlesQuery(baseOptions?: Apollo.QueryHookOptions<TitlesQuery, TitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TitlesQuery, TitlesQueryVariables>(TitlesDocument, options);
      }
export function useTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TitlesQuery, TitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TitlesQuery, TitlesQueryVariables>(TitlesDocument, options);
        }
// @ts-ignore
export function useTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TitlesQuery, TitlesQueryVariables>): Apollo.UseSuspenseQueryResult<TitlesQuery, TitlesQueryVariables>;
export function useTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TitlesQuery, TitlesQueryVariables>): Apollo.UseSuspenseQueryResult<TitlesQuery | undefined, TitlesQueryVariables>;
export function useTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TitlesQuery, TitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TitlesQuery, TitlesQueryVariables>(TitlesDocument, options);
        }
export type TitlesQueryHookResult = ReturnType<typeof useTitlesQuery>;
export type TitlesLazyQueryHookResult = ReturnType<typeof useTitlesLazyQuery>;
export type TitlesSuspenseQueryHookResult = ReturnType<typeof useTitlesSuspenseQuery>;
export type TitlesQueryResult = Apollo.QueryResult<TitlesQuery, TitlesQueryVariables>;
export const AuthLoginDocument = gql`
    mutation AuthLogin($loginid: String!, $password: String!, $signature: String!) {
  login(loginid: $loginid, password: $password, signature: $signature) {
    token
    error {
      code
    }
  }
}
    `;
export type AuthLoginMutationFn = Apollo.MutationFunction<AuthLoginMutation, AuthLoginMutationVariables>;

/**
 * __useAuthLoginMutation__
 *
 * To run a mutation, you first call `useAuthLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLoginMutation, { data, loading, error }] = useAuthLoginMutation({
 *   variables: {
 *      loginid: // value for 'loginid'
 *      password: // value for 'password'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAuthLoginMutation(baseOptions?: Apollo.MutationHookOptions<AuthLoginMutation, AuthLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLoginMutation, AuthLoginMutationVariables>(AuthLoginDocument, options);
      }
export type AuthLoginMutationHookResult = ReturnType<typeof useAuthLoginMutation>;
export type AuthLoginMutationResult = Apollo.MutationResult<AuthLoginMutation>;
export type AuthLoginMutationOptions = Apollo.BaseMutationOptions<AuthLoginMutation, AuthLoginMutationVariables>;
export const AuthUserDocument = gql`
    query AuthUser {
  user {
    ...accountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useAuthUserQuery__
 *
 * To run a query within a React component, call `useAuthUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthUserQuery(baseOptions?: Apollo.QueryHookOptions<AuthUserQuery, AuthUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserQuery, AuthUserQueryVariables>(AuthUserDocument, options);
      }
export function useAuthUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserQuery, AuthUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserQuery, AuthUserQueryVariables>(AuthUserDocument, options);
        }
// @ts-ignore
export function useAuthUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthUserQuery, AuthUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserQuery, AuthUserQueryVariables>;
export function useAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserQuery, AuthUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserQuery | undefined, AuthUserQueryVariables>;
export function useAuthUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserQuery, AuthUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthUserQuery, AuthUserQueryVariables>(AuthUserDocument, options);
        }
export type AuthUserQueryHookResult = ReturnType<typeof useAuthUserQuery>;
export type AuthUserLazyQueryHookResult = ReturnType<typeof useAuthUserLazyQuery>;
export type AuthUserSuspenseQueryHookResult = ReturnType<typeof useAuthUserSuspenseQuery>;
export type AuthUserQueryResult = Apollo.QueryResult<AuthUserQuery, AuthUserQueryVariables>;
export const AuthUserWithFavoritesDocument = gql`
    query AuthUserWithFavorites {
  user {
    ...accountFields
  }
  favorites: userFavorites {
    ...userFavoritesFields
  }
}
    ${AccountFieldsFragmentDoc}
${UserFavoritesFieldsFragmentDoc}`;

/**
 * __useAuthUserWithFavoritesQuery__
 *
 * To run a query within a React component, call `useAuthUserWithFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserWithFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserWithFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthUserWithFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>(AuthUserWithFavoritesDocument, options);
      }
export function useAuthUserWithFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>(AuthUserWithFavoritesDocument, options);
        }
// @ts-ignore
export function useAuthUserWithFavoritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>;
export function useAuthUserWithFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserWithFavoritesQuery | undefined, AuthUserWithFavoritesQueryVariables>;
export function useAuthUserWithFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>(AuthUserWithFavoritesDocument, options);
        }
export type AuthUserWithFavoritesQueryHookResult = ReturnType<typeof useAuthUserWithFavoritesQuery>;
export type AuthUserWithFavoritesLazyQueryHookResult = ReturnType<typeof useAuthUserWithFavoritesLazyQuery>;
export type AuthUserWithFavoritesSuspenseQueryHookResult = ReturnType<typeof useAuthUserWithFavoritesSuspenseQuery>;
export type AuthUserWithFavoritesQueryResult = Apollo.QueryResult<AuthUserWithFavoritesQuery, AuthUserWithFavoritesQueryVariables>;
export const AuthLogoutDocument = gql`
    mutation AuthLogout($force: Boolean = false) {
  logout(force: $force) {
    result
  }
}
    `;
export type AuthLogoutMutationFn = Apollo.MutationFunction<AuthLogoutMutation, AuthLogoutMutationVariables>;

/**
 * __useAuthLogoutMutation__
 *
 * To run a mutation, you first call `useAuthLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLogoutMutation, { data, loading, error }] = useAuthLogoutMutation({
 *   variables: {
 *      force: // value for 'force'
 *   },
 * });
 */
export function useAuthLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AuthLogoutMutation, AuthLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLogoutMutation, AuthLogoutMutationVariables>(AuthLogoutDocument, options);
      }
export type AuthLogoutMutationHookResult = ReturnType<typeof useAuthLogoutMutation>;
export type AuthLogoutMutationResult = Apollo.MutationResult<AuthLogoutMutation>;
export type AuthLogoutMutationOptions = Apollo.BaseMutationOptions<AuthLogoutMutation, AuthLogoutMutationVariables>;
export const AuthSelectProfileDocument = gql`
    mutation AuthSelectProfile($profileId: Int!, $passcode: String, $type: String) {
  selectProfile(profileId: $profileId, passcode: $passcode, type: $type) {
    ...accountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AuthSelectProfileMutationFn = Apollo.MutationFunction<AuthSelectProfileMutation, AuthSelectProfileMutationVariables>;

/**
 * __useAuthSelectProfileMutation__
 *
 * To run a mutation, you first call `useAuthSelectProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSelectProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSelectProfileMutation, { data, loading, error }] = useAuthSelectProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAuthSelectProfileMutation(baseOptions?: Apollo.MutationHookOptions<AuthSelectProfileMutation, AuthSelectProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSelectProfileMutation, AuthSelectProfileMutationVariables>(AuthSelectProfileDocument, options);
      }
export type AuthSelectProfileMutationHookResult = ReturnType<typeof useAuthSelectProfileMutation>;
export type AuthSelectProfileMutationResult = Apollo.MutationResult<AuthSelectProfileMutation>;
export type AuthSelectProfileMutationOptions = Apollo.BaseMutationOptions<AuthSelectProfileMutation, AuthSelectProfileMutationVariables>;
export const AuthProfileDocument = gql`
    mutation AuthProfile($profileId: Int, $passcode: String) {
  authProfile(profileId: $profileId, passcode: $passcode) {
    result
  }
}
    `;
export type AuthProfileMutationFn = Apollo.MutationFunction<AuthProfileMutation, AuthProfileMutationVariables>;

/**
 * __useAuthProfileMutation__
 *
 * To run a mutation, you first call `useAuthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authProfileMutation, { data, loading, error }] = useAuthProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAuthProfileMutation(baseOptions?: Apollo.MutationHookOptions<AuthProfileMutation, AuthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthProfileMutation, AuthProfileMutationVariables>(AuthProfileDocument, options);
      }
export type AuthProfileMutationHookResult = ReturnType<typeof useAuthProfileMutation>;
export type AuthProfileMutationResult = Apollo.MutationResult<AuthProfileMutation>;
export type AuthProfileMutationOptions = Apollo.BaseMutationOptions<AuthProfileMutation, AuthProfileMutationVariables>;
export const AccountSendProfilePinResetTokenDocument = gql`
    mutation AccountSendProfilePinResetToken {
  sendProfilePinResetToken {
    result
  }
}
    `;
export type AccountSendProfilePinResetTokenMutationFn = Apollo.MutationFunction<AccountSendProfilePinResetTokenMutation, AccountSendProfilePinResetTokenMutationVariables>;

/**
 * __useAccountSendProfilePinResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendProfilePinResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendProfilePinResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendProfilePinResetTokenMutation, { data, loading, error }] = useAccountSendProfilePinResetTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountSendProfilePinResetTokenMutation(baseOptions?: Apollo.MutationHookOptions<AccountSendProfilePinResetTokenMutation, AccountSendProfilePinResetTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountSendProfilePinResetTokenMutation, AccountSendProfilePinResetTokenMutationVariables>(AccountSendProfilePinResetTokenDocument, options);
      }
export type AccountSendProfilePinResetTokenMutationHookResult = ReturnType<typeof useAccountSendProfilePinResetTokenMutation>;
export type AccountSendProfilePinResetTokenMutationResult = Apollo.MutationResult<AccountSendProfilePinResetTokenMutation>;
export type AccountSendProfilePinResetTokenMutationOptions = Apollo.BaseMutationOptions<AccountSendProfilePinResetTokenMutation, AccountSendProfilePinResetTokenMutationVariables>;
export const AccountSendPasswordResetTokenDocument = gql`
    mutation AccountSendPasswordResetToken($mailAddress: String!) {
  sendPasswordResetToken(mailAddress: $mailAddress) {
    result
  }
}
    `;
export type AccountSendPasswordResetTokenMutationFn = Apollo.MutationFunction<AccountSendPasswordResetTokenMutation, AccountSendPasswordResetTokenMutationVariables>;

/**
 * __useAccountSendPasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useAccountSendPasswordResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPasswordResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPasswordResetTokenMutation, { data, loading, error }] = useAccountSendPasswordResetTokenMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountSendPasswordResetTokenMutation(baseOptions?: Apollo.MutationHookOptions<AccountSendPasswordResetTokenMutation, AccountSendPasswordResetTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountSendPasswordResetTokenMutation, AccountSendPasswordResetTokenMutationVariables>(AccountSendPasswordResetTokenDocument, options);
      }
export type AccountSendPasswordResetTokenMutationHookResult = ReturnType<typeof useAccountSendPasswordResetTokenMutation>;
export type AccountSendPasswordResetTokenMutationResult = Apollo.MutationResult<AccountSendPasswordResetTokenMutation>;
export type AccountSendPasswordResetTokenMutationOptions = Apollo.BaseMutationOptions<AccountSendPasswordResetTokenMutation, AccountSendPasswordResetTokenMutationVariables>;
export const AccountPasswordResetDocument = gql`
    mutation AccountPasswordReset($password: String!, $token: String!) {
  passwordReset(password: $password, token: $token) {
    result
  }
}
    `;
export type AccountPasswordResetMutationFn = Apollo.MutationFunction<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>;

/**
 * __useAccountPasswordResetMutation__
 *
 * To run a mutation, you first call `useAccountPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasswordResetMutation, { data, loading, error }] = useAccountPasswordResetMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>(AccountPasswordResetDocument, options);
      }
export type AccountPasswordResetMutationHookResult = ReturnType<typeof useAccountPasswordResetMutation>;
export type AccountPasswordResetMutationResult = Apollo.MutationResult<AccountPasswordResetMutation>;
export type AccountPasswordResetMutationOptions = Apollo.BaseMutationOptions<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>;
export const AccountPasscodeResetDocument = gql`
    mutation AccountPasscodeReset($passcode: String!, $token: String!) {
  passcodeReset(passcode: $passcode, token: $token) {
    result
  }
}
    `;
export type AccountPasscodeResetMutationFn = Apollo.MutationFunction<AccountPasscodeResetMutation, AccountPasscodeResetMutationVariables>;

/**
 * __useAccountPasscodeResetMutation__
 *
 * To run a mutation, you first call `useAccountPasscodeResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasscodeResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasscodeResetMutation, { data, loading, error }] = useAccountPasscodeResetMutation({
 *   variables: {
 *      passcode: // value for 'passcode'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountPasscodeResetMutation(baseOptions?: Apollo.MutationHookOptions<AccountPasscodeResetMutation, AccountPasscodeResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountPasscodeResetMutation, AccountPasscodeResetMutationVariables>(AccountPasscodeResetDocument, options);
      }
export type AccountPasscodeResetMutationHookResult = ReturnType<typeof useAccountPasscodeResetMutation>;
export type AccountPasscodeResetMutationResult = Apollo.MutationResult<AccountPasscodeResetMutation>;
export type AccountPasscodeResetMutationOptions = Apollo.BaseMutationOptions<AccountPasscodeResetMutation, AccountPasscodeResetMutationVariables>;
export const AccountVerifyPinCodeDocument = gql`
    mutation AccountVerifyPinCode($code: String!, $mailAddress: String!) {
  verifyPinCode(code: $code, mailAddress: $mailAddress) {
    verified
    error
  }
}
    `;
export type AccountVerifyPinCodeMutationFn = Apollo.MutationFunction<AccountVerifyPinCodeMutation, AccountVerifyPinCodeMutationVariables>;

/**
 * __useAccountVerifyPinCodeMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPinCodeMutation, { data, loading, error }] = useAccountVerifyPinCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *   },
 * });
 */
export function useAccountVerifyPinCodeMutation(baseOptions?: Apollo.MutationHookOptions<AccountVerifyPinCodeMutation, AccountVerifyPinCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountVerifyPinCodeMutation, AccountVerifyPinCodeMutationVariables>(AccountVerifyPinCodeDocument, options);
      }
export type AccountVerifyPinCodeMutationHookResult = ReturnType<typeof useAccountVerifyPinCodeMutation>;
export type AccountVerifyPinCodeMutationResult = Apollo.MutationResult<AccountVerifyPinCodeMutation>;
export type AccountVerifyPinCodeMutationOptions = Apollo.BaseMutationOptions<AccountVerifyPinCodeMutation, AccountVerifyPinCodeMutationVariables>;
export const AccountVerifyPasswordTokenDocument = gql`
    mutation AccountVerifyPasswordToken($token: String!) {
  verifyPasswordToken(token: $token) {
    verified
    error
  }
}
    `;
export type AccountVerifyPasswordTokenMutationFn = Apollo.MutationFunction<AccountVerifyPasswordTokenMutation, AccountVerifyPasswordTokenMutationVariables>;

/**
 * __useAccountVerifyPasswordTokenMutation__
 *
 * To run a mutation, you first call `useAccountVerifyPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyPasswordTokenMutation, { data, loading, error }] = useAccountVerifyPasswordTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountVerifyPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<AccountVerifyPasswordTokenMutation, AccountVerifyPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountVerifyPasswordTokenMutation, AccountVerifyPasswordTokenMutationVariables>(AccountVerifyPasswordTokenDocument, options);
      }
export type AccountVerifyPasswordTokenMutationHookResult = ReturnType<typeof useAccountVerifyPasswordTokenMutation>;
export type AccountVerifyPasswordTokenMutationResult = Apollo.MutationResult<AccountVerifyPasswordTokenMutation>;
export type AccountVerifyPasswordTokenMutationOptions = Apollo.BaseMutationOptions<AccountVerifyPasswordTokenMutation, AccountVerifyPasswordTokenMutationVariables>;
export const AccountSignupDocument = gql`
    mutation AccountSignup($code: String!, $mailAddress: String!, $password: String!, $firstName: String!, $lastName: String!, $birthday: String!, $sex: String!, $terms: String!, $signature: String!) {
  signup(
    code: $code
    mailAddress: $mailAddress
    password: $password
    firstName: $firstName
    lastName: $lastName
    birthday: $birthday
    sex: $sex
    terms: $terms
    signature: $signature
  ) {
    token
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountSignupMutationFn = Apollo.MutationFunction<AccountSignupMutation, AccountSignupMutationVariables>;

/**
 * __useAccountSignupMutation__
 *
 * To run a mutation, you first call `useAccountSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSignupMutation, { data, loading, error }] = useAccountSignupMutation({
 *   variables: {
 *      code: // value for 'code'
 *      mailAddress: // value for 'mailAddress'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAccountSignupMutation(baseOptions?: Apollo.MutationHookOptions<AccountSignupMutation, AccountSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountSignupMutation, AccountSignupMutationVariables>(AccountSignupDocument, options);
      }
export type AccountSignupMutationHookResult = ReturnType<typeof useAccountSignupMutation>;
export type AccountSignupMutationResult = Apollo.MutationResult<AccountSignupMutation>;
export type AccountSignupMutationOptions = Apollo.BaseMutationOptions<AccountSignupMutation, AccountSignupMutationVariables>;
export const AddFavoriteDocument = gql`
    mutation AddFavorite($id: Int!) {
  addFavorite(id: $id) {
    result
    favorites {
      ...userFavoritesFields
    }
  }
}
    ${UserFavoritesFieldsFragmentDoc}`;
export type AddFavoriteMutationFn = Apollo.MutationFunction<AddFavoriteMutation, AddFavoriteMutationVariables>;

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteMutation, AddFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteMutation, AddFavoriteMutationVariables>(AddFavoriteDocument, options);
      }
export type AddFavoriteMutationHookResult = ReturnType<typeof useAddFavoriteMutation>;
export type AddFavoriteMutationResult = Apollo.MutationResult<AddFavoriteMutation>;
export type AddFavoriteMutationOptions = Apollo.BaseMutationOptions<AddFavoriteMutation, AddFavoriteMutationVariables>;
export const DeleteFavoriteDocument = gql`
    mutation DeleteFavorite($id: Int!) {
  deleteFavorite(id: $id) {
    result
    favorites {
      ...userFavoritesFields
    }
  }
}
    ${UserFavoritesFieldsFragmentDoc}`;
export type DeleteFavoriteMutationFn = Apollo.MutationFunction<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;

/**
 * __useDeleteFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteMutation, { data, loading, error }] = useDeleteFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>(DeleteFavoriteDocument, options);
      }
export type DeleteFavoriteMutationHookResult = ReturnType<typeof useDeleteFavoriteMutation>;
export type DeleteFavoriteMutationResult = Apollo.MutationResult<DeleteFavoriteMutation>;
export type DeleteFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;
export const FavoritesByContentTypeDocument = gql`
    query FavoritesByContentType($type: String, $offset: Int, $limit: Int) {
  favorites: favoritesByContentType(type: $type, offset: $offset, limit: $limit) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
      }
      ... on LiveMeta {
        ...liveMetaFields
      }
      ... on TVShowMeta {
        ...tvShowMetaFields
      }
      ... on ChannelMeta {
        ...channelMetaFields
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${TvShowMetaFieldsFragmentDoc}
${ChannelMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useFavoritesByContentTypeQuery__
 *
 * To run a query within a React component, call `useFavoritesByContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesByContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesByContentTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFavoritesByContentTypeQuery(baseOptions?: Apollo.QueryHookOptions<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>(FavoritesByContentTypeDocument, options);
      }
export function useFavoritesByContentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>(FavoritesByContentTypeDocument, options);
        }
// @ts-ignore
export function useFavoritesByContentTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>;
export function useFavoritesByContentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<FavoritesByContentTypeQuery | undefined, FavoritesByContentTypeQueryVariables>;
export function useFavoritesByContentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>(FavoritesByContentTypeDocument, options);
        }
export type FavoritesByContentTypeQueryHookResult = ReturnType<typeof useFavoritesByContentTypeQuery>;
export type FavoritesByContentTypeLazyQueryHookResult = ReturnType<typeof useFavoritesByContentTypeLazyQuery>;
export type FavoritesByContentTypeSuspenseQueryHookResult = ReturnType<typeof useFavoritesByContentTypeSuspenseQuery>;
export type FavoritesByContentTypeQueryResult = Apollo.QueryResult<FavoritesByContentTypeQuery, FavoritesByContentTypeQueryVariables>;
export const ViewingHistoriesDocument = gql`
    query ViewingHistories($offset: Int, $limit: Int, $sort: String, $nocache: Boolean = false) {
  viewingHistories(offset: $offset, limit: $limit, sort: $sort, nocache: $nocache) {
    data {
      ... on EpisodeMeta {
        ...episodeMetaFields
        resume_point
        last_viewing_at
      }
      ... on LiveMeta {
        ...liveMetaFields
        resume_point
        last_viewing_at
      }
    }
    pageInfo {
      ...pageInfoFields
    }
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${PageInfoFieldsFragmentDoc}`;

/**
 * __useViewingHistoriesQuery__
 *
 * To run a query within a React component, call `useViewingHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewingHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewingHistoriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      nocache: // value for 'nocache'
 *   },
 * });
 */
export function useViewingHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>(ViewingHistoriesDocument, options);
      }
export function useViewingHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>(ViewingHistoriesDocument, options);
        }
// @ts-ignore
export function useViewingHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>;
export function useViewingHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewingHistoriesQuery | undefined, ViewingHistoriesQueryVariables>;
export function useViewingHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>(ViewingHistoriesDocument, options);
        }
export type ViewingHistoriesQueryHookResult = ReturnType<typeof useViewingHistoriesQuery>;
export type ViewingHistoriesLazyQueryHookResult = ReturnType<typeof useViewingHistoriesLazyQuery>;
export type ViewingHistoriesSuspenseQueryHookResult = ReturnType<typeof useViewingHistoriesSuspenseQuery>;
export type ViewingHistoriesQueryResult = Apollo.QueryResult<ViewingHistoriesQuery, ViewingHistoriesQueryVariables>;
export const DeleteViewingHistoryDocument = gql`
    mutation DeleteViewingHistory($metaIds: [String]) {
  deleteViewingHistory(metaIds: $metaIds) {
    result
  }
}
    `;
export type DeleteViewingHistoryMutationFn = Apollo.MutationFunction<DeleteViewingHistoryMutation, DeleteViewingHistoryMutationVariables>;

/**
 * __useDeleteViewingHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteViewingHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewingHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewingHistoryMutation, { data, loading, error }] = useDeleteViewingHistoryMutation({
 *   variables: {
 *      metaIds: // value for 'metaIds'
 *   },
 * });
 */
export function useDeleteViewingHistoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteViewingHistoryMutation, DeleteViewingHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteViewingHistoryMutation, DeleteViewingHistoryMutationVariables>(DeleteViewingHistoryDocument, options);
      }
export type DeleteViewingHistoryMutationHookResult = ReturnType<typeof useDeleteViewingHistoryMutation>;
export type DeleteViewingHistoryMutationResult = Apollo.MutationResult<DeleteViewingHistoryMutation>;
export type DeleteViewingHistoryMutationOptions = Apollo.BaseMutationOptions<DeleteViewingHistoryMutation, DeleteViewingHistoryMutationVariables>;
export const AddResumeDocument = gql`
    mutation AddResume($resume: Int, $metaId: Int, $groupedMetaId: Int, $psid: String, $reachToEnd: Boolean) {
  addResume(
    resume: $resume
    metaId: $metaId
    groupedMetaId: $groupedMetaId
    psid: $psid
    reachToEnd: $reachToEnd
  ) {
    result
  }
}
    `;
export type AddResumeMutationFn = Apollo.MutationFunction<AddResumeMutation, AddResumeMutationVariables>;

/**
 * __useAddResumeMutation__
 *
 * To run a mutation, you first call `useAddResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeMutation, { data, loading, error }] = useAddResumeMutation({
 *   variables: {
 *      resume: // value for 'resume'
 *      metaId: // value for 'metaId'
 *      groupedMetaId: // value for 'groupedMetaId'
 *      psid: // value for 'psid'
 *      reachToEnd: // value for 'reachToEnd'
 *   },
 * });
 */
export function useAddResumeMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeMutation, AddResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeMutation, AddResumeMutationVariables>(AddResumeDocument, options);
      }
export type AddResumeMutationHookResult = ReturnType<typeof useAddResumeMutation>;
export type AddResumeMutationResult = Apollo.MutationResult<AddResumeMutation>;
export type AddResumeMutationOptions = Apollo.BaseMutationOptions<AddResumeMutation, AddResumeMutationVariables>;
export const AccountUpdateDocument = gql`
    mutation AccountUpdate($mailAddress: String, $code: String) {
  update(mailAddress: $mailAddress, code: $code) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUpdateMutationFn = Apollo.MutationFunction<AccountUpdateMutation, AccountUpdateMutationVariables>;

/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      mailAddress: // value for 'mailAddress'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateMutation, AccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateMutation, AccountUpdateMutationVariables>(AccountUpdateDocument, options);
      }
export type AccountUpdateMutationHookResult = ReturnType<typeof useAccountUpdateMutation>;
export type AccountUpdateMutationResult = Apollo.MutationResult<AccountUpdateMutation>;
export type AccountUpdateMutationOptions = Apollo.BaseMutationOptions<AccountUpdateMutation, AccountUpdateMutationVariables>;
export const AccountUpdatePasswordDocument = gql`
    mutation AccountUpdatePassword($currentPassword: String, $password: String) {
  updatePassword(currentPassword: $currentPassword, password: $password) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUpdatePasswordMutationFn = Apollo.MutationFunction<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>;

/**
 * __useAccountUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAccountUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdatePasswordMutation, { data, loading, error }] = useAccountUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAccountUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>(AccountUpdatePasswordDocument, options);
      }
export type AccountUpdatePasswordMutationHookResult = ReturnType<typeof useAccountUpdatePasswordMutation>;
export type AccountUpdatePasswordMutationResult = Apollo.MutationResult<AccountUpdatePasswordMutation>;
export type AccountUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>;
export const AccountUpdateOwnerProfileDocument = gql`
    mutation AccountUpdateOwnerProfile($displayName: String, $icon: Int, $passcode: String, $rating: Int) {
  updateOwnerProfile(
    displayName: $displayName
    icon: $icon
    passcode: $passcode
    rating: $rating
  ) {
    user {
      ...accountFields
    }
    error
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountUpdateOwnerProfileMutationFn = Apollo.MutationFunction<AccountUpdateOwnerProfileMutation, AccountUpdateOwnerProfileMutationVariables>;

/**
 * __useAccountUpdateOwnerProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateOwnerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateOwnerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateOwnerProfileMutation, { data, loading, error }] = useAccountUpdateOwnerProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      icon: // value for 'icon'
 *      passcode: // value for 'passcode'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useAccountUpdateOwnerProfileMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateOwnerProfileMutation, AccountUpdateOwnerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateOwnerProfileMutation, AccountUpdateOwnerProfileMutationVariables>(AccountUpdateOwnerProfileDocument, options);
      }
export type AccountUpdateOwnerProfileMutationHookResult = ReturnType<typeof useAccountUpdateOwnerProfileMutation>;
export type AccountUpdateOwnerProfileMutationResult = Apollo.MutationResult<AccountUpdateOwnerProfileMutation>;
export type AccountUpdateOwnerProfileMutationOptions = Apollo.BaseMutationOptions<AccountUpdateOwnerProfileMutation, AccountUpdateOwnerProfileMutationVariables>;
export const AccountAddProfileDocument = gql`
    mutation AccountAddProfile($displayName: String, $birthday: String, $sex: String, $icon: Int, $rating: Int, $passcode: String) {
  addProfile(
    displayName: $displayName
    birthday: $birthday
    sex: $sex
    icon: $icon
    rating: $rating
    passcode: $passcode
  ) {
    profile {
      ...profileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;
export type AccountAddProfileMutationFn = Apollo.MutationFunction<AccountAddProfileMutation, AccountAddProfileMutationVariables>;

/**
 * __useAccountAddProfileMutation__
 *
 * To run a mutation, you first call `useAccountAddProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddProfileMutation, { data, loading, error }] = useAccountAddProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAccountAddProfileMutation(baseOptions?: Apollo.MutationHookOptions<AccountAddProfileMutation, AccountAddProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountAddProfileMutation, AccountAddProfileMutationVariables>(AccountAddProfileDocument, options);
      }
export type AccountAddProfileMutationHookResult = ReturnType<typeof useAccountAddProfileMutation>;
export type AccountAddProfileMutationResult = Apollo.MutationResult<AccountAddProfileMutation>;
export type AccountAddProfileMutationOptions = Apollo.BaseMutationOptions<AccountAddProfileMutation, AccountAddProfileMutationVariables>;
export const AccountUpdateProfileDocument = gql`
    mutation AccountUpdateProfile($displayName: String, $birthday: String, $sex: String, $password: String, $profileId: Int, $icon: Int, $rating: Int, $passcode: String) {
  updateProfile(
    displayName: $displayName
    birthday: $birthday
    sex: $sex
    password: $password
    profileId: $profileId
    icon: $icon
    rating: $rating
    passcode: $passcode
  ) {
    profile {
      ...profileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;
export type AccountUpdateProfileMutationFn = Apollo.MutationFunction<AccountUpdateProfileMutation, AccountUpdateProfileMutationVariables>;

/**
 * __useAccountUpdateProfileMutation__
 *
 * To run a mutation, you first call `useAccountUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateProfileMutation, { data, loading, error }] = useAccountUpdateProfileMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      birthday: // value for 'birthday'
 *      sex: // value for 'sex'
 *      password: // value for 'password'
 *      profileId: // value for 'profileId'
 *      icon: // value for 'icon'
 *      rating: // value for 'rating'
 *      passcode: // value for 'passcode'
 *   },
 * });
 */
export function useAccountUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateProfileMutation, AccountUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateProfileMutation, AccountUpdateProfileMutationVariables>(AccountUpdateProfileDocument, options);
      }
export type AccountUpdateProfileMutationHookResult = ReturnType<typeof useAccountUpdateProfileMutation>;
export type AccountUpdateProfileMutationResult = Apollo.MutationResult<AccountUpdateProfileMutation>;
export type AccountUpdateProfileMutationOptions = Apollo.BaseMutationOptions<AccountUpdateProfileMutation, AccountUpdateProfileMutationVariables>;
export const AccountDeleteProfileDocument = gql`
    mutation AccountDeleteProfile($profileId: Int) {
  deleteProfile(profileId: $profileId) {
    result
  }
}
    `;
export type AccountDeleteProfileMutationFn = Apollo.MutationFunction<AccountDeleteProfileMutation, AccountDeleteProfileMutationVariables>;

/**
 * __useAccountDeleteProfileMutation__
 *
 * To run a mutation, you first call `useAccountDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeleteProfileMutation, { data, loading, error }] = useAccountDeleteProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useAccountDeleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<AccountDeleteProfileMutation, AccountDeleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountDeleteProfileMutation, AccountDeleteProfileMutationVariables>(AccountDeleteProfileDocument, options);
      }
export type AccountDeleteProfileMutationHookResult = ReturnType<typeof useAccountDeleteProfileMutation>;
export type AccountDeleteProfileMutationResult = Apollo.MutationResult<AccountDeleteProfileMutation>;
export type AccountDeleteProfileMutationOptions = Apollo.BaseMutationOptions<AccountDeleteProfileMutation, AccountDeleteProfileMutationVariables>;
export const AccountUserDeleteDocument = gql`
    mutation AccountUserDelete {
  userDelete {
    result
  }
}
    `;
export type AccountUserDeleteMutationFn = Apollo.MutationFunction<AccountUserDeleteMutation, AccountUserDeleteMutationVariables>;

/**
 * __useAccountUserDeleteMutation__
 *
 * To run a mutation, you first call `useAccountUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUserDeleteMutation, { data, loading, error }] = useAccountUserDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AccountUserDeleteMutation, AccountUserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUserDeleteMutation, AccountUserDeleteMutationVariables>(AccountUserDeleteDocument, options);
      }
export type AccountUserDeleteMutationHookResult = ReturnType<typeof useAccountUserDeleteMutation>;
export type AccountUserDeleteMutationResult = Apollo.MutationResult<AccountUserDeleteMutation>;
export type AccountUserDeleteMutationOptions = Apollo.BaseMutationOptions<AccountUserDeleteMutation, AccountUserDeleteMutationVariables>;
export const UserEntitlementsDocument = gql`
    query UserEntitlements {
  entitlements: userEntitlements {
    ...entitlementFields
  }
}
    ${EntitlementFieldsFragmentDoc}`;

/**
 * __useUserEntitlementsQuery__
 *
 * To run a query within a React component, call `useUserEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEntitlementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEntitlementsQuery(baseOptions?: Apollo.QueryHookOptions<UserEntitlementsQuery, UserEntitlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEntitlementsQuery, UserEntitlementsQueryVariables>(UserEntitlementsDocument, options);
      }
export function useUserEntitlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEntitlementsQuery, UserEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEntitlementsQuery, UserEntitlementsQueryVariables>(UserEntitlementsDocument, options);
        }
// @ts-ignore
export function useUserEntitlementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserEntitlementsQuery, UserEntitlementsQueryVariables>): Apollo.UseSuspenseQueryResult<UserEntitlementsQuery, UserEntitlementsQueryVariables>;
export function useUserEntitlementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserEntitlementsQuery, UserEntitlementsQueryVariables>): Apollo.UseSuspenseQueryResult<UserEntitlementsQuery | undefined, UserEntitlementsQueryVariables>;
export function useUserEntitlementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserEntitlementsQuery, UserEntitlementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserEntitlementsQuery, UserEntitlementsQueryVariables>(UserEntitlementsDocument, options);
        }
export type UserEntitlementsQueryHookResult = ReturnType<typeof useUserEntitlementsQuery>;
export type UserEntitlementsLazyQueryHookResult = ReturnType<typeof useUserEntitlementsLazyQuery>;
export type UserEntitlementsSuspenseQueryHookResult = ReturnType<typeof useUserEntitlementsSuspenseQuery>;
export type UserEntitlementsQueryResult = Apollo.QueryResult<UserEntitlementsQuery, UserEntitlementsQueryVariables>;
export const AccountAdvertisingPreferencesDocument = gql`
    mutation AccountAdvertisingPreferences($receiveAdvertisingMailFlag: Boolean) {
  advertisingPreferences(receiveAdvertisingMailFlag: $receiveAdvertisingMailFlag) {
    request_id
  }
}
    `;
export type AccountAdvertisingPreferencesMutationFn = Apollo.MutationFunction<AccountAdvertisingPreferencesMutation, AccountAdvertisingPreferencesMutationVariables>;

/**
 * __useAccountAdvertisingPreferencesMutation__
 *
 * To run a mutation, you first call `useAccountAdvertisingPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAdvertisingPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAdvertisingPreferencesMutation, { data, loading, error }] = useAccountAdvertisingPreferencesMutation({
 *   variables: {
 *      receiveAdvertisingMailFlag: // value for 'receiveAdvertisingMailFlag'
 *   },
 * });
 */
export function useAccountAdvertisingPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<AccountAdvertisingPreferencesMutation, AccountAdvertisingPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountAdvertisingPreferencesMutation, AccountAdvertisingPreferencesMutationVariables>(AccountAdvertisingPreferencesDocument, options);
      }
export type AccountAdvertisingPreferencesMutationHookResult = ReturnType<typeof useAccountAdvertisingPreferencesMutation>;
export type AccountAdvertisingPreferencesMutationResult = Apollo.MutationResult<AccountAdvertisingPreferencesMutation>;
export type AccountAdvertisingPreferencesMutationOptions = Apollo.BaseMutationOptions<AccountAdvertisingPreferencesMutation, AccountAdvertisingPreferencesMutationVariables>;
export const CheckTokenTimeoutDocument = gql`
    query CheckTokenTimeout {
  checkTokenTimeout {
    result
  }
}
    `;

/**
 * __useCheckTokenTimeoutQuery__
 *
 * To run a query within a React component, call `useCheckTokenTimeoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTokenTimeoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTokenTimeoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckTokenTimeoutQuery(baseOptions?: Apollo.QueryHookOptions<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>(CheckTokenTimeoutDocument, options);
      }
export function useCheckTokenTimeoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>(CheckTokenTimeoutDocument, options);
        }
// @ts-ignore
export function useCheckTokenTimeoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>;
export function useCheckTokenTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<CheckTokenTimeoutQuery | undefined, CheckTokenTimeoutQueryVariables>;
export function useCheckTokenTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>(CheckTokenTimeoutDocument, options);
        }
export type CheckTokenTimeoutQueryHookResult = ReturnType<typeof useCheckTokenTimeoutQuery>;
export type CheckTokenTimeoutLazyQueryHookResult = ReturnType<typeof useCheckTokenTimeoutLazyQuery>;
export type CheckTokenTimeoutSuspenseQueryHookResult = ReturnType<typeof useCheckTokenTimeoutSuspenseQuery>;
export type CheckTokenTimeoutQueryResult = Apollo.QueryResult<CheckTokenTimeoutQuery, CheckTokenTimeoutQueryVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken {
    result
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const IdcTokenLoginDocument = gql`
    mutation IdcTokenLogin($signature: String!) {
  idcTokenLogin(signature: $signature) {
    token
    user {
      ...accountFields
    }
    error {
      code
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type IdcTokenLoginMutationFn = Apollo.MutationFunction<IdcTokenLoginMutation, IdcTokenLoginMutationVariables>;

/**
 * __useIdcTokenLoginMutation__
 *
 * To run a mutation, you first call `useIdcTokenLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdcTokenLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idcTokenLoginMutation, { data, loading, error }] = useIdcTokenLoginMutation({
 *   variables: {
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useIdcTokenLoginMutation(baseOptions?: Apollo.MutationHookOptions<IdcTokenLoginMutation, IdcTokenLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdcTokenLoginMutation, IdcTokenLoginMutationVariables>(IdcTokenLoginDocument, options);
      }
export type IdcTokenLoginMutationHookResult = ReturnType<typeof useIdcTokenLoginMutation>;
export type IdcTokenLoginMutationResult = Apollo.MutationResult<IdcTokenLoginMutation>;
export type IdcTokenLoginMutationOptions = Apollo.BaseMutationOptions<IdcTokenLoginMutation, IdcTokenLoginMutationVariables>;
export const AccountIdcTokenSignupDocument = gql`
    mutation AccountIdcTokenSignup($password: String!, $terms: String!, $signature: String!) {
  idcTokenSignup(password: $password, terms: $terms, signature: $signature) {
    token
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type AccountIdcTokenSignupMutationFn = Apollo.MutationFunction<AccountIdcTokenSignupMutation, AccountIdcTokenSignupMutationVariables>;

/**
 * __useAccountIdcTokenSignupMutation__
 *
 * To run a mutation, you first call `useAccountIdcTokenSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountIdcTokenSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountIdcTokenSignupMutation, { data, loading, error }] = useAccountIdcTokenSignupMutation({
 *   variables: {
 *      password: // value for 'password'
 *      terms: // value for 'terms'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAccountIdcTokenSignupMutation(baseOptions?: Apollo.MutationHookOptions<AccountIdcTokenSignupMutation, AccountIdcTokenSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountIdcTokenSignupMutation, AccountIdcTokenSignupMutationVariables>(AccountIdcTokenSignupDocument, options);
      }
export type AccountIdcTokenSignupMutationHookResult = ReturnType<typeof useAccountIdcTokenSignupMutation>;
export type AccountIdcTokenSignupMutationResult = Apollo.MutationResult<AccountIdcTokenSignupMutation>;
export type AccountIdcTokenSignupMutationOptions = Apollo.BaseMutationOptions<AccountIdcTokenSignupMutation, AccountIdcTokenSignupMutationVariables>;
export const SpooxIdIdcTokenMappingDocument = gql`
    mutation SpooxIdIdcTokenMapping($signature: String!) {
  idcTokenMapping(signature: $signature) {
    user {
      ...accountFields
    }
  }
}
    ${AccountFieldsFragmentDoc}`;
export type SpooxIdIdcTokenMappingMutationFn = Apollo.MutationFunction<SpooxIdIdcTokenMappingMutation, SpooxIdIdcTokenMappingMutationVariables>;

/**
 * __useSpooxIdIdcTokenMappingMutation__
 *
 * To run a mutation, you first call `useSpooxIdIdcTokenMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpooxIdIdcTokenMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spooxIdIdcTokenMappingMutation, { data, loading, error }] = useSpooxIdIdcTokenMappingMutation({
 *   variables: {
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSpooxIdIdcTokenMappingMutation(baseOptions?: Apollo.MutationHookOptions<SpooxIdIdcTokenMappingMutation, SpooxIdIdcTokenMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpooxIdIdcTokenMappingMutation, SpooxIdIdcTokenMappingMutationVariables>(SpooxIdIdcTokenMappingDocument, options);
      }
export type SpooxIdIdcTokenMappingMutationHookResult = ReturnType<typeof useSpooxIdIdcTokenMappingMutation>;
export type SpooxIdIdcTokenMappingMutationResult = Apollo.MutationResult<SpooxIdIdcTokenMappingMutation>;
export type SpooxIdIdcTokenMappingMutationOptions = Apollo.BaseMutationOptions<SpooxIdIdcTokenMappingMutation, SpooxIdIdcTokenMappingMutationVariables>;
export const WatchDocument = gql`
    query Watch($id: Int) {
  episode(id: $id) {
    ...episodeMetaFields
    ...liveMetaFields
  }
  nextEpisode(id: $id) {
    ...episodeMetaFields
    ...liveMetaFields
  }
  howtoPlay(id: $id) {
    free
    member_only
    rights {
      ...rightFields
    }
    courses {
      ...courseFields
    }
    products {
      ...productFields
    }
  }
  entitlements(metaId: $id) {
    ...entitlementFields
  }
  uid2Token {
    token
  }
}
    ${EpisodeMetaFieldsFragmentDoc}
${LiveMetaFieldsFragmentDoc}
${RightFieldsFragmentDoc}
${CourseFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${EntitlementFieldsFragmentDoc}`;

/**
 * __useWatchQuery__
 *
 * To run a query within a React component, call `useWatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWatchQuery(baseOptions?: Apollo.QueryHookOptions<WatchQuery, WatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchQuery, WatchQueryVariables>(WatchDocument, options);
      }
export function useWatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchQuery, WatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchQuery, WatchQueryVariables>(WatchDocument, options);
        }
// @ts-ignore
export function useWatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WatchQuery, WatchQueryVariables>): Apollo.UseSuspenseQueryResult<WatchQuery, WatchQueryVariables>;
export function useWatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchQuery, WatchQueryVariables>): Apollo.UseSuspenseQueryResult<WatchQuery | undefined, WatchQueryVariables>;
export function useWatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchQuery, WatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchQuery, WatchQueryVariables>(WatchDocument, options);
        }
export type WatchQueryHookResult = ReturnType<typeof useWatchQuery>;
export type WatchLazyQueryHookResult = ReturnType<typeof useWatchLazyQuery>;
export type WatchSuspenseQueryHookResult = ReturnType<typeof useWatchSuspenseQuery>;
export type WatchQueryResult = Apollo.QueryResult<WatchQuery, WatchQueryVariables>;
export const WebPageDocument = gql`
    query WebPage($path: String) {
  webPage(path: $path) {
    id
    content
    style
    script
    metatags {
      robots
      canonicalUrl
      title
      keywords
      description
    }
  }
}
    `;

/**
 * __useWebPageQuery__
 *
 * To run a query within a React component, call `useWebPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebPageQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useWebPageQuery(baseOptions?: Apollo.QueryHookOptions<WebPageQuery, WebPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebPageQuery, WebPageQueryVariables>(WebPageDocument, options);
      }
export function useWebPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebPageQuery, WebPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebPageQuery, WebPageQueryVariables>(WebPageDocument, options);
        }
// @ts-ignore
export function useWebPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebPageQuery, WebPageQueryVariables>): Apollo.UseSuspenseQueryResult<WebPageQuery, WebPageQueryVariables>;
export function useWebPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebPageQuery, WebPageQueryVariables>): Apollo.UseSuspenseQueryResult<WebPageQuery | undefined, WebPageQueryVariables>;
export function useWebPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebPageQuery, WebPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebPageQuery, WebPageQueryVariables>(WebPageDocument, options);
        }
export type WebPageQueryHookResult = ReturnType<typeof useWebPageQuery>;
export type WebPageLazyQueryHookResult = ReturnType<typeof useWebPageLazyQuery>;
export type WebPageSuspenseQueryHookResult = ReturnType<typeof useWebPageSuspenseQuery>;
export type WebPageQueryResult = Apollo.QueryResult<WebPageQuery, WebPageQueryVariables>;